// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/await-thenable, @typescript-eslint/no-floating-promises, @typescript-eslint/no-unused-expressions, @typescript-eslint/require-await */

import * as turf from "@turf/turf";
import _ from "lodash";
import MapboxGl from "mapbox-gl";
import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
import { Icon } from "semantic-ui-react";
import * as analysisActions from "../../../redux/actions/analysisActions";
import * as autoAlignActions from "../../../redux/actions/autoAlignActions";
import * as fieldActions from "../../../redux/actions/fieldActions";
import * as flightImageActions from "../../../redux/actions/flightImageActions";
import * as flightsPlotsActions from "../../../redux/actions/flightsPlotsActions";
import * as markedPlotActions from "../../../redux/actions/markedPlotActions";
import * as orthoActions from "../../../redux/actions/orthoActions";
import * as orthoViewerActions from "../../../redux/actions/orthoViewerActions";
import * as quantifiedRegionActions from "../../../redux/actions/quantifiedRegionsActions";
import { getPrecisionString } from "../ValuePrecisionConverter";
import { MapboxOverlay } from "@deck.gl/mapbox";
import ColorGradient from "../Heatmap/colorGradient";
import {
	BlueYellowLayer,
	ClampedLayer,
	GreenFireBlueLayer,
	RYGLayer,
	SpectralLayer,
	ThermalLayer,
} from "./orthoShaders";

import damagedIcon from "../../../assets/BoxWarningFilled.svg";
import flaggedIcon from "../../../assets/BoxFlagFilled.svg";
import partialExcludedIcon from "../../../assets/BoxWarningLine.svg";
import partialFlagIcon from "../../../assets/BoxFlagLine.svg";

let allPlots = [];
let allFields = [];
let allTrials = [];
let allLLPoints = [];
let allRows = [];
let selectedFieldId = null;
let selectedTrialId = null;
let disableModifying = false;
let initialPlots = [];
let fieldCombined = [];
let rowsCombined = [];
let fieldPivotPoints = [];
let trialPlots = [];
let movingFieldProperties = [];
let nonPlotDrawingsDeleted = [];
const fineConstant = 4;
const coarseConstant = 4;
let orthoId = null;
let markedPlots = [];
let markedSubsamples = [];
let markedPlotOptions = [];
let annotationClassOptions = [];
let defaultViewerSetting = null;
let currentFlightId = null;
let currentFlightDate = null;
let tilesetIds = [];
let activeShader = "";
let inverseShader = false;
let lastAppliedShader = (minThreshold, maxThreshold, inverse = false) => {
	(minThreshold, maxThreshold, inverse);
};
let shaderLayer = null;
let defaultMinShaderThreshold = 0.0;
let defaultMaxShaderThreshold = 1.0;
let subsamples = [];
let subsamplesToAdd = [];
let quantifiedRegionOptions = [];
const precisionOptions = { precision: 7 };
let labelMarkers = { fields: {}, trials: {} };
let cropToFilterOn = "all";
let drawnFeature = null;
let prealignedPlots = [];
let imageBounds = null;
let firstFlightFields = [];
let dataLayerFieldsToDelete = [];

//-- Button Toggles
let llToggle = true;
let fieldToggle = true;
let plotBoundaryToggle = true;
let rowsToggle = false;
let trialsToggle = false;
let fieldLabelsToggle = false;
let trialLabelsToggle = false;
let plotLabelsToggle = false;
let defMarkersToggle = false;
let pivotToggle = false;
let styleToggled = false;
let singleFeatureToggle = false;
let pcToggle = false;
let pcQrToggle = false;
let rcQrToggle = false;
let brQrToggle = false;
let frQrToggle = false;
let scQrToggle = false;
let farmBoundsToggle = false;

//-- Dirty checks for suppressing toggles
let fieldsDirty = true;

//-- Updating QR within edit field modal
let tempPlots = [];
let tempSubsamplesToAdd = [];

//-- Heatmap shader purposes
let heatmapOverlayLabelsToggled = false;
let plotAnalysisResults = [];
let filteredAnalysisResults = [];
let analysisOptions = [];
let heatmapDomain = [];
let heatmapOpacity = 0.65;
let heatmapGradient = "ryg";

//-- Default Viewer Setting

const scalingMetric = 0.001;
const trialColors = [
	"#a83232",
	"#c5db35",
	"#07a1e8",
	"#9607e8",
	"#e807e1",
	"#e80774",
	"#e87407",
	"#a0ff52",
	"#52ff8c",
	"#5adbc4",
	"#64bdd9",
	"#519bdb",
	"#6e69ff",
	"#cd69ff",
	"#ff69da",
	"#ff698f",
	"#ffa078",
	"#c6ed64",
	"#3fbec4",
	"#491bb5",
];

let imageLayers = [];
let imageLayersHidden = false;
const shaderLayers = {
	by: BlueYellowLayer,
	gfb: GreenFireBlueLayer,
	ryg: RYGLayer,
	spectral: SpectralLayer,
	thermal: ThermalLayer,
	clamped: ClampedLayer,
};

let timelineDomain = { ortho: null, heatmap: null, union: [0, 1] };

export function setOrthoId(id) {
	orthoId = id;
}

export function sgetOrthoId() {
	return orthoId;
}
export function styleToggle() {
	styleToggled = !styleToggled;
}

export function checkStyleToggle() {
	return styleToggled;
}

export function getDefaultViewerSetting() {
	return defaultViewerSetting;
}

export function setDefaultViewerSetting(targetDefaultViewerSetting, deafultSettingsPopupRef) {
	if (deafultSettingsPopupRef?.current) {
		deafultSettingsPopupRef.current.setSettingsExist(!!targetDefaultViewerSetting);
	}
	defaultViewerSetting = targetDefaultViewerSetting;
}

// Toggle triggered when lower left toggle button is clicked
export function lowerLeftToggle(draw) {
	if (draw && draw.current) {
		//-- Lays down field if active
		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw, false);
		}

		if (!llToggle) {
			let featuresToAdd = {
				type: "FeatureCollection",
				features: [],
			};

			if (!fieldToggle && fieldsDirty) {
				recalculateFieldBoundaries();
			}

			let llToggleFields = _.cloneDeep(allFields);

			if (singleFeatureToggle) {
				llToggleFields = _.filter(llToggleFields, ({ id }) => {
					return id === selectedFieldId;
				});
			} else if (cropToFilterOn !== "all") {
				llToggleFields = _.filter(llToggleFields, ({ properties }) => {
					return properties.crop === cropToFilterOn;
				});
			}

			_.map(llToggleFields, ({ geometry, id }) => {
				let llPoint = {
					id: crypto.randomUUID(),
					type: "Feature",
					properties: { field: id, type: "llPoint" },
					geometry: {
						type: "Point",
						coordinates: geometry.coordinates[0][0],
					},
				};

				allLLPoints.push(llPoint);
				featuresToAdd.features.push(llPoint);
			});

			draw.current.draw.add(featuresToAdd);
		} else {
			draw.current.draw.delete(_.map(allLLPoints, "id"));
			allLLPoints = [];
		}

		llToggle = !llToggle;
	}
}

export function findTrialBoundaries(trialId) {
	let plots = {
		type: "FeatureCollection",
		id: trialId,
		features: _.filter(allPlots, (ap) => ap.properties.trial === trialId),
	};

	findBoundaries(plots, "trial", false);
}

// Creates boundaries for fields and trials using the existing plots
export function findBoundaries(plots, type, border) {
	let lowerLeft = 0,
		upperLeft = 0,
		upperRight = 0,
		lowerRight = 0;
	let plotBearings = [];

	if (plots.features.length === 1) {
		const coordinates = plots.features[0].geometry.coordinates[0];
		lowerLeft = coordinates[0];
		upperLeft = coordinates[1];
		upperRight = coordinates[2];
		lowerRight = coordinates[3];

		manageBearings(plotBearings, coordinates);
	} else {
		let fieldBearings = {};

		_.forEach(plots.features, (plot) => {
			let fieldBearing = _.round(turf.bearing(plot.geometry.coordinates[0][0], plot.geometry.coordinates[0][1]), 5);

			fieldBearings[fieldBearing] = isNaN(fieldBearings[fieldBearing]) ? 1 : fieldBearings[fieldBearing] + 1;
		});

		let fieldBearing = parseFloat(
			Object.entries(fieldBearings).reduce((a, b) => {
				if (b[1] > a[1]) {
					return b;
				}
				return a;
			})[0],
		);

		let fieldDirection =
			fieldBearing >= 0 && fieldBearing < 90
				? "ne"
				: fieldBearing >= 90 && fieldBearing <= 180
					? "se"
					: fieldBearing <= 0 && fieldBearing > -90
						? "nw"
						: "sw";

		//-- Get all coords
		let allCoords = turf.coordAll(turf.featureCollection(plots.features));

		//-- Split into x/y
		let allXCoords = _.map(allCoords, (c, i) => {
			return { coords: c[0], index: i };
		});
		let allYCoords = _.map(allCoords, (c, i) => {
			return { coords: c[1], index: i };
		});

		//-- Get extremes
		let maxX = _.maxBy(allXCoords, (c) => c.coords);
		let minX = _.minBy(allXCoords, (c) => c.coords);
		let maxY = _.maxBy(allYCoords, (c) => c.coords);
		let minY = _.minBy(allYCoords, (c) => c.coords);

		//-- Map back into points
		let maxXCoords = [allXCoords[maxX.index].coords, allYCoords[maxX.index].coords];
		let minXCoords = [allXCoords[minX.index].coords, allYCoords[minX.index].coords];
		let maxYCoords = [allXCoords[maxY.index].coords, allYCoords[maxY.index].coords];
		let minYCoords = [allXCoords[minY.index].coords, allYCoords[minY.index].coords];

		//-- Create crossing lines from each extreme point following the bearing and perpendicular bearing of the field
		let maxXBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(maxXCoords, 5, fieldBearing - 180).geometry.coordinates,
				maxXCoords,
				turf.rhumbDestination(maxXCoords, 5, fieldBearing).geometry.coordinates,
			]),
			precisionOptions,
		);
		let maxXPerpBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(maxXCoords, 5, fieldBearing + 90).geometry.coordinates,
				maxXCoords,
				turf.rhumbDestination(maxXCoords, 5, fieldBearing - 90).geometry.coordinates,
			]),
			precisionOptions,
		);
		let minXBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(minXCoords, 5, fieldBearing - 180).geometry.coordinates,
				minXCoords,
				turf.rhumbDestination(minXCoords, 5, fieldBearing).geometry.coordinates,
			]),
			precisionOptions,
		);
		let minXPerpBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(minXCoords, 5, fieldBearing + 90).geometry.coordinates,
				minXCoords,
				turf.rhumbDestination(minXCoords, 5, fieldBearing - 90).geometry.coordinates,
			]),
			precisionOptions,
		);
		let maxYBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(maxYCoords, 5, fieldBearing - 180).geometry.coordinates,
				maxYCoords,
				turf.rhumbDestination(maxYCoords, 5, fieldBearing).geometry.coordinates,
			]),
			precisionOptions,
		);
		let maxYPerpBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(maxYCoords, 5, fieldBearing + 90).geometry.coordinates,
				maxYCoords,
				turf.rhumbDestination(maxYCoords, 5, fieldBearing - 90).geometry.coordinates,
			]),
			precisionOptions,
		);
		let minYBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(minYCoords, 5, fieldBearing - 180).geometry.coordinates,
				minYCoords,
				turf.rhumbDestination(minYCoords, 5, fieldBearing).geometry.coordinates,
			]),
			precisionOptions,
		);
		let minYPerpBearingLine = turf.truncate(
			turf.lineString([
				turf.rhumbDestination(minYCoords, 5, fieldBearing + 90).geometry.coordinates,
				minYCoords,
				turf.rhumbDestination(minYCoords, 5, fieldBearing - 90).geometry.coordinates,
			]),
			precisionOptions,
		);

		//-- Get intersect of every extreme line
		let maxXIntersects = [],
			minXIntersects = [],
			maxYIntersects = [],
			minYIntersects = [];

		//---- Bearing line and perp bearing lines change intersections based on field direction
		if (fieldDirection === "nw" || fieldDirection === "se") {
			maxXIntersects = [
				turf.lineIntersect(maxYBearingLine, minYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXBearingLine, minYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXPerpBearingLine, maxYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXBearingLine, maxXPerpBearingLine).features[0].geometry.coordinates,
			];

			minXIntersects = [
				turf.lineIntersect(minXBearingLine, maxYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minYBearingLine, maxYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minYBearingLine, minXPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minXBearingLine, minXPerpBearingLine).features[0].geometry.coordinates,
			];

			maxYIntersects = [
				turf.lineIntersect(maxYBearingLine, minXPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXBearingLine, maxYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXBearingLine, minXPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxYBearingLine, maxYPerpBearingLine).features[0].geometry.coordinates,
			];

			minYIntersects = [
				turf.lineIntersect(minYBearingLine, maxXPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minXBearingLine, minYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minXBearingLine, maxXPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minYBearingLine, minYPerpBearingLine).features[0].geometry.coordinates,
			];
		} else {
			maxXIntersects = [
				turf.lineIntersect(maxYPerpBearingLine, minYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXPerpBearingLine, minYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXBearingLine, maxYPerpBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXBearingLine, maxXPerpBearingLine).features[0].geometry.coordinates,
			];

			minXIntersects = [
				turf.lineIntersect(minXPerpBearingLine, maxYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minYPerpBearingLine, maxYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minYPerpBearingLine, minXBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minXPerpBearingLine, minXBearingLine).features[0].geometry.coordinates,
			];

			maxYIntersects = [
				turf.lineIntersect(maxYPerpBearingLine, minXBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXPerpBearingLine, maxYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxXPerpBearingLine, minXBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(maxYPerpBearingLine, maxYBearingLine).features[0].geometry.coordinates,
			];

			minYIntersects = [
				turf.lineIntersect(minYPerpBearingLine, maxXBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minXPerpBearingLine, minYBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minXPerpBearingLine, maxXBearingLine).features[0].geometry.coordinates,
				turf.lineIntersect(minYPerpBearingLine, minYBearingLine).features[0].geometry.coordinates,
			];
		}

		//-- Find combination of intersects that produce largest area
		let largestArea = 1;
		let largestIntersects = [0, 0, 0, 0];

		_.forEach(maxXIntersects, (a, i) => {
			_.forEach(maxYIntersects, (b, ii) => {
				_.forEach(minXIntersects, (c, iii) => {
					_.forEach(minYIntersects, (d, iv) => {
						let tempPolygon = turf.truncate(
							turf.polygon([
								[maxXIntersects[i], minYIntersects[iv], minXIntersects[iii], maxYIntersects[ii], maxXIntersects[i]],
							]),
							precisionOptions,
						);

						let checkArea = turf.area(tempPolygon);

						if (checkArea > largestArea) {
							largestArea = checkArea;
							largestIntersects = [i, ii, iii, iv];
						}
					});
				});
			});
		});

		//-- Assign extremes to corners based on field direction
		switch (fieldDirection) {
			case "ne":
				lowerLeft = minXIntersects[largestIntersects[2]];
				upperLeft = maxYIntersects[largestIntersects[1]];
				upperRight = maxXIntersects[largestIntersects[0]];
				lowerRight = minYIntersects[largestIntersects[3]];
				break;
			case "nw":
				lowerLeft = minYIntersects[largestIntersects[3]];
				upperLeft = minXIntersects[largestIntersects[2]];
				upperRight = maxYIntersects[largestIntersects[1]];
				lowerRight = maxXIntersects[largestIntersects[0]];
				break;
			case "se":
				lowerLeft = maxYIntersects[largestIntersects[1]];
				upperLeft = maxXIntersects[largestIntersects[0]];
				upperRight = minYIntersects[largestIntersects[3]];
				lowerRight = minXIntersects[largestIntersects[2]];
				break;
			case "sw":
				lowerLeft = maxXIntersects[largestIntersects[0]];
				upperLeft = minYIntersects[largestIntersects[3]];
				upperRight = minXIntersects[largestIntersects[2]];
				lowerRight = maxYIntersects[largestIntersects[1]];
				break;
			default:
				break;
		}

		//-- Handles adding buffer to boundaries
		_.forEach(
			_.map(_.map(_.map(plots.features, "geometry"), "coordinates"), (c) => c[0]),
			(c) => {
				manageBearings(plotBearings, c);
			},
		);
	}

	let initialLL = lowerLeft;

	// Add buffer
	let bearing = _.maxBy(plotBearings, "count").bearing;
	if (border) {
		let buffer =
			(plots.features[0].properties.fieldColWidth > 10 ? 10 : plots.features[0].properties.fieldColWidth) /
			3.281 /
			1000; // Convert ft to km
		// Push point horizontally outward
		lowerLeft = turf.truncate(turf.destination(lowerLeft, buffer, bearing.ulToLl), precisionOptions).geometry
			.coordinates;
		upperLeft = turf.truncate(turf.destination(upperLeft, buffer, bearing.llToUl), precisionOptions).geometry
			.coordinates;
		upperRight = turf.truncate(turf.destination(upperRight, buffer, bearing.ulToUr), precisionOptions).geometry
			.coordinates;
		lowerRight = turf.truncate(turf.destination(lowerRight, buffer, bearing.llToLr), precisionOptions).geometry
			.coordinates;
		// Push point vertically outward
		lowerLeft = turf.truncate(turf.destination(lowerLeft, buffer, bearing.lrToLl), precisionOptions).geometry
			.coordinates;
		upperLeft = turf.truncate(turf.destination(upperLeft, buffer, bearing.urToUl), precisionOptions).geometry
			.coordinates;
		upperRight = turf.truncate(turf.destination(upperRight, buffer, bearing.lrToUr), precisionOptions).geometry
			.coordinates;
		lowerRight = turf.truncate(turf.destination(lowerRight, buffer, bearing.urToLr), precisionOptions).geometry
			.coordinates;
	} else if (!border && type === "field") {
		let buffer = 0.25 / 3.281 / 1000; // small distance to show field boundary
		// Push point horizontally outward
		lowerLeft = turf.truncate(turf.destination(lowerLeft, buffer, bearing.ulToLl), precisionOptions).geometry
			.coordinates;
		upperLeft = turf.truncate(turf.destination(upperLeft, buffer, bearing.llToUl), precisionOptions).geometry
			.coordinates;
		upperRight = turf.truncate(turf.destination(upperRight, buffer, bearing.ulToUr), precisionOptions).geometry
			.coordinates;
		lowerRight = turf.truncate(turf.destination(lowerRight, buffer, bearing.llToLr), precisionOptions).geometry
			.coordinates;
		// Push point vertically outward
		lowerLeft = turf.truncate(turf.destination(lowerLeft, buffer, bearing.lrToLl), precisionOptions).geometry
			.coordinates;
		upperLeft = turf.truncate(turf.destination(upperLeft, buffer, bearing.urToUl), precisionOptions).geometry
			.coordinates;
		upperRight = turf.truncate(turf.destination(upperRight, buffer, bearing.lrToUr), precisionOptions).geometry
			.coordinates;
		lowerRight = turf.truncate(turf.destination(lowerRight, buffer, bearing.urToLr), precisionOptions).geometry
			.coordinates;
	}

	// Assign new pivot points
	if (type === "field") {
		if (_.findIndex(fieldPivotPoints, { id: plots.features[0].properties.field }) === -1) {
			fieldPivotPoints.push({
				id: plots.features[0].properties.field,
				pivot: {
					id: crypto.randomUUID(),
					type: "Feature",
					properties: {
						type: "pivot",
						field: plots.features[0].properties.field,
						portColor: "#7b32a8",
					},
					geometry: {
						type: "Point",
						coordinates: lowerLeft,
					},
				},
			});
		}
	}

	let columns =
		type === "field"
			? plots.features[0].properties.columns
			: _.uniqBy(plots.features, (f) => f.properties.column).length;
	let ranges =
		type === "field" ? plots.features[0].properties.ranges : _.uniqBy(plots.features, (f) => f.properties.range).length;

	let boundaries = {
		id: type === "field" ? plots.features[0].properties.field : plots.features[0].properties.trial,
		type: "Feature",
		properties: {
			plotIds: _.map(plots.features, "id"),
			type: type,
			field: plots.features[0].properties.field,
			name: type === "field" ? plots.features[0].properties.fieldName : plots.features[0].properties.trialName,
			portColor: type === "field" ? (plots.features[0].properties.locked ? "#03fcf8" : "#FF0000") : "#FF0000",
			locked: plots.features[0].properties.locked,
			crop: plots.features[0].properties.crop,
			plantDate: plots.features[0].properties.plantDate,
			harvestDate: plots.features[0].properties.harvestDate,
			city: plots.features[0].properties.city,
			region: plots.features[0].properties.region,
			country: plots.features[0].properties.country,
			countryCode: plots.features[0].properties.countryCode,
			ranges: ranges,
			columns: columns,
			rangeLength: plots.features[0].properties.fieldRangeLength,
			columnWidth: plots.features[0].properties.fieldColWidth,
			scaleFactor: plots.features[0].properties.scaleFactor,
			initialLL: initialLL,
			treatments: type === "trial" ? _.uniqBy(plots.features, (f) => f.properties.treatment).length : null,
			replicates: type === "trial" ? _.uniqBy(plots.features, (f) => f.properties.replicate).length : null,
		},
		geometry: {
			type: "Polygon",
			coordinates: [[lowerLeft, upperLeft, upperRight, lowerRight, lowerLeft]],
		},
	};

	if (type === "field") {
		allFields.push(boundaries);
	}
	if (type === "trial") {
		allTrials.push(boundaries);
	}
}

function manageBearings(plotBearings, coordinates) {
	let localBearing = {
		llToLr: turf.bearing(coordinates[0], coordinates[3]),
		llToUl: turf.bearing(coordinates[0], coordinates[1]),
		ulToLl: turf.bearing(coordinates[1], coordinates[0]),
		ulToUr: turf.bearing(coordinates[1], coordinates[2]),
		urToUl: turf.bearing(coordinates[2], coordinates[1]),
		urToLr: turf.bearing(coordinates[2], coordinates[3]),
		lrToLl: turf.bearing(coordinates[3], coordinates[0]),
		lrToUr: turf.bearing(coordinates[3], coordinates[2]),
	};
	let index = _.findIndex(plotBearings, { bearing: localBearing });
	if (index === -1) {
		plotBearings.push({
			bearing: localBearing,
			coords: coordinates,
			count: 1,
		});
	} else {
		plotBearings[index].count += 1;
	}
}

// Recreates fields if plots were moved since last creation
function recalculateFieldBoundaries(border = false) {
	let fields = [];

	_.map(allPlots, ({ properties }, index) => {
		if (fields.length === 0 || !fields.some((field) => field.id === properties.field)) {
			let newField = {
				type: "FeatureCollection",
				id: properties.field,
				features: [],
			};
			fields.push(newField);
		}

		fields[_.findIndex(fields, { id: properties.field })].features.push(allPlots[index]);
	});

	allFields = [];
	_.map(fields, (field) => {
		findBoundaries(field, "field", border);
	});

	if (allFields.length > 0) {
		fieldsDirty = false;
	}
}

// Toggle triggered when field toggle is clicked
export function fieldBoundaryToggle(draw) {
	if (draw?.current) {
		//-- Lays down field if active
		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw, false);
		}

		if (!fieldToggle) {
			if (fieldsDirty) {
				recalculateFieldBoundaries();
			}

			let fieldsToDraw = _.cloneDeep(allFields);

			if (singleFeatureToggle) {
				fieldsToDraw = _.filter(fieldsToDraw, ({ id }) => {
					return id === selectedFieldId;
				});
			}

			if (cropToFilterOn !== "all") {
				fieldsToDraw = _.filter(fieldsToDraw, (f) => f.properties.crop === cropToFilterOn);
			}

			let newFeatures = {
				type: "FeatureCollection",
				features: fieldsToDraw,
			};

			draw.current.draw.add(newFeatures);

			bringSubsamplesToTopLayer(draw);
		} else {
			draw.current.draw.delete(
				_.map(
					_.filter(draw.current.draw.getAll().features, (f) => f.properties.type === "field"),
					"id",
				),
			);
		}

		fieldToggle = !fieldToggle;
	}
}

// Toggle triggered when plot toggle button is clicked
export function plotToggle(draw, controlComponentRefs = null, keepHeatmap = false) {
	if (draw?.current) {
		if (!plotBoundaryToggle) {
			let plotsToDraw = _.cloneDeep(allPlots);

			if (singleFeatureToggle && !selectedTrialId) {
				plotsToDraw = _.filter(plotsToDraw, ({ properties }) => {
					return properties.field === selectedFieldId;
				});
			} else if (singleFeatureToggle && selectedTrialId) {
				plotsToDraw = _.filter(plotsToDraw, ({ properties }) => {
					return properties.trial === selectedTrialId;
				});
			}

			if (cropToFilterOn !== "all") {
				plotsToDraw = _.filter(plotsToDraw, (p) => p.properties.crop === cropToFilterOn);
			}

			let featuresToAdd = {
				type: "FeatureCollection",
				features: plotsToDraw,
			};

			draw.current.draw.add(featuresToAdd);

			//-- Recoloring trial plots
			if (trialsToggle) {
				trialToggle(draw);
				trialToggle(draw);
			}

			bringSubsamplesToTopLayer(draw);

			if (controlComponentRefs?.heatmapTimelineRef?.current && !keepHeatmap) {
				controlComponentRefs.heatmapTimelineRef.current.setHeatmapDisabled(false);
				heatmapOverlayLabelsToggled = false;
			}
		} else {
			draw.current.draw.delete(
				_.map(
					_.filter(draw.current.draw.getAll().features, (f) => f.properties.type === "plot"),
					"id",
				),
			);

			//-- Turn heatmap toggle off if plots go off
			if (controlComponentRefs?.heatmapTimelineRef?.current && !keepHeatmap) {
				controlComponentRefs.heatmapTimelineRef.current.setHeatmapEnabled(false);
				controlComponentRefs.heatmapTimelineRef.current.setHeatmapDisabled(true);
			}
		}

		plotBoundaryToggle = !plotBoundaryToggle;
	}
}

// Toggle triggered when row toggle button is clicked
export function rowToggle(draw) {
	if (draw?.current) {
		//-- Lays down field if active
		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw, false);
		}

		if (!rowsToggle) {
			draw.current.draw.changeMode("simple_select");

			let featuresToAdd = {
				type: "FeatureCollection",
				features: [],
			};

			drawRows(featuresToAdd);

			draw.current.draw.add(featuresToAdd);

			bringSubsamplesToTopLayer(draw);
		} else {
			draw.current.draw.delete(_.map(allRows, "id"));
			allRows = [];
		}

		rowsToggle = !rowsToggle;
	}
}

function drawRows(featuresToAdd = null) {
	let plotsToDraw = _.cloneDeep(allPlots);

	if (singleFeatureToggle && !selectedTrialId) {
		plotsToDraw = _.filter(plotsToDraw, ({ properties }) => {
			return properties.field === selectedFieldId;
		});
	} else if (singleFeatureToggle && selectedTrialId) {
		plotsToDraw = _.filter(plotsToDraw, ({ properties }) => {
			return properties.trial === selectedTrialId;
		});
	}

	if (cropToFilterOn !== "all") {
		plotsToDraw = _.filter(plotsToDraw, (p) => p.properties.crop === cropToFilterOn);
	}

	_.map(plotsToDraw, ({ id, properties, geometry }) => {
		let bearing = turf.bearing(geometry.coordinates[0][0], geometry.coordinates[0][1]);
		let perpendicularBearing = bearing + 90;

		let coordsToRotateAround = [geometry.coordinates[0][0][0], geometry.coordinates[0][0][1]];

		let firstRow = true;
		_.times(properties.fieldRowCount, (i) => {
			let fieldRowSpacing = properties.fieldRowSpacing * properties.scaleFactor;
			let lineToAdd = {
				type: "Feature",
				id: crypto.randomUUID(),
				properties: {
					field: properties.field,
					trial: properties.trial,
					plot: id,
					rowNumber: i + 1,
					type: "row",
				},
				geometry: {
					type: "LineString",
					coordinates: [],
				},
			};

			//Set the field row spacing to half to line up the rows correctly
			if (firstRow) {
				fieldRowSpacing = fieldRowSpacing / 2;
				fieldRowSpacing += (properties.fieldPlanterOffset * properties.scaleFactor) / 2;
				firstRow = false;
			}

			let initialPoint = turf.truncate(
				turf.destination(coordsToRotateAround, fieldRowSpacing / 12 / 3.281 / 1000, perpendicularBearing),
				precisionOptions,
			).geometry.coordinates;

			let endingPoint = turf.truncate(
				turf.destination(initialPoint, (properties.fieldRangeLength * properties.scaleFactor) / 3.281 / 1000, bearing),
				precisionOptions,
			).geometry.coordinates;

			coordsToRotateAround = initialPoint;

			lineToAdd.geometry.coordinates.push(initialPoint, endingPoint);
			if (featuresToAdd) {
				featuresToAdd.features.push(lineToAdd);
			}
			allRows.push(lineToAdd);
		});
	});
}

// Resets the viewport to the original settings
export function resetOrientation(
	canvas,
	level,
	draw,
	dropdownRef,
	controlComponentRefs,
	moduleNavigation,
	featureBounds = null,
) {
	if (canvas) {
		selectedFieldId = null;
		selectedTrialId = null;

		if (featureBounds) imageBounds = featureBounds;

		fitToHeight(canvas, level, true);

		toggleSingleFieldTrial(draw, canvas, null, controlComponentRefs, moduleNavigation, dropdownRef, level);

		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw, false);
		}

		if (dropdownRef) {
			dropdownRef.current.innerRef.current.setThirdDropdownId("all");
		}

		if (dropdownRef && level === "farm") {
			dropdownRef.current.innerRef.current.resetSelectedOptions();
		}
	}
}

//-- Draws farm bounds
export function drawFarmBounds(draw) {
	if (imageBounds && draw) {
		if (!farmBoundsToggle) {
			let farmBounds = {
				type: "Feature",
				id: crypto.randomUUID(),
				properties: {
					type: "farm",
					portColor: "#ffb820",
				},
				geometry: {
					type: "Polygon",
					coordinates: [imageBounds],
				},
			};

			draw.current.draw.add(farmBounds);
		} else {
			let farmFeature = _.find(draw.current.draw.getAll().features, (f) => f.properties.type === "farm");

			if (farmFeature) {
				draw.current.draw.delete(farmFeature?.id);
			}
		}

		farmBoundsToggle = !farmBoundsToggle;
	}
}

// Recreates trial boundaries if any plots were moved since previous creation
function recalculateTrialBoundaries(border) {
	let trials = [];

	_.map(allPlots, ({ properties }, index) => {
		if (properties.trial && properties.trial !== "none") {
			if (trials.length === 0 || !trials.some((trial) => trial.id === properties.trial)) {
				let newTrial = {
					type: "FeatureCollection",
					id: properties.trial,
					features: [],
				};
				trials.push(newTrial);
			}

			trials[_.findIndex(trials, { id: properties.trial })].features.push(allPlots[index]);
		}
	});

	allTrials = [];
	_.map(trials, (trial) => {
		findBoundaries(trial, "trial", border);
	});
}

// Toggle triggered when trial toggle button is clicked
export function trialToggle(draw, forceAddColor = false, forceRemoveColor = false) {
	if (draw?.current) {
		//-- Lays down field if active
		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw, false);
		}

		if (!trialsToggle || forceAddColor) {
			//-- Redraw trial boundaries just in case
			recalculateTrialBoundaries(false);

			//-- Get all existing plots with trials
			//---- Get assigned trial color index
			let plotsWithTrials = _.cloneDeep(allTrials);
			_.map(plotsWithTrials, (plots, index) => {
				plots.trialColorIndex = index;
			});

			//-- If single feature toggled, only display plots with selected trial
			if (singleFeatureToggle && selectedTrialId) {
				plotsWithTrials = _.filter(plotsWithTrials, ({ id }) => {
					return id === selectedTrialId;
				});
			}

			//-- Filter by crop selection
			if (cropToFilterOn !== "all") {
				plotsWithTrials = _.filter(plotsWithTrials, (t) => t.properties.crop === cropToFilterOn);
			}

			//-- Find matching plots to manipulate in allPlots object
			_.forEach(plotsWithTrials, ({ id, trialColorIndex }) => {
				_.forEach(allPlots, (plot) => {
					if (plot.properties.trial === id) {
						//-- Create trial plot object to hold for later use
						let trialPlot = {
							id: crypto.randomUUID(),
							type: "Feature",
							properties: {
								...plot.properties,
								trialColor: trialColors[trialColorIndex % 20],
								trialOrder: trialColorIndex,
								plotId: plot.id,
							},
							geometry: plot.geometry,
						};

						//-- Pick trial color from master list
						plot.trialColor = trialColors[trialColorIndex % 20];
						plot.trialOrder = trialColorIndex;

						//-- Check for existing mapbox feature
						let featureExists = draw.current.draw.get(plot.id);

						if (featureExists) {
							//-- Redrawing plot
							draw.current.draw.setFeatureProperty(plot.id, "trialColor", trialColors[trialColorIndex % 20]);
							draw.current.draw.setFeatureProperty(plot.id, "trialOrder", trialColorIndex);

							let feature = draw.current.draw.get(plot.id);
							draw.current.draw.add(feature);
						}

						//-- Add trial plot objects to global
						trialPlots.push(trialPlot);
					}
				});
			});

			bringSubsamplesToTopLayer(draw);
		} else if (trialsToggle || forceRemoveColor) {
			//-- Look for matching plot in the allPlots object
			// TODO: do we need a double loop here?
			_.map(trialPlots, (tp) => {
				_.map(allPlots, (ap) => {
					if (ap.id === tp.properties.plotId) {
						//-- Redrawing plot
						let feature = draw.current.draw.get(ap.id);

						//-- Remove trialColor property to recolor plot with original color
						if (feature) {
							draw.current.draw.setFeatureProperty(ap.id, "trialColor", undefined);
							draw.current.draw.setFeatureProperty(ap.id, "trialOrder", undefined);
							delete feature.properties.trialColor;
							delete feature.properties.trialOrder;

							draw.current.draw.add(feature);
						}
					}
				});
			});

			//-- Clear all trial plots
			trialPlots = [];

			bringSubsamplesToTopLayer(draw);
		}

		//-- Toggle opposite state
		if (!forceAddColor && !forceRemoveColor) {
			trialsToggle = !trialsToggle;
		}
	}
}

export function fieldPivotToggle(draw) {
	if (draw?.current) {
		//-- Lays down field if active
		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw, false);
		}

		if (!pivotToggle) {
			let newFeatures = {
				type: "FeatureCollection",
				features: _.map(fieldPivotPoints, "pivot"),
			};

			draw.current.draw.add(newFeatures);
		} else {
			draw.current.draw.delete(_.map(_.map(fieldPivotPoints, "pivot"), "id"));
		}

		pivotToggle = !pivotToggle;
	}
}

export function fieldPivotLlSet(draw) {
	if (draw.current) {
		if (fieldCombined.length > 0) {
			uncombinePlotsInField(draw);
		}

		// Delete pivot drawings if enabled
		let pivotToggleState = _.cloneDeep(pivotToggle);
		if (pivotToggleState) {
			fieldPivotToggle(draw);
		}

		// Enable ll if not enabled
		let llState = _.cloneDeep(llToggle);
		if (!llState) {
			lowerLeftToggle(draw);
		}

		_.map(fieldPivotPoints, (pivotPoint) => {
			let llPoint = _.filter(allLLPoints, ({ properties }) => {
				if (properties.field === pivotPoint.id) return true;
			})[0];
			let center = turf.center(llPoint).geometry.coordinates;
			pivotPoint.pivot.geometry.coordinates = center;
		});

		// Reset to original state
		if (pivotToggleState) {
			fieldPivotToggle(draw);
		}
		if (!llState) {
			lowerLeftToggle(draw);
		}
	}
}

// Polyfill function to make fit to height/width work with a bearing
function fitBoundsRotated(bounds, options, eventData, canvas) {
	options = {
		padding: {
			top: 55,
			bottom: 15,
			right: 5,
			left: 5,
		},
		offset: [0, 0],
		maxZoom: canvas.transform.maxZoom,
		...options,
	};

	if (typeof options.padding === "number") {
		const p = options.padding;
		options.padding = {
			top: p,
			bottom: p,
			right: p,
			left: p,
		};
	}

	bounds = MapboxGl.LngLatBounds.convert(bounds);
	const paddingOffset = [options.padding.left - options.padding.right, options.padding.top - options.padding.bottom],
		lateralPadding = Math.min(options.padding.right, options.padding.left),
		verticalPadding = Math.min(options.padding.top, options.padding.bottom);
	options.offset = [options.offset[0] + paddingOffset[0], options.offset[1] + paddingOffset[1]];

	options.bearing = options.bearing ?? canvas.getBearing();

	const offset = MapboxGl.Point.convert(options.offset),
		tr = canvas.transform,
		nw = tr.project(bounds.getNorthWest()),
		se = tr.project(bounds.getSouthEast()),
		size = se.sub(nw);

	const theta = options.bearing * (Math.PI / 180),
		W = size.x * Math.abs(Math.cos(theta)) + size.y * Math.abs(Math.sin(theta)),
		H = size.x * Math.abs(Math.sin(theta)) + size.y * Math.abs(Math.cos(theta)),
		rotatedSize = { x: W, y: H },
		scaleX = (tr.width - lateralPadding * 2 - Math.abs(offset.x) * 2) / rotatedSize.x,
		scaleY = (tr.height - verticalPadding * 2 - Math.abs(offset.y) * 2) / rotatedSize.y;

	if (scaleY < 0 || scaleX < 0) {
		if (typeof console !== "undefined")
			console.warn("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
		return canvas;
	}

	options.center = tr.unproject(nw.add(se).div(2));
	options.zoom = Math.min(tr.scaleZoom(tr.scale * Math.min(scaleX, scaleY)), options.maxZoom);

	return options.linear ? canvas.easeTo(options, eventData) : canvas.flyTo(options, eventData);
}

// Finds and changes viewport to fit the height of the selected field/trial
export function fitToHeight(canvas, type, originalPos = false) {
	let coords = null;
	if ((type === "field" && allFields.length > 0) || (type === "trial" && allTrials.length > 0)) {
		if (type === "field" && !selectedFieldId) {
			selectedFieldId = _.last(allFields).id;
		} else if (type === "trial" && !selectedTrialId) {
			selectedTrialId = _.last(allTrials).id;
		}
	}

	if (selectedFieldId || selectedTrialId) {
		coords = selectedFieldId
			? _.find(allFields, { id: selectedFieldId }).geometry.coordinates[0]
			: _.find(allTrials, { id: selectedTrialId }).geometry.coordinates[0];
	} else if (imageBounds) {
		coords = imageBounds;
	}

	if (coords) {
		//-- Get current viewport bearing
		let viewportLl = canvas.unproject([0, canvas.getCanvas().height]).toArray();
		let viewportUl = canvas.unproject([0, 0]).toArray();
		let viewportBearing = turf.bearing(viewportLl, viewportUl);

		//-- Identify all bearings of feature
		let llToUl = turf.bearing(coords[0], coords[1]);
		let ulToUr = turf.bearing(coords[1], coords[2]);
		let urToLr = turf.bearing(coords[2], coords[3]);
		let lrToLl = turf.bearing(coords[3], coords[0]);

		//-- Adjusting for range to be 0 - 360
		if (viewportBearing < 0) viewportBearing = 360 - Math.abs(viewportBearing);
		if (llToUl < 0) llToUl = 360 - Math.abs(llToUl);
		if (ulToUr < 0) ulToUr = 360 - Math.abs(ulToUr);
		if (urToLr < 0) urToLr = 360 - Math.abs(urToLr);
		if (lrToLl < 0) lrToLl = 360 - Math.abs(lrToLl);

		//-- Viewport bearing must be less than feature bearing
		let closestBearing = [llToUl, ulToUr, urToLr, lrToLl].reduce((prev, curr) =>
			Math.abs(curr - viewportBearing) < Math.abs(prev - viewportBearing) ? curr : prev,
		);

		//-- Assign what points need to be captured on the given bearing
		let firstPoint, secondPoint;
		if (closestBearing.toPrecision(4) == llToUl.toPrecision(4)) {
			firstPoint = turf.midpoint(coords[0], coords[3]).geometry.coordinates;
			secondPoint = turf.midpoint(coords[1], coords[2]).geometry.coordinates;
		}
		if (closestBearing.toPrecision(4) == ulToUr.toPrecision(4)) {
			firstPoint = turf.midpoint(coords[0], coords[1]).geometry.coordinates;
			secondPoint = turf.midpoint(coords[2], coords[3]).geometry.coordinates;
		}
		if (closestBearing.toPrecision(4) == urToLr.toPrecision(4)) {
			firstPoint = turf.midpoint(coords[0], coords[3]).geometry.coordinates;
			secondPoint = turf.midpoint(coords[1], coords[2]).geometry.coordinates;
		}
		if (closestBearing.toPrecision(4) == lrToLl.toPrecision(4)) {
			firstPoint = turf.midpoint(coords[0], coords[1]).geometry.coordinates;
			secondPoint = turf.midpoint(coords[2], coords[3]).geometry.coordinates;
		}

		if (closestBearing > 180) closestBearing -= 360;

		let bearing = type === "farm" ? 0 : turf.bearing(coords[0], coords[1]);
		let bounds = originalPos
			? turf.bbox(
					turf.multiLineString([
						[
							turf.midpoint(coords[0], coords[3]).geometry.coordinates,
							turf.midpoint(coords[1], coords[2]).geometry.coordinates,
						],
					]),
				)
			: turf.bbox(turf.multiLineString([[firstPoint, secondPoint]]));

		fitBoundsRotated(
			[
				[bounds[0], bounds[1]],
				[bounds[2], bounds[3]],
			],
			{
				bearing: originalPos ? bearing : closestBearing,
			},
			{},
			canvas,
		);
	}
}

// Finds and changes viewport to fit the width of the selected field
export function fitToWidth(canvas, type) {
	if ((type === "field" && allFields.length > 0) || (type === "trial" && allTrials.length > 0)) {
		if (type === "field" && !selectedFieldId) {
			selectedFieldId = _.last(allFields).id;
		} else if (type === "trial" && !selectedTrialId) {
			selectedTrialId = _.last(allTrials).id;
		}

		let coords =
			type === "field"
				? _.find(allFields, { id: selectedFieldId }).geometry.coordinates[0]
				: _.find(allTrials, { id: selectedTrialId }).geometry.coordinates[0];

		if (coords) {
			//-- Get current viewport bearing
			let viewportLl = canvas.unproject([0, canvas.getCanvas().height]).toArray();
			let viewportUl = canvas.unproject([0, 0]).toArray();
			let viewportBearing = turf.bearing(viewportLl, viewportUl);

			//-- Identify all bearings of feature
			let llToUl = turf.bearing(coords[0], coords[1]);
			let ulToUr = turf.bearing(coords[1], coords[2]);
			let urToLr = turf.bearing(coords[2], coords[3]);
			let lrToLl = turf.bearing(coords[3], coords[0]);

			//-- Adjusting for range to be 0 - 360
			if (viewportBearing < 0) viewportBearing = 360 - Math.abs(viewportBearing);
			if (llToUl < 0) llToUl = 360 - Math.abs(llToUl);
			if (ulToUr < 0) ulToUr = 360 - Math.abs(ulToUr);
			if (urToLr < 0) urToLr = 360 - Math.abs(urToLr);
			if (lrToLl < 0) lrToLl = 360 - Math.abs(lrToLl);

			//-- Viewport bearing must be less than feature bearing
			let closestBearing = [llToUl, ulToUr, urToLr, lrToLl].reduce((prev, curr) =>
				Math.abs(curr - viewportBearing) < Math.abs(prev - viewportBearing) ? curr : prev,
			);

			let firstPoint, secondPoint;
			if (closestBearing.toPrecision(4) === llToUl.toPrecision(4)) {
				firstPoint = turf.midpoint(coords[0], coords[1]).geometry.coordinates;
				secondPoint = turf.midpoint(coords[2], coords[3]).geometry.coordinates;
			}
			if (closestBearing.toPrecision(4) === ulToUr.toPrecision(4)) {
				firstPoint = turf.midpoint(coords[1], coords[2]).geometry.coordinates;
				secondPoint = turf.midpoint(coords[0], coords[3]).geometry.coordinates;
			}
			if (closestBearing.toPrecision(4) === urToLr.toPrecision(4)) {
				firstPoint = turf.midpoint(coords[0], coords[1]).geometry.coordinates;
				secondPoint = turf.midpoint(coords[2], coords[3]).geometry.coordinates;
			}
			if (closestBearing.toPrecision(4) === lrToLl.toPrecision(4)) {
				firstPoint = turf.midpoint(coords[1], coords[2]).geometry.coordinates;
				secondPoint = turf.midpoint(coords[0], coords[3]).geometry.coordinates;
			}

			if (closestBearing > 180) closestBearing -= 360;

			let bounds = turf.bbox(turf.multiLineString([[firstPoint, secondPoint]]));

			fitBoundsRotated(
				[
					[bounds[0], bounds[1]],
					[bounds[2], bounds[3]],
				],
				{
					bearing: closestBearing,
				},
				{},
				canvas,
			);
		}
	}
}

export function plotLabelToggle(draw, canvas, componentRefs) {
	if (canvas) {
		let filteredPlots = _.cloneDeep(allPlots);

		if (!plotLabelsToggle) {
			//-- Turn off heatmap values if enabled
			if (componentRefs.heatmapOverlayLabelsRef?.current?.checkToggleState) {
				heatmapOverlayLabels(draw, canvas, componentRefs);
			}

			let labelCollection = {
				type: "FeatureCollection",
				features: [],
			};

			//-- Filter on field id
			if (singleFeatureToggle && selectedFieldId) {
				filteredPlots = _.filter(allPlots, (ap) => ap.properties.field === selectedFieldId);
			}

			//-- Filter on trial id
			if (singleFeatureToggle && selectedTrialId) {
				filteredPlots = _.filter(allPlots, (ap) => ap.properties.trial === selectedTrialId);
			}

			if (cropToFilterOn !== "all") {
				filteredPlots = _.filter(filteredPlots, (p) => p.properties.crop === cropToFilterOn);
			}

			_.map(filteredPlots, (plot) => {
				const center = turf.truncate(turf.centroid(plot), precisionOptions).geometry.coordinates;

				let minSideLen = 24;

				if (plot.properties.fieldColWidth !== null && plot.properties.fieldRangeLength !== null) {
					minSideLen = Math.min(plot.properties.fieldColWidth, plot.properties.fieldRangeLength);
				}

				const size = minSideLen * 0.9;

				if (plot.properties.name !== null && plot.properties.treatment !== null) {
					let labelToAdd = {
						type: "Feature",
						properties: {
							name: `${plot.properties.name} \n ${plot.properties.treatment}`,
							field: plot.properties.field,
							size: size,
							type: "plotLabel",
						},
						geometry: {
							type: "Point",
							coordinates: center,
						},
					};
					labelCollection.features.push(labelToAdd);
				}
			});

			if (canvas.getLayer("plot-labels")) {
				canvas.removeLayer("plot-labels");
			}

			if (canvas.getSource("plot-labels")) {
				canvas.removeSource("plot-labels");
			}

			canvas.addSource("plot-labels", {
				type: "geojson",
				data: labelCollection,
			});

			canvas.addLayer({
				id: "plot-labels",
				type: "symbol",
				source: "plot-labels",
				layout: {
					"text-field": ["format", ["get", "name"]],
					"text-variable-anchor": ["center"],
					"text-size": ["interpolate", ["exponential", 2], ["zoom"], 14, 3, 19, ["get", "size"], 25, 255],
					"text-justify": "auto",
				},
				paint: {
					"text-color": "#ffffff",
					"text-halo-color": "#000000",
					"text-halo-width": 1,
				},
				//minzoom: 14
			});
		} else {
			if (canvas.getLayer("plot-labels")) {
				canvas.removeLayer("plot-labels");
				canvas.removeSource("plot-labels");
			}
		}

		plotLabelsToggle = !plotLabelsToggle;
	}
}

export function defMarkerToggle(canvas, controlComponentRefs) {
	if (canvas) {
		const images = [
			{ svg: damagedIcon, name: "Excluded", size: [64, 64] },
			{ svg: flaggedIcon, name: "Flagged", size: [64, 64] },
			{ svg: partialFlagIcon, name: "PartiallyFlagged", size: [64, 64] },
			{ svg: partialExcludedIcon, name: "PartiallyExcluded", size: [64, 64] },
		];

		images.map((ob) => {
			if (!canvas.hasImage(ob.name)) {
				const img = new Image(ob.size[0], ob.size[1]);
				img.onload = () => canvas.addImage(ob.name, img, { sdf: "true" });
				img.src = ob.svg;
			}
		});

		let filteredPlots = _.cloneDeep(allPlots);
		if (!defMarkersToggle) {
			let defCollection = {
				type: "FeatureCollection",
				features: [],
			};

			//-- Filter on field id
			if (singleFeatureToggle && selectedFieldId) {
				filteredPlots = _.filter(allPlots, (ap) => ap.properties.field === selectedFieldId);
			}

			//-- Filter on trial id
			if (singleFeatureToggle && selectedTrialId) {
				filteredPlots = _.filter(allPlots, (ap) => ap.properties.trial === selectedTrialId);
			}

			if (cropToFilterOn !== "all") {
				filteredPlots = _.filter(filteredPlots, (p) => p.properties.crop === cropToFilterOn);
			}

			const markedIds = new Set(_.map(markedSubsamples, "quantifiedRegionId"));

			const firstPlot = filteredPlots[0];
			const firstPlotSubsamples = _.filter(subsamples, (ps) => ps.properties.plotId === firstPlot.id);
			const splitFirstPlotSubsamples = _.groupBy(firstPlotSubsamples, "properties.quantifiedRegionTypeName");

			let minSideLen = 10;
			if (firstPlot && firstPlot.properties) {
				minSideLen = Math.min(firstPlot.properties.fieldColWidth, firstPlot.properties.fieldRangeLength);
			}

			const size = Math.log10(minSideLen);
			const visibleAtZoom = 24 - size;

			const quantifiedRegionTypeRefrence = _.reduce(
				Object.keys(splitFirstPlotSubsamples),
				(acc, type) => {
					acc[type] = {};
					acc[type].count = splitFirstPlotSubsamples[type].length;
					return acc;
				},
				{},
			);

			_.map(filteredPlots, (plot) => {
				let plotDef = _.filter(markedPlots, (mp) => mp.plotId === plot.id);

				const lowerLeft = plot.geometry.coordinates[0][0];
				const lowerRight = plot.geometry.coordinates[0][3];
				const upperLeft = plot.geometry.coordinates[0][1];

				const bearing1 = turf.bearing(lowerLeft, lowerRight);
				const bearing2 = turf.bearing(lowerLeft, upperLeft);

				let paddedLowerLeft = turf.destination(lowerLeft, 3.5 * size * size, bearing1, { units: "feet" }).geometry
					.coordinates;
				paddedLowerLeft = turf.destination(paddedLowerLeft, 3.5 * size * size, bearing2, { units: "feet" }).geometry
					.coordinates;

				const statusOrder = {
					Excluded: 0,
					Flagged: 1,
				};

				const learnedStatuses = {};

				plotDef.forEach((pdef) => {
					let dateAndTime = new Date(pdef.dateAndTime ? pdef.dateAndTime : new Date(Date.UTC(0, 0))).getTime();
					let plotStatus = {
						status: pdef.plotStatusName,
						level: "Entire Plot",
						notes: pdef.notes ?? "",
						quantifiedRegionNames: "",
						statusOrder: statusOrder[pdef.plotStatusName],
						levelOrder: 0,
						isAllData: pdef.isAllData,
						annotationClassifier: pdef.annotationClassifier,
						modifiedBy: pdef.modifiedBy,
						modifiedDateTime: moment(pdef.modifiedDateTime).local().format("MM/DD/YY"),
					};

					if (learnedStatuses[dateAndTime]) {
						learnedStatuses[dateAndTime].push(plotStatus);
					} else {
						learnedStatuses[dateAndTime] = [plotStatus];
					}
				});

				const plotSubsamples = _.filter(
					subsamples,
					(ps) => ps.properties.plotId === plot.id && markedIds.has(ps.properties.quantifiedRegionId),
				);

				if (plotSubsamples.length > 0) {
					const datedMarkedSubsamples = _.map(markedSubsamples, (ms) => {
						if (ms.isAllData) {
							return {
								...ms,
								dateAndTime: new Date(Date.UTC(0, 0)),
							};
						}
						return ms;
					});

					const markedTimeframeSubsamples = Object.values(
						_.groupBy(datedMarkedSubsamples, (dms) =>
							[new Date(dms.dateAndTime).toLocaleString(), dms.annotationClassifier, dms.modifiedBy].join(),
						),
					);

					for (let mts of markedTimeframeSubsamples) {
						const markedPlotSubsamples = _.reduce(
							mts,
							(acc, cur) => {
								const mps = _.find(plotSubsamples, { properties: { quantifiedRegionId: cur.quantifiedRegionId } });
								if (mps) {
									return [
										...acc,
										{
											...cur,
											quantifiedRegionNumber: mps.properties.quantifiedRegionNumber,
											quantifiedRegionTypeName: mps.properties.quantifiedRegionTypeName,
											column: mps.properties.column,
											range: mps.properties.range,
										},
									];
								}
								return acc;
							},
							[],
						);

						if (markedPlotSubsamples.length > 0) {
							let excludedPlotSubsamples = _.filter(markedPlotSubsamples, {
								quantifiedRegionStatusName: "Excluded",
							});
							let flaggedPlotSubsamples = _.filter(markedPlotSubsamples, {
								quantifiedRegionStatusName: "Flagged",
							});

							excludedPlotSubsamples = _.groupBy(excludedPlotSubsamples, "quantifiedRegionTypeName");
							flaggedPlotSubsamples = _.groupBy(flaggedPlotSubsamples, "quantifiedRegionTypeName");

							const checkIfAll = (splitMarkedSubsamples) => {
								const qrstids = Object.keys(splitMarkedSubsamples);
								for (let id of qrstids) {
									if (splitMarkedSubsamples[id].length === quantifiedRegionTypeRefrence[id].count) {
										return true;
									}
								}
								return false;
							};

							const timeframeStatus = [];

							const learnStatus = (splitMarkedSubsamples, statusName, statusOrder) => {
								if (Object.keys(splitMarkedSubsamples).length > 0) {
									const subsampleTypeNumbers = {};
									let notes = "";

									const qrstids = Object.keys(splitMarkedSubsamples);
									for (let id of qrstids) {
										const subsampleNumbers = _.map(splitMarkedSubsamples[id], "quantifiedRegionNumber");
										subsampleTypeNumbers[id] = subsampleNumbers.sort((a, b) => a - b);

										const notesSet = _.uniq(_.map(splitMarkedSubsamples[id], "notes"));

										notes += _.reduce(notesSet, (acc, n) => (n ? acc + n + ", " : ""), "");
									}

									// taken from https://stackoverflow.com/questions/2270910/how-to-reduce-consecutive-integers-in-an-array-to-hyphenated-range-expressions
									const getRanges = (array) => {
										var ranges = [],
											rstart,
											rend;
										for (var i = 0; i < array.length; i++) {
											rstart = array[i];
											rend = rstart;
											while (array[i + 1] - array[i] == 1) {
												rend = array[i + 1]; // increment the index if the numbers sequential
												i++;
											}
											ranges.push(rstart === rend ? "S" + rstart + "" : "S" + rstart + "–S" + rend);
										}
										return ranges;
									};

									_.map(Object.keys(subsampleTypeNumbers), (key) => {
										subsampleTypeNumbers[key] = getRanges(subsampleTypeNumbers[key]);
									});

									notes = notes.slice(0, notes.length - 2);

									let level = "Partial";

									if (checkIfAll(splitMarkedSubsamples)) {
										level = "Entire Plot";
									}

									timeframeStatus.push({
										status: statusName,
										level: level,
										notes: notes,
										quantifiedRegionNames: subsampleTypeNumbers,
										statusOrder: statusOrder,
										levelOrder: level === "Partial" ? 1 : 0,
										isAllData: markedPlotSubsamples[0]?.isAllData,
										annotationClassifier: markedPlotSubsamples[0]?.annotationClassifier,
										modifiedBy: markedPlotSubsamples[0]?.modifiedBy,
										modifiedDateTime: moment(markedPlotSubsamples[0]?.modifiedDateTime).local().format("MM/DD/YY"),
									});
								}
							};

							learnStatus(excludedPlotSubsamples, "Excluded", 0);
							learnStatus(flaggedPlotSubsamples, "Flagged", 1);

							const dateAndTime = new Date(markedPlotSubsamples[0].dateAndTime).getTime();
							if (learnedStatuses[dateAndTime]) {
								learnedStatuses[dateAndTime].push(...timeframeStatus);
							} else {
								learnedStatuses[dateAndTime] = timeframeStatus;
							}
						}
					}
				}

				let sortedLearnedStatuses = Object.keys(learnedStatuses).sort().reverse();

				sortedLearnedStatuses.unshift(sortedLearnedStatuses.pop());

				sortedLearnedStatuses = sortedLearnedStatuses.reduce((acc, cur) => {
					acc[cur] = learnedStatuses[cur];
					return acc;
				}, {});

				let displayStatus = _.sortBy(_.flattenDeep(Object.values(learnedStatuses)), ["statusOrder", "levelOrder"])[0];

				if (displayStatus) {
					let defLabelToAdd = {
						type: "Feature",
						properties: {
							name:
								displayStatus.level === "Partial" && displayStatus.status === "Excluded"
									? "PartiallyExcluded"
									: displayStatus.level === "Partial" && displayStatus.status === "Flagged"
										? "PartiallyFlagged"
										: displayStatus.status,
							field: plot.properties.field,
							type: "plotLabel",
							color:
								displayStatus.status === "Flagged"
									? "#ffa500"
									: displayStatus.status === "Excluded"
										? "#d03f2c"
										: "#ff0000",
							statuses: sortedLearnedStatuses,
							plotName: plot.properties.name ?? "",
						},
						geometry: {
							type: "Point",
							coordinates: paddedLowerLeft,
						},
					};
					defCollection.features.push(defLabelToAdd);
				}
			});

			let defId = crypto.randomUUID();
			canvas.addSource(defId, {
				type: "geojson",
				data: defCollection,
			});

			canvas.addLayer({
				id: `def-labels`,
				type: "symbol",
				source: defId,
				layout: {
					"icon-image": ["get", "name"],
					"icon-size": ["interpolate", ["linear"], ["zoom"], visibleAtZoom - 5.5, 0, visibleAtZoom, size],
					"icon-allow-overlap": true,
				},
				paint: {
					"icon-color": ["get", "color"],
				},
			});
		} else {
			if (canvas.getLayer(`def-labels`)) {
				canvas.removeLayer(`def-labels`);
			}
		}

		if (controlComponentRefs?.defMarkerToggleRef?.current) {
			controlComponentRefs.defMarkerToggleRef.current.setToggleState(!defMarkersToggle);
		}
		defMarkersToggle = !defMarkersToggle;
	}
}

// Event fired when add field button is clicked
export function addField(draw, measureDistanceRef) {
	if (!disableModifying) {
		if (draw.current) {
			if (fieldCombined.length > 0) {
				uncombinePlotsInField(draw, false);
			}

			measureDistanceRef.current.setActive(false);
			draw.current.draw.changeMode("new_field_mode");

			toast.info("Select the lower left position of the field", {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
			});
		}
	} else {
		toast.error("Cannot modify field while images are being processed", {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
		});
	}
}

// Rotate feature right
export function rotateRight(draw, orthoAnalyzedModal, dataLayerDeleteModal, e) {
	if (draw.current) {
		if (
			draw.current.draw.getSelected().features.length !== 0 &&
			draw.current.draw.getSelected().features[0].properties.type !== "pivot"
		) {
			let featuresToRotate = draw.current.draw.getSelected().features;
			let isFieldSelected = _.map(featuresToRotate, "properties.type").includes("field");
			let nonFieldsToRotate = [];
			let rotateWithPivot = [];
			_.map(featuresToRotate, (feature) => {
				(feature.properties.type === "field" ||
					feature.properties.type === "subsample" ||
					feature.properties.type === "plot" ||
					feature.properties.type === "row") &&
				isFieldSelected
					? rotateWithPivot.push(feature)
					: nonFieldsToRotate.push(feature);
			});

			_.map(rotateWithPivot, (feature) => {
				let fieldId =
					feature.properties.field ??
					_.find(allFields, (f) => f.properties.plotIds.includes(feature.properties.plotId)).id;

				let options = {
					pivot: _.find(fieldPivotPoints, { id: fieldId }).pivot.geometry.coordinates,
				};
				feature = turf.transformRotate(
					feature,
					(0.0375 / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1),
					options,
				);
				draw.current.draw.add(feature);

				updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
			});

			_.map(nonFieldsToRotate, (feature) => {
				feature = turf.transformRotate(
					feature,
					(0.075 / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1),
				);

				draw.current.draw.add(feature);

				updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
			});
		} else {
			toast.warn("Please select a feature to rotate");
		}
	}
}

// Rotate feature left
export function rotateLeft(draw, orthoAnalyzedModal, dataLayerDeleteModal, e) {
	if (draw.current) {
		if (
			draw.current.draw.getSelected().features.length !== 0 &&
			draw.current.draw.getSelected().features[0].properties.type !== "pivot"
		) {
			let featuresToRotate = draw.current.draw.getSelected().features;
			let isFieldSelected = _.map(featuresToRotate, "properties.type").includes("field");
			let nonFieldsToRotate = [];
			let rotateWithPivot = [];
			_.map(featuresToRotate, (feature) => {
				(feature.properties.type === "field" ||
					feature.properties.type === "subsample" ||
					feature.properties.type === "plot" ||
					feature.properties.type === "row") &&
				isFieldSelected
					? rotateWithPivot.push(feature)
					: nonFieldsToRotate.push(feature);
			});

			_.map(rotateWithPivot, (feature) => {
				let fieldId =
					feature.properties.field ??
					_.find(allFields, (f) => f.properties.plotIds.includes(feature.properties.plotId)).id;

				let options = {
					pivot: _.find(fieldPivotPoints, { id: fieldId }).pivot.geometry.coordinates,
				};
				feature = turf.transformRotate(
					feature,
					(-0.075 / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1),
					options,
				);
				draw.current.draw.add(feature);

				updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
			});

			_.map(nonFieldsToRotate, (feature) => {
				feature = turf.transformRotate(
					feature,
					(-0.075 / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1),
				);

				draw.current.draw.add(feature);

				updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
			});
		} else {
			toast.warn("Please select a feature to rotate");
		}
	}
}

// Gracefully handles combining plots
export function combine(e) {
	if (e.createdFeatures[0].properties.type !== "row") {
		fieldCombined.push(e.createdFeatures[0].id);
	} else {
		rowsCombined.push(e.createdFeatures[0].id);
	}
}

// Gracefully handles uncombining plots
export function uncombine(e, draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	let createdFields = _.uniqBy(e.createdFeatures, (cf) => cf.properties.field);

	_.map(createdFields, (cf, fieldIndex) => {
		if (!cf.properties.locked) {
			let matchingField = _.find(allFields, (af) => af.properties.field === cf.properties.field);
			_.map(cf.properties.plotIds, (id, index) => {
				let matchingPlotIndex = _.findIndex(allPlots, (ap) => ap.id === id);
				if (matchingPlotIndex !== -1) {
					allPlots[matchingPlotIndex].geometry.coordinates =
						e.deletedFeatures[fieldIndex].geometry.coordinates[index + 1]; // Skip the first index as that is the field drawing
					allPlots[matchingPlotIndex].properties.isDirty = true;
					allPlots[matchingPlotIndex].properties.scaleFactor = matchingField?.properties.scaleFactor;
				}
			});
		}
	});

	let rowFeatures = _.filter(e.createdFeatures, ({ properties }) => properties.type === "row");
	let adjustedRows = _.find(e.deletedFeatures, ({ geometry }) => geometry.type === "MultiLineString");
	_.map(rowFeatures, ({ properties }, rowIndex) => {
		let matchingRowIndex = _.findIndex(
			allRows,
			(ar) => ar.properties.rowNumber === properties.rowNumber && ar.properties.plot === properties.plot,
		);

		allRows[matchingRowIndex].geometry.coordinates = adjustedRows.geometry.coordinates[rowIndex];
	});

	// Delete newly created plots
	draw.current.draw.delete(_.map(e.createdFeatures, "id"));
	refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
}

// Adds labels to fields
export function fieldLabelToggle(
	draw,
	canvas,
	controlComponentRefs,
	moduleNavigation,
	dropdownRef,
	level,
	hasEditAccess = true,
) {
	if (canvas) {
		if (!fieldLabelsToggle && !canvas.getLayer("field-labels")) {
			if (fieldsDirty) {
				recalculateFieldBoundaries();
			}

			let fieldsToLabel = _.cloneDeep(allFields);
			if (singleFeatureToggle && selectedFieldId) {
				fieldsToLabel = _.filter(fieldsToLabel, { id: selectedFieldId });
			}

			if (cropToFilterOn !== "all") {
				fieldsToLabel = _.filter(fieldsToLabel, (f) => f.properties.crop === cropToFilterOn);
			}

			const currentZoom = canvas.getZoom();

			fieldsToLabel.forEach((field) => {
				const el = document.createElement("div");
				el.innerHTML = field.properties.name.replaceAll(/_/g, "_<wbr>").replaceAll(/-/g, "-<wbr>");
				el.className = "fieldLabel";

				let anchor = turf.centroid(field).geometry.coordinates;
				let fieldPoint = turf.point(anchor);

				_.map(labelMarkers.trials, (t) => {
					let trialAnchor = t.getLngLat();
					let labelDist = turf.distance(fieldPoint, turf.point([trialAnchor.lng, trialAnchor.lat]), {
						units: "meters",
					});
					if (labelDist < 1) {
						let viewportBearing = canvas.getBearing();
						anchor = turf.destination(fieldPoint, 8, viewportBearing - 45, { units: "meters" }).geometry.coordinates;
						return;
					}
				});

				labelMarkers.fields[field.id] = new MapboxGl.Marker(el)
					.setLngLat(anchor)
					.setPopup(
						new MapboxGl.Popup()
							.setHTML(
								`
						<div class="popupContent">
							<div class="popupRow">
								<i class="icon magnify" id="field-magnify-icon" style="cursor: pointer"></i>
								<span>${field.properties.name}</span>
								<div style="flex-grow: 2; min-width: 20px"></div>
								${
									level !== "field" && hasEditAccess
										? `<a id="field-viewer-icon" href="${moduleNavigation.createFieldLink(
												true,
												field.id,
												"viewer",
											)}" target="_blank" style="color: black">
										<div class="tooltip">Viewer</div>
										<i class="binoculars large icon" style="cursor: pointer"></i>
								</a>`
										: ""
								}
								${
									hasEditAccess
										? `<a id="field-edit-icon" href="${moduleNavigation.createFieldLink(
												true,
												field.id,
												"edit",
											)}" target="_blank" style="color: black">
											<div class="tooltip">Edit</div>
											<i class="pencil large icon" style="cursor: pointer"></i>
									</a>`
										: ""
								}
								
							</div>
							<div class="popupRow">
								<span>${field.properties.ranges} Rg x ${field.properties.columns} Col</span>
								<div style="flex-grow: 2"></div>
								<span>${field.properties.crop}</span>
							</div>
						</div>
						`,
							)
							.setMaxWidth("800px")
							.setOffset({ center: 0 })
							.on("open", () => {
								document.getElementById("field-magnify-icon").addEventListener("click", () => {
									if (!selectedFieldId) {
										zoomToField(draw, canvas, field.id, dropdownRef, controlComponentRefs, level, moduleNavigation);
									} else {
										//-- At farm level, this will reset the map as well as update the dropdown list
										if (level === "farm") {
											dropdownRef.current.innerRef.current.setSelectedFieldOption("all");
										} else {
											resetOrientation(canvas, level, draw, dropdownRef, controlComponentRefs, moduleNavigation);
										}
									}
								});
							})
							.addClassName("fieldMarkerPopup"),
					)
					.addTo(canvas);

				if (currentZoom >= 19) {
					labelMarkers.fields[field.id].getElement().classList.remove("small");
				} else {
					labelMarkers.fields[field.id].getElement().classList.add("small");
				}

				if (currentZoom >= 15) {
					labelMarkers.fields[field.id].getElement().classList.remove("hidden");
				} else {
					labelMarkers.fields[field.id].getElement().classList.add("hidden");
				}
			});

			canvas.on("zoom", () => {
				const zoom = canvas.getZoom();

				Object.values(labelMarkers.fields).forEach((label) => {
					const classList = label.getElement().classList;
					if (zoom >= 19) {
						classList.remove("small");
					} else {
						classList.add("small");
					}
					if (zoom >= 15) {
						classList.remove("hidden");
					} else {
						classList.add("hidden");
					}
				});
			});

			if (controlComponentRefs?.fieldLabelToggleRef?.current)
				controlComponentRefs.fieldLabelToggleRef.current.setToggleState(true);
		} else {
			Object.values(labelMarkers.fields).forEach((label) => label.remove());
			labelMarkers.fields = {};
			if (controlComponentRefs?.fieldLabelToggleRef?.current)
				controlComponentRefs.fieldLabelToggleRef.current.setToggleState(false);
		}

		fieldLabelsToggle = !fieldLabelsToggle;
	}
}

// Adds labels to trials
export function trialLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	if (canvas) {
		if (!trialLabelsToggle) {
			recalculateTrialBoundaries(false);

			let trialsToLabel = _.cloneDeep(allTrials);
			if (singleFeatureToggle && selectedTrialId) {
				trialsToLabel = _.filter(trialsToLabel, { id: selectedTrialId });
			} else if (singleFeatureToggle && selectedFieldId) {
				trialsToLabel = _.filter(trialsToLabel, { properties: { field: selectedFieldId } });
			}

			if (cropToFilterOn !== "all") {
				trialsToLabel = _.filter(trialsToLabel, (t) => t.properties.crop === cropToFilterOn);
			}

			const currentZoom = canvas.getZoom();

			trialsToLabel.forEach((trial) => {
				const el = document.createElement("div");
				el.innerHTML = trial.properties.name.replaceAll(/_/g, "_<wbr>").replaceAll(/-/g, "-<wbr>");
				el.className = "trialLabel";

				let anchor = turf.centroid(trial).geometry.coordinates;
				let trialPoint = turf.point(anchor);

				_.map(labelMarkers.fields, (t) => {
					let fieldAnchor = t.getLngLat();
					let labelDist = turf.distance(trialPoint, turf.point([fieldAnchor.lng, fieldAnchor.lat]), {
						units: "meters",
					});
					if (labelDist < 1) {
						let viewportBearing = canvas.getBearing();
						anchor = turf.destination(trialPoint, 8, viewportBearing + 45, { units: "meters" }).geometry.coordinates;
						return;
					}
				});

				labelMarkers.trials[trial.id] = new MapboxGl.Marker(el)
					.setLngLat(anchor)
					.setPopup(
						new MapboxGl.Popup()
							.setHTML(
								`
						<div class="popupContent">
							<div class="popupRow">
								<i class="icon magnify" id="trial-magnify-icon" style="cursor: pointer"></i>
								<span>${trial.properties.name}</span>
								<div style="flex-grow: 2; min-width: 20px"></div>
								${
									level !== "trial"
										? `<a id="trial-viewer-icon" href="${moduleNavigation.createTrialLink(
												true,
												trial.id,
												"viewer",
											)}" target="_blank" style="color: black">
											<div class="tooltip">Viewer</div>
											<i class="binoculars large icon" style="cursor: pointer"></i>
									</a>`
										: ""
								}
								<a id="trial-edit-icon" href="${moduleNavigation.createTrialLink(
									true,
									trial.id,
									"edit",
								)}" target="_blank" style="color: black">
										<div class="tooltip">Edit</div>
										<i class="pencil large icon" style="cursor: pointer"></i>
								</a>
								<a id="trial-analysis-icon" href="${moduleNavigation.createTrialLink(
									true,
									trial.id,
									"analysis",
								)}" target="_blank" style="color: black">
										<div class="tooltip">Analysis</div>
										<i class="chart bar outline large icon" style="cursor: pointer"></i>
								</a>
							</div>
							<div class="popupRow">
								<span>${trial.properties.ranges} Rg x ${trial.properties.columns} Col</span>
								<div style="flex-grow: 1"></div>
								<span>${trial.properties.treatments} Trt x ${trial.properties.replicates} Rep</span>
								<div style="flex-grow: 1"></div>
								<span>${trial.properties.crop}</span>
							</div>
						</div>
						`,
							)
							.setMaxWidth("800px")
							.setOffset({ center: 0 })
							.on("open", () => {
								document.getElementById("trial-magnify-icon").addEventListener("click", () => {
									if (!selectedTrialId) {
										zoomToTrial(draw, canvas, trial.id, dropdownRef, controlComponentRefs, level, moduleNavigation);
									} else {
										//-- At farm level, this will reset the map as well as update the dropdown list
										if (level === "farm") {
											dropdownRef.current.innerRef.current.setSelectedTrialOption("all");
										} else {
											resetOrientation(canvas, level, draw, dropdownRef, controlComponentRefs, moduleNavigation);
										}
									}
								});
							})
							.addClassName("trialMarkerPopup"),
					)
					.addTo(canvas);

				if (currentZoom >= 19) {
					labelMarkers.trials[trial.id].getElement().classList.remove("small");
				} else {
					labelMarkers.trials[trial.id].getElement().classList.add("small");
				}

				if (currentZoom >= 17) {
					labelMarkers.trials[trial.id].getElement().classList.remove("hidden");
				} else {
					labelMarkers.trials[trial.id].getElement().classList.add("hidden");
				}
			});

			canvas.on("zoom", () => {
				const zoom = canvas.getZoom();

				Object.values(labelMarkers.trials).forEach((label) => {
					const classList = label.getElement().classList;
					if (zoom >= 19) {
						classList.remove("small");
					} else {
						classList.add("small");
					}
					if (zoom >= 17) {
						classList.remove("hidden");
					} else {
						classList.add("hidden");
					}
				});
			});
		} else {
			Object.values(labelMarkers.trials).forEach((label) => label.remove());
			labelMarkers.trials = {};
		}

		trialLabelsToggle = !trialLabelsToggle;
	}
}

export async function lockToggle(draw, canvas, dropdownRef, controlComponentRefs, moduleNavigation, level) {
	if (allFields?.length > 0) {
		if (!disableModifying) {
			let multipleFieldIds = draw.current.draw.getSelected().features;
			if (multipleFieldIds.length > 0) {
				// Returns list of field ids for selected field drawings
				multipleFieldIds = _.map(
					_.map(
						_.filter(multipleFieldIds, ({ properties }) => {
							return properties.type === "field";
						}),
						"properties",
					),
					"field",
				);
			} else {
				if (!selectedFieldId) {
					selectedFieldId = _.last(allFields).id;
				}

				multipleFieldIds = [selectedFieldId];
			}

			if (fieldCombined.length > 0) {
				uncombinePlotsInField(draw, false);
			}

			// Recreating the field ddl
			let thirdDropdownList = dropdownRef.current.innerRef.current.currentThirdDropdownOptions();
			let modifiedList = _.filter(thirdDropdownList, ({ key }) => {
				if (!multipleFieldIds.includes(key)) return true;
			});

			_.forEach(multipleFieldIds, (fieldId) => {
				let fieldName = null;
				let isFieldLocking = false;

				let plotIds = [];
				_.map(allPlots, (plot) => {
					if (plot.properties.field === fieldId) {
						if (plot.properties.locked) {
							plot.properties.portColor = "#ffb820";
						} else {
							isFieldLocking = true;
							plot.properties.portColor = "#0ac944";
						}
						fieldName = plot.properties.fieldName;
						plot.properties.locked = !plot.properties.locked;

						plotIds.push(plot.id);
					}
				});

				let fieldIndex = _.findIndex(allFields, (af) => af.properties.field === fieldId);
				if (fieldIndex !== -1) {
					allFields[fieldIndex].properties.locked = isFieldLocking;
					allFields[fieldIndex].properties.portColor = isFieldLocking ? "#03fcf8" : "#FF0000";
				}

				let matchingFeature = _.find(draw.current.draw.getAll().features, (f) => f.properties.field === fieldId);
				if (matchingFeature !== -1) {
					matchingFeature.properties.locked = isFieldLocking;
					matchingFeature.properties.portColor = isFieldLocking ? "#03fcf8" : "#FF0000";

					draw.current.draw.add(matchingFeature);
				}

				modifiedList.push({
					key: fieldId,
					value: fieldId,
					text: fieldName,
					icon: (
						<>
							<Icon
								style={{ float: "right" }}
								name="trash"
								link
								onClick={(e) => dropdownRef.current.innerRef.current.handleDeleteClick(e, fieldId)}
							/>
							<Icon style={{ float: "right" }} name={isFieldLocking ? "check" : "warning"} />
						</>
					),
				});

				if (isFieldLocking) {
					if (controlComponentRefs.lockToggleRef && controlComponentRefs.lockToggleRef.current) {
						controlComponentRefs.lockToggleRef.current.setLocked(true);
					}

					toast.success("Field " + fieldName + " was locked successfully");
				} else {
					if (controlComponentRefs.lockToggleRef && controlComponentRefs.lockToggleRef.current) {
						controlComponentRefs.lockToggleRef.current.setLocked(false);
					}

					toast.success("Field " + fieldName + " was unlocked successfully");
				}
			});

			dropdownRef.current.innerRef.current.setThirdDropdownOptions(modifiedList);
			refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		} else {
			toast.error("Cannot modify field while images are being processed");
		}
	}
}

// Nudging plots
export function movePlot(dir, draw, canvas, orthoAnalyzedModal, dataLayerDeleteModal, level, edit, viewer, e) {
	if (draw.current) {
		if (level === "field" && dir === "Shift") {
			let selectedFeatures = draw.current.draw.getSelected().features;
			draw.current.draw.changeMode("simple_select", {
				featureIds: _.map(
					_.filter(selectedFeatures, ({ properties }) => {
						return properties.type !== "field";
					}),
					"id",
				),
			});
		} else if (dir !== "Shift" && level === "flight" && !(edit && viewer)) {
			let collection = draw.current.draw.getSelectedIds();
			let allFeatures = draw.current.draw.getAll();
			let movementMetric = (0.00000055625 / 2 / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1); // Roughly 1/10 of a foot - 1/20 for fine control
			let offsetX = 0,
				offsetY = 0,
				denominator = 0,
				viewportDir = null;
			let viewportBearing = canvas.getBearing();
			if (viewportBearing >= 0 && viewportBearing <= 90) {
				denominator = 90;
				viewportDir = "ne";
				offsetX = movementMetric * (viewportBearing / denominator);
				offsetY = movementMetric - offsetX;
			} else if (viewportBearing >= 90 && viewportBearing <= 180) {
				denominator = 90;
				viewportBearing -= 90;
				viewportDir = "se";
				offsetX = movementMetric * (viewportBearing / denominator);
				offsetY = movementMetric - offsetX;
			} else if (viewportBearing <= 0 && viewportBearing >= -90) {
				denominator = -90;
				viewportDir = "nw";
				offsetX = Math.abs(movementMetric * (viewportBearing / denominator));
				offsetY = movementMetric - offsetX;
			} else if (viewportBearing <= -90 && viewportBearing >= -180) {
				denominator = -90;
				viewportBearing += 90;
				viewportDir = "sw";
				offsetX = Math.abs(movementMetric * (viewportBearing / denominator));
				offsetY = movementMetric - offsetX;
			}

			if (collection.length > 0) {
				collection.forEach((feature) => {
					let indexOfFeatureToUpdate = allFeatures.features.findIndex((filtered) => filtered.id === feature),
						featureToUpdate = allFeatures.features[indexOfFeatureToUpdate];

					if (featureToUpdate.geometry.type === "MultiPolygon") {
						featureToUpdate.geometry.coordinates.forEach((feature) => {
							feature[0].forEach((coordinate) => {
								arrowSwitches(viewportDir, dir, coordinate, offsetX, offsetY);
							});
						});
					} else if (featureToUpdate.geometry.type === "Polygon") {
						featureToUpdate.geometry.coordinates[0].forEach((coordinate) => {
							arrowSwitches(viewportDir, dir, coordinate, offsetX, offsetY);
						});
					} else if (featureToUpdate.geometry.type === "LineString") {
						featureToUpdate.geometry.coordinates.forEach((coordinate) => {
							arrowSwitches(viewportDir, dir, coordinate, offsetX, offsetY);
						});
					} else if (featureToUpdate.geometry.type === "MultiLineString") {
						featureToUpdate.geometry.coordinates.forEach((feature) => {
							feature.forEach((coordinate) => {
								arrowSwitches(viewportDir, dir, coordinate, offsetX, offsetY);
							});
						});
					} else {
						arrowSwitches(viewportDir, dir, featureToUpdate.geometry.coordinates, offsetX, offsetY);
					}
				});

				draw.current.draw.set(allFeatures);
				updateArea(draw, false, orthoAnalyzedModal, dataLayerDeleteModal);
			}
		}
	}
}

function arrowSwitches(viewportDir, dir, coordinate, offsetX, offsetY) {
	switch (viewportDir) {
		case "ne":
			switch (dir) {
				case "ArrowUp":
					coordinate[0] += offsetX;
					coordinate[1] += offsetY;
					break;
				case "ArrowDown":
					coordinate[0] -= offsetX;
					coordinate[1] -= offsetY;
					break;
				case "ArrowLeft":
					coordinate[0] -= offsetY;
					coordinate[1] += offsetX;
					break;
				case "ArrowRight":
					coordinate[0] += offsetY;
					coordinate[1] -= offsetX;
					break;
				default:
					break;
			}
			break;
		case "se":
			switch (dir) {
				case "ArrowUp":
					coordinate[0] += offsetY;
					coordinate[1] -= offsetX;
					break;
				case "ArrowDown":
					coordinate[0] -= offsetY;
					coordinate[1] += offsetX;
					break;
				case "ArrowLeft":
					coordinate[0] += offsetX;
					coordinate[1] += offsetY;
					break;
				case "ArrowRight":
					coordinate[0] -= offsetX;
					coordinate[1] -= offsetY;
					break;
				default:
					break;
			}
			break;
		case "nw":
			switch (dir) {
				case "ArrowUp":
					coordinate[0] -= offsetX;
					coordinate[1] += offsetY;
					break;
				case "ArrowDown":
					coordinate[0] += offsetX;
					coordinate[1] -= offsetY;
					break;
				case "ArrowLeft":
					coordinate[0] -= offsetY;
					coordinate[1] -= offsetX;
					break;
				case "ArrowRight":
					coordinate[0] += offsetY;
					coordinate[1] += offsetX;
					break;
				default:
					break;
			}
			break;
		case "sw":
			switch (dir) {
				case "ArrowUp":
					coordinate[0] -= offsetY;
					coordinate[1] -= offsetX;
					break;
				case "ArrowDown":
					coordinate[0] += offsetY;
					coordinate[1] += offsetX;
					break;
				case "ArrowLeft":
					coordinate[0] += offsetX;
					coordinate[1] -= offsetY;
					break;
				case "ArrowRight":
					coordinate[0] -= offsetX;
					coordinate[1] += offsetY;
					break;
				default:
					break;
			}
			break;
		default:
			break;
	}

	//-- Round coordinates to 7 decimals
	coordinate = [applyPrecision(coordinate[0]), applyPrecision(coordinate[1])];
}

// Click event handler.
export function handleClickEvent(draw, canvas, dropdownRef, componentRefs, level, event, moduleNavigation) {
	//-- No event on right clicks
	let highestLevelFeatureIsPlot = [];
	let highestLevelFeatureIsSubsample = [];

	let features = draw.current.draw.getSelected().features;

	if (
		event &&
		["direct_select", "simple_select"].includes(draw.current.draw.getMode()) &&
		!_.some(features, (f) => f.properties.meta === "drawn_feature")
	) {
		//-- Get all features at the click location
		let featuresAtClick = canvas.queryRenderedFeatures(event.point, {
			layers: ["gl-draw-polygon-fill-inactive.cold", "gl-draw-polygon-fill-active.hot"],
		});

		let selectedFeatureIds = [];

		if (event.originalEvent.shiftKey) {
			selectedFeatureIds = [..._.map(features, "id")];
		}

		//-- See if a subsample exists at the click location
		let subsampleExists = _.some(_.map(featuresAtClick, "properties"), (f) => f.user_type == "subsample");

		//-- Remove features on hot layer
		//-- This is the layer that has selected features on it
		featuresAtClick = _.filter(featuresAtClick, (f) => !f.source.includes("hot"));

		//-- if subsample doesn't exist, check if plot does
		if (!subsampleExists) {
			highestLevelFeatureIsPlot = _.filter(_.map(featuresAtClick, "properties"), (f) => f.user_type == "plot");

			//-- Remove any subsamples that are selected
			let allPlotIds = _.map(allPlots, "id");
			selectedFeatureIds = _.filter(selectedFeatureIds, (id) => allPlotIds.includes(id));

			selectedFeatureIds = [...selectedFeatureIds, ..._.map(highestLevelFeatureIsPlot, "id")];

			if (highestLevelFeatureIsPlot.length > 0) {
				draw.current.draw.changeMode("simple_select", { featureIds: selectedFeatureIds });
			}
		} else {
			//-- Remove any plots that are selected; only want one type selected
			let allPlotIds = _.map(allPlots, "id");
			selectedFeatureIds = _.filter(selectedFeatureIds, (id) => !allPlotIds.includes(id));

			highestLevelFeatureIsSubsample = _.filter(
				_.map(featuresAtClick, "properties"),
				(f) => f.user_type == "subsample",
			);
			selectedFeatureIds = [...selectedFeatureIds, ..._.map(highestLevelFeatureIsSubsample, "id")];
			draw.current.draw.changeMode("simple_select", { featureIds: selectedFeatureIds });
		}
	}

	features = draw.current.draw.getSelected().features;

	let fields = _.filter(features, ({ properties }) => {
		return properties.type === "field";
	});

	if (
		(features.length === 0 ||
			(features[0].geometry.type !== "MultiPolygon" && features[0].geometry.type !== "Point")) &&
		fieldCombined.length !== 0
	) {
		uncombinePlotsInField(draw, true);
	}

	if (
		features.length > 0 &&
		features[0].geometry.type !== "MultiPolygon" &&
		features[0].geometry.type !== "Point" &&
		features[0].properties.type !== "field" &&
		(features[0].properties.type === "plot" || features[0].properties.type === "subsample")
	) {
		componentRefs.flagPlotsRef?.current?.setDisabled(false);

		if (features[0].properties.type === "plot") {
			componentRefs.flagPlotsRef?.current?.isSubsample(false);
		} else {
			componentRefs.flagPlotsRef?.current?.isSubsample(true);
		}
	} else {
		componentRefs.flagPlotsRef?.current?.setDisabled(true);
	}

	if (
		features.length > 0 &&
		features[0].geometry.type !== "MultiPolygon" &&
		features[0].geometry.type !== "Point" &&
		features[0].properties.type === "field"
	) {
		if (componentRefs.alignPlotsRef.current) {
			componentRefs.alignPlotsRef.current.setDisabled(false);
		}

		if (componentRefs.editFieldModal.current) {
			componentRefs.editFieldModal.current.setDisabled(false);
		}
	} else {
		if (componentRefs.alignPlotsRef.current) {
			componentRefs.alignPlotsRef.current.setDisabled(true);
		}

		if (componentRefs.editFieldModal.current) {
			componentRefs.editFieldModal.current.setDisabled(true);
		}
	}

	if (_.findIndex(allRows, { id: draw.current.draw.getSelectedIds()[0] }) !== -1) {
		selectPlotFromRow(draw, draw.current.draw.getSelectedIds()[0], componentRefs);
	} else {
		if (
			features.length === 1 &&
			features[0].geometry.type === "Point" &&
			features[0].properties.type !== "pivot" &&
			features[0].properties.meta !== "vertex" &&
			features[0].properties.meta !== "drawn_feature"
		) {
			if (fieldCombined.length > 0) {
				let fieldId = _.find(allLLPoints, { id: draw.current.draw.getSelectedIds()[0] }).properties.field;
				uncombinePlotsInField(draw, false);
				zoomToField(draw, canvas, fieldId, dropdownRef, componentRefs, level, moduleNavigation);
			} else {
				zoomToField(draw, canvas, undefined, dropdownRef, componentRefs, level, moduleNavigation);
			}
		}

		if (
			features.length === 1 &&
			features[0].properties.type === "plot" &&
			highestLevelFeatureIsSubsample.length === 0 &&
			rowsToggle
		) {
			let plotId = features[0].id;
			let rowId = _.filter(allRows, ({ properties }) => {
				return properties.plot === plotId;
			})[0].id;

			selectPlotFromRow(draw, rowId, componentRefs);
		}

		// Greater than 1 field means combine multiple fields
		_.map(fields, (f, index) => {
			if (f.geometry.type !== "MultiPolygon" && level === "flight") {
				selectedFieldId = f.id;
				index > 0 ? combinePlotsInField(draw, true, componentRefs) : combinePlotsInField(draw, false, componentRefs);
			}
		});
	}
}

// Zooms to field of given field id
function zoomToField(draw, canvas, fieldId, dropdownRef, componentRefs, level, moduleNavigation) {
	if (fieldId === undefined) {
		let indexOfLLPoint = _.findIndex(allLLPoints, {
			id: draw.current.draw.getSelectedIds()[0],
		});

		if (_.map(allLLPoints, "properties.field") !== _.map(allFields, "id")) {
			lowerLeftToggle(draw); // resyncs ll points with field ids
			if (!llToggle) {
				// make sure ll points are on if not
				lowerLeftToggle(draw);
			}
		}

		selectedFieldId = allLLPoints[indexOfLLPoint].properties.field;
	} else {
		selectedFieldId = fieldId;
	}

	if (dropdownRef && level === "flight") {
		dropdownRef.current.innerRef.current.setThirdDropdownId(selectedFieldId);
	}

	if (dropdownRef && level === "farm") {
		dropdownRef.current.innerRef.current.setSelectedFieldOption(selectedFieldId);
	}

	toggleSingleFieldTrial(draw, canvas, "field", componentRefs, moduleNavigation, dropdownRef, level);
	fitToHeight(canvas, level, true);

	if (componentRefs?.alignPlotsRef?.current) {
		componentRefs.alignPlotsRef.current.setDisabled(true);
	}

	if (componentRefs?.lockToggleRef?.current) {
		let locked = _.find(allFields, { id: selectedFieldId }).properties.locked;
		componentRefs.lockToggleRef.current.setLocked(locked);
	}
}

function zoomToTrial(draw, canvas, trialId, dropdownRef, componentRefs, level, moduleNavigation) {
	selectedTrialId = trialId;

	if (dropdownRef && level === "flight") {
		dropdownRef.current.innerRef.current.setThirdDropdownId(selectedTrialId);
	}

	if (dropdownRef && level === "farm") {
		dropdownRef.current.innerRef.current.setSelectedTrialOption(selectedTrialId);
	}

	toggleSingleFieldTrial(draw, canvas, "trial", componentRefs, moduleNavigation, dropdownRef, level);
	fitToHeight(canvas, "trial", true);
}

// Called every update event. Updates plots if need to
function updateArea(draw, feature, modal, dataLayerDeleteModal) {
	let features = feature ? [feature] : draw.current.draw.getSelected().features;
	if (features?.length > 0) {
		if (features[0].properties.type !== "pivot") {
			if (features.some((x) => x.properties.locked)) {
				toast.warn("Your changes to this feature will not be saved while it's locked");
				return false;
			}

			let plotHasAnalysisData = false;
			let plotCollectionIndex = _.findIndex(
				features,
				({ properties }) => properties.type === "field" || properties.type === "trial",
			);

			//-- Catches if field/trial AND plots exist in selection
			if (plotCollectionIndex !== -1 && _.some(features, ({ properties }) => properties.type === "plot")) {
				features = _.filter(features, ({ properties }) => properties.type !== "field" && properties.type !== "trial");
				plotCollectionIndex = -1;
			}

			if (plotCollectionIndex !== -1) {
				let fieldPlots = _.filter(allPlots, (ap) => features[plotCollectionIndex].properties.plotIds.includes(ap.id));
				let fieldId = features[plotCollectionIndex].properties.field;
				if (fieldPlots.some((x) => x.properties.analyzed)) {
					plotHasAnalysisData = true;
					modal.current.updateFieldId(fieldId);
					modal.current.updateActiveElement(document.activeElement);
					modal.current.updateDraw(draw);
					modal.current.updateFeature(feature);
					modal.current.openModal();
				}

				if (firstFlightFields?.includes(fieldId)) {
					dataLayerDeleteModal.current.updateFieldId(fieldId);
					dataLayerDeleteModal.current.updateActiveElement(document.activeElement);
					dataLayerDeleteModal.current.openModal();
				}
			} else if (features[0].properties.type === "plot") {
				let fieldId = features[0].properties.field;
				if (features.some((x) => x.properties.analyzed)) {
					plotHasAnalysisData = true;
					modal.current.updateFieldId(fieldId);
					modal.current.updateActiveElement(document.activeElement);
					modal.current.updateDraw(draw);
					modal.current.updateFeature(feature);
					modal.current.openModal();
				}

				if (firstFlightFields?.includes(fieldId)) {
					dataLayerDeleteModal.current.updateFieldId(fieldId);
					dataLayerDeleteModal.current.updateActiveElement(document.activeElement);
					dataLayerDeleteModal.current.openModal();
				}
			}

			if (!plotHasAnalysisData) {
				let plots = [];
				fieldsDirty = true;
				//-- Updates field/trial features
				if (plotCollectionIndex !== -1) {
					plots = _.filter(allPlots, (ap) => features[plotCollectionIndex].properties.plotIds.includes(ap.id));
					_.forEach(plots, (plot) => {
						plot.properties.isDirty = true;
					});
					draw.current.draw.setFeatureProperty(features[plotCollectionIndex].id, "plots", plots);
				} else {
					//-- Updates plot featuers
					_.forEach(features, ({ id, properties, geometry }) => {
						if (properties.type === "plot") {
							allPlots[_.findIndex(allPlots, { id: id })].geometry = geometry;
							allPlots[_.findIndex(allPlots, { id: id })].properties.isDirty = true;
							delete allPlots[_.findIndex(allPlots, { id: id })].properties.alignColor;
						}
					});
				}
			}
		} else {
			let index = _.findIndex(_.map(fieldPivotPoints, "pivot"), { id: features[0].id });
			fieldPivotPoints[index].pivot = features[0];
		}
	}
}

export function deleteAnalyzedData(fieldId, draw, feature) {
	_.forEach(allPlots, (plot) => {
		if (plot.properties.field === fieldId) {
			plot.properties.analyzed = false;
			plot.properties.isDirty = true;
		}
	});

	let features = feature ? [feature] : draw.current.draw.getSelected().features;
	let plots = [];
	_.forEach(features, (feature) => {
		if (feature.properties.type === "plot") {
			feature.properties.analyzed = false;
			feature.properties.isDirty = true;
			plots.push(feature);
		}
	});

	if (_.some(features, ({ properties }) => properties.type === "field")) {
		draw.current.draw.setFeatureProperty(features[0].id, "plots", plots);
	} else {
		_.map(features, ({ id, properties }) => {
			if (properties.type === "plot") {
				draw.current.draw.setFeatureProperty(id, "analyzed", false);
				draw.current.draw.setFeatureProperty(id, "isDirty", true);
			}
		});
	}

	let selectedIds = draw.current.draw.getSelectedIds();

	draw.current.draw.changeMode("simple_select", { featureIds: selectedIds });
}

export function markDataLayerFieldToDelete(fieldId) {
	if (!dataLayerFieldsToDelete.includes(fieldId)) {
		dataLayerFieldsToDelete.push(fieldId);

		firstFlightFields = _.filter(firstFlightFields, (id) => id !== fieldId);
	}
}

// Draws a new grid based on the lower left and upper left points
function drawGrid(evt, draw, canvas, dropdownRef, componentRefs, moduleNavigation) {
	let rows = fieldRanges,
		cols = fieldCols,
		plotHeight = fieldRangeLength,
		plotWidth = fieldColWidth;

	const actualWidth = plotWidth;

	//Create upper left point if upper left is not provided from field form
	if (lowerLeftLat && lowerLeftLong && !upperLeftLat && !upperLeftLong) {
		let buffer = (fieldRanges * fieldRangeLength) / 3.281 / 1000; // Convert ft to km
		let upperLeftCoordinates = turf.truncate(
			turf.destination([lowerLeftLong, lowerLeftLat], buffer, degreeHeading),
			precisionOptions,
		).geometry.coordinates;
		upperLeftLong = upperLeftCoordinates[0];
		upperLeftLat = upperLeftCoordinates[1];
	}

	let lineString = evt,
		llXCoord = lowerLeftLong && lowerLeftLong != "" ? lowerLeftLong : lineString.geometry.coordinates[0][0],
		llYCoord = lowerLeftLat && lowerLeftLat != "" ? lowerLeftLat : lineString.geometry.coordinates[0][1],
		ulXCoord = upperLeftLong && upperLeftLong != "" ? upperLeftLong : lineString.geometry.coordinates[1][0],
		ulYCoord = upperLeftLat && upperLeftLat != "" ? upperLeftLat : lineString.geometry.coordinates[1][1];

	lowerLeftLat = null;
	lowerLeftLong = null;
	upperLeftLat = null;
	upperLeftLong = null;

	let initialBearing = turf.bearing([llXCoord, llYCoord], [ulXCoord, ulYCoord]);

	let perpendicularBearing = initialBearing + 90;
	let oppositePerpBearing = initialBearing - 90;

	// Push the initial points half of the field row spacing, convert to feet, convert to km
	let llOffset = turf.truncate(
		turf.destination(turf.point([llXCoord, llYCoord]), fieldRowSpacing / 2 / 12 / 3.281 / 1000, oppositePerpBearing),
		precisionOptions,
	);
	llXCoord = llOffset.geometry.coordinates[0];
	llYCoord = llOffset.geometry.coordinates[1];

	let ulOffset = turf.destination(
		turf.point([ulXCoord, ulYCoord]),
		fieldRowSpacing / 2 / 12 / 3.281 / 1000,
		oppositePerpBearing,
	);
	ulXCoord = ulOffset.geometry.coordinates[0];
	ulYCoord = ulOffset.geometry.coordinates[1];

	let newFeatureCollection = {
		type: "FeatureCollection",
		features: [],
	};

	let xCoordinateToRotateAround = llXCoord,
		yCoordinateToRotateAround = llYCoord,
		previousRowXCoordinate = llXCoord,
		previousRowYCoordinate = llYCoord;

	_.times(rows, (rowIndex) => {
		let firstColumnInRow = true;

		_.times(cols, (colIndex) => {
			let plot = _.find(plotsToCreate, {
				range: rowIndex + 1,
				column: colIndex + 1,
			});

			let newPolygon = {
				id: plot.id,
				type: "Feature",
				properties: {
					type: "plot",
					field: fieldId,
					fieldName: fieldName,
					trial: plot.trialId === "00000000-0000-0000-0000-000000000000" ? null : plot.trialId,
					trialName: plot.trialName,
					companyName: plot.companyName,
					fieldRangeLength: fieldRangeLength,
					fieldColWidth: actualWidth,
					fieldRowCount: fieldRowCount,
					fieldRowSpacing: fieldRowSpacing,
					quantifiedHeight: quantifiedHeight,
					quantifiedWidth: quantifiedWidth,
					locked: false,
					portColor: "#ffb820",
					new: true,
					isDirty: true,
					analyzed: false,
					crop: crop,
					plantDate: plantDate,
					harvestDate: harvestDate,
					city: city,
					region: region,
					country: country,
					countryCode: countryCode,
					ranges: rows,
					columns: cols,
					range: rowIndex + 1,
					column: colIndex + 1,
					scaleFactor: 1,
					alleyLength: alleyLength,
					fieldPlanterOffset: planterOffset,
				},
				geometry: {
					type: "Polygon",
					coordinates: [],
				},
			};

			let lowerLeft = 0,
				upperLeft = 0,
				upperRight = 0,
				lowerRight = 0;

			if (firstColumnInRow) {
				xCoordinateToRotateAround = previousRowXCoordinate;
				yCoordinateToRotateAround = previousRowYCoordinate;
			}

			lowerLeft = [xCoordinateToRotateAround, yCoordinateToRotateAround];

			//Need to calculate the height and width change based on the radius of the earth in meters
			//6378137 = Radius of Earth in meters
			//3.281 = Conversion from feet to meters
			//https://stackoverflow.com/questions/2839533/adding-distance-to-a-gps-coordinate
			upperLeft = turf.truncate(
				turf.destination(lowerLeft, plotHeight / 3.281 / 1000, initialBearing),
				precisionOptions,
			).geometry.coordinates;

			if (firstColumnInRow) {
				previousRowXCoordinate = upperLeft[0];
				previousRowYCoordinate = upperLeft[1];
				firstColumnInRow = false;
			}

			upperRight = turf.truncate(
				turf.destination(upperLeft, actualWidth / 3.281 / 1000, perpendicularBearing),
				precisionOptions,
			).geometry.coordinates;

			lowerRight = turf.truncate(
				turf.destination(lowerLeft, actualWidth / 3.281 / 1000, perpendicularBearing),
				precisionOptions,
			).geometry.coordinates;

			xCoordinateToRotateAround = lowerRight[0];
			yCoordinateToRotateAround = lowerRight[1];

			let newCoords = [lowerLeft, upperLeft, upperRight, lowerRight, lowerLeft];

			let existingIndex = _.findIndex(allPlots, { id: plot.id });
			if (existingIndex !== -1) {
				_.pullAt(allPlots, existingIndex);
			}

			newPolygon.geometry.coordinates.push(newCoords);
			newFeatureCollection.features.push(newPolygon);
			allPlots.push(newPolygon);

			let initialPlot = _.cloneDeep(newPolygon);
			initialPlots.push(initialPlot);
		});
	});

	let thirdDropdownList = dropdownRef.current.innerRef.current.currentThirdDropdownOptions();

	if (newFeatureCollection.features && newFeatureCollection.features.length > 0) {
		let modifiedList = thirdDropdownList.concat({
			key: newFeatureCollection.features[0].properties.field,
			value: newFeatureCollection.features[0].properties.field,
			text: newFeatureCollection.features[0].properties.fieldName,
			icon: (
				<>
					<Icon
						style={{ float: "right" }}
						name="trash"
						link
						onClick={(e) =>
							dropdownRef.current.innerRef.current.handleDeleteClick(
								e,
								newFeatureCollection.features[0].properties.field,
							)
						}
					/>
					<Icon style={{ float: "right" }} name="warning" />
				</>
			),
		});

		dropdownRef.current.innerRef.current.setThirdDropdownOptions(modifiedList);
	}

	if (componentRefs?.llToggleRef?.current?.checkDisabled) {
		_.map(componentRefs, (ref) => {
			if (
				ref?.current?.setDisabled &&
				ref !== componentRefs.alignPlotsRef &&
				ref !== componentRefs.quantifiedRegionToggleRef &&
				ref !== componentRefs.editFieldModal &&
				ref !== componentRefs.heatmapOverlayLabelsRef &&
				ref !== componentRefs.heatmapOptionsRef &&
				ref !== componentRefs.coordinateTrackerRef
			) {
				ref.current.setDisabled(false);
			}
		});
	}

	draw.current.draw.delete(lineString.id);

	fieldsDirty = true;
	recalculateFieldBoundaries();
	refreshToggles(draw, canvas, componentRefs, moduleNavigation, dropdownRef, "flight");

	if (allFields?.length > 0) {
		zoomToField(draw, canvas, _.last(allFields).id, dropdownRef, componentRefs, "flight", moduleNavigation);
	}

	// Reset field measurements - used for a check in checkValidField
	fieldRanges = -1;
	fieldCols = -1;
	fieldColWidth = -1;
	fieldRangeLength = -1;
	plotsToCreate = [];
	fieldId = "";
	crop = "";
	plantDate = -1;
	harvestDate = -1;
	city = "";
	region = "";
	country = "";
	countryCode = "";
	alleyLength = -1;
	planterOffset = -1;
	lowerLeftLat = null;
	lowerLeftLong = null;
	upperLeftLat = null;
	upperLeftLong = null;
	degreeHeading = null;
	quantifiedHeight = null;
	quantifiedWidth = null;
}

// Checks if we need to re-draw any toggleable functionality
export function refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	if (fieldToggle) {
		fieldBoundaryToggle(draw);
		fieldBoundaryToggle(draw);
	}

	if (pivotToggle) {
		fieldPivotToggle(draw);
		fieldPivotToggle(draw);
	}

	if (fieldLabelsToggle) {
		fieldLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		fieldLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	}

	if (plotBoundaryToggle) {
		plotToggle(draw, controlComponentRefs, true);
		plotToggle(draw, controlComponentRefs, true);
	}

	if (rowsToggle) {
		rowToggle(draw);
		rowToggle(draw);
	}

	if (trialsToggle) {
		trialToggle(draw);
		trialToggle(draw);
	}

	if (llToggle) {
		lowerLeftToggle(draw);
		lowerLeftToggle(draw);
	}

	if (trialLabelsToggle) {
		trialLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		trialLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	}

	if (plotLabelsToggle) {
		plotLabelToggle(draw, canvas, controlComponentRefs);
		plotLabelToggle(draw, canvas, controlComponentRefs);
	}

	if (defMarkersToggle) {
		defMarkerToggle(canvas, controlComponentRefs);
		defMarkerToggle(canvas, controlComponentRefs);
	}

	if (pcToggle || pcQrToggle || rcQrToggle || brQrToggle || frQrToggle || scQrToggle) {
		quantifiedRegionToggle(draw, true);
	}

	if (controlComponentRefs?.heatmapTimelineRef?.current?.getHeatmapEnabled()) {
		heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	}

	if (controlComponentRefs.heatmapOverlayLabelsRef?.current?.checkToggleState) {
		heatmapOverlayLabels(draw, canvas, controlComponentRefs);
		heatmapOverlayLabels(draw, canvas, controlComponentRefs);
	}

	if (farmBoundsToggle) {
		drawFarmBounds(draw);
		drawFarmBounds(draw);
	}
}

export function resetControls() {
	allPlots = [];
	allFields = [];
	allTrials = [];
	allLLPoints = [];
	allRows = [];
	llToggle = true;
	fieldToggle = true;
	plotBoundaryToggle = true;
	rowsToggle = false;
	trialsToggle = false;
	fieldLabelsToggle = false;
	trialLabelsToggle = false;
	plotLabelsToggle = false;
	selectedFieldId = null;
	selectedTrialId = null;
	disableModifying = false;
	initialPlots = [];
	fieldCombined = [];
	rowsCombined = [];
	pivotToggle = false;
	fieldPivotPoints = [];
	singleFeatureToggle = false;
	trialPlots = [];
	movingFieldProperties = [];
	nonPlotDrawingsDeleted = [];
	analysisOptions = [];
	subsamples = [];
	subsamplesToAdd = [];
	quantifiedRegionOptions = [];
	pcToggle = false;
	pcQrToggle = false;
	rcQrToggle = false;
	brQrToggle = false;
	frQrToggle = false;
	scQrToggle = false;
	tilesetIds = [];
	fieldsDirty = true;
}

let fieldRanges = -1;
let fieldCols = -1;
let fieldColWidth = -1;
let fieldRangeLength = -1;
let fieldRowCount = -1;
let fieldRowSpacing = -1;
let fieldName = "";
let plotsToCreate = [];
let fieldId = "";
let crop = "";
let plantDate = -1;
let harvestDate = -1;
let city = "";
let region = "";
let country = "";
let countryCode = "";
let alleyLength = -1;
let planterOffset = -1;
let lowerLeftLat = null;
let lowerLeftLong = null;
let upperLeftLat = null;
let upperLeftLong = null;
let degreeHeading = null;
let quantifiedHeight = null;
let quantifiedWidth = null;
let newFieldLine = null;

// Sets up creation of grid
export function handleFieldAdd(
	plots,
	field,
	newFieldId,
	quantifiedRegions,
	draw,
	canvas,
	dropdownRef,
	componentRefs,
	moduleNavigation,
) {
	fieldRanges = parseInt(field.numOfRanges);
	fieldCols = parseInt(field.numOfColumns);
	fieldColWidth = field.columnWidth;
	fieldRangeLength = field.rangeLength;
	fieldRowCount = field.rowsPerPlot;
	fieldRowSpacing = field.rowSpacing;
	quantifiedHeight = field.quantifiedLength;
	quantifiedWidth = field.quantifiedWidth;
	fieldName = field.name;
	plotsToCreate = plots;
	fieldId = newFieldId;
	crop = field.crop;
	plantDate = field.plantDate;
	harvestDate = field.harvestDate;
	city = field.city;
	region = field.region;
	country = field.country;
	countryCode = field.countryCode;
	alleyLength = field.alleyLength;
	planterOffset = field.planterOffset;
	lowerLeftLat = field.llLat;
	lowerLeftLong = field.llLong;
	upperLeftLat = field.ulLat;
	upperLeftLong = field.ulLong;
	degreeHeading = field.degreeHeading;

	checkValidField(newFieldLine, draw, canvas, dropdownRef, componentRefs, moduleNavigation);
}

export function checkValidField(e, draw, canvas, dropdownRef, componentRefs, moduleNavigation) {
	if (draw.current.draw.getMode() === "simple_select") {
		if (
			fieldRanges !== -1 ||
			fieldCols !== -1 ||
			fieldColWidth !== -1 ||
			fieldRangeLength !== -1 ||
			fieldName !== "" ||
			plotsToCreate.length === 0 ||
			fieldId !== ""
		) {
			drawGrid(e, draw, canvas, dropdownRef, componentRefs, moduleNavigation);
		} else {
			draw.current.draw.delete(e.id);
		}
	}
}

// On initial page load, retrieve the plot data for the flight viewer.
export async function addExistingPlotsInFlight(
	flightId,
	getTokenSilently,
	dispatch,
	draw,
	canvas,
	componentRefs,
	clientId,
	moduleNavigation,
	dropdownRef,
	level,
) {
	const accessToken = await getTokenSilently();
	dispatch(flightsPlotsActions.getExistingFlightsPlotsInFlight(flightId, clientId, accessToken)).then((res) => {
		if (res.plots.length > 0) {
			_.map(componentRefs, (ref) => {
				if (
					ref?.current?.setDisabled &&
					ref !== componentRefs.flagPlotsRef &&
					ref !== componentRefs.alignPlotsRef &&
					ref !== componentRefs.quantifiedRegionToggleRef &&
					ref !== componentRefs.editFieldModal &&
					ref !== componentRefs.coordinateTrackerRef
				) {
					ref.current.setDisabled(false);

					if (ref == componentRefs.lockToggleRef) {
						ref.current.setLocked(true);
					}
				}
			});

			markedPlots = res.markedPlots;
			markedSubsamples = res.markedQuantifiedRegions;
			markedPlotOptions = res.markedPlotOptions;
			annotationClassOptions = res.annotationClassOptions;

			firstFlightFields = res.firstFlightFields;

			_.map(res.plots, (plot) => {
				let plotToAdd = {
					id: plot.plotId,
					type: "Feature",
					properties: {
						type: "plot",
						field: plot.fieldId,
						fieldName: plot.fieldName,
						companyName: plot.companyName,
						trialName: `${plot.companyName} - ${plot.trialName}`,
						trial: plot.trialId,
						fieldRangeLength: plot.plotRangeLength,
						fieldColWidth: plot.plotColumnWidth,
						fieldRowCount: plot.fieldRowsPerPlot,
						fieldRowSpacing: plot.fieldRowSpacing,
						fieldRowsPerPlot: plot.rowsPerPlot,
						fieldPassesPerPlot: plot.passesPerPlot,
						fieldPlanterOffset: plot.planterOffset,
						locked: true,
						portColor: "#0ac944",
						new: false,
						analyzed: plot.analyzed,
						crop: plot.crop,
						plantDate: plot.plantDate !== "0001-01-01T00:00:00" ? plot.plantDate : -1,
						harvestDate: plot.harvestDate !== "0001-01-01T00:00:00" ? plot.harvestDate : -1,
						city: plot.city,
						region: plot.region,
						country: plot.country,
						countryCode: plot.countryCode,
						ranges: plot.ranges,
						columns: plot.columns,
						range: plot.range,
						column: plot.column,
						name: plot.plotName,
						quantifiedHeight: plot.quantifiedHeight,
						quantifiedWidth: plot.quantifiedWidth,
						scaleFactor: plot.scaleFactor,
						replicate: plot.replicate,
						treatment: plot.treatment,
						flightDate: plot.flightDate,
					},
					geometry: {
						type: "Polygon",
						coordinates: [
							[
								[plot.llLong, plot.llLat],
								[plot.ulLong, plot.ulLat],
								[plot.urLong, plot.urLat],
								[plot.lrLong, plot.lrLat],
								[plot.llLong, plot.llLat],
							],
						],
					},
				};

				plotToAdd = turf.truncate(plotToAdd, precisionOptions);

				let existingIndex = _.findIndex(allPlots, { id: plot.plotId });
				if (existingIndex !== -1) {
					_.pullAt(allPlots, existingIndex);
				}

				allPlots.push(plotToAdd);
				initialPlots.push(_.cloneDeep(plotToAdd));
			});

			currentFlightId = flightId;
			refreshToggles(draw, canvas, componentRefs, moduleNavigation, dropdownRef, level);
		}
	});
}

export async function addExistingPlotsInField(
	flightId,
	fieldId,
	getTokenSilently,
	dispatch,
	draw,
	canvas,
	align,
	readjust = true,
	first,
	controlComponentRefs,
	clientId,
	moduleNavigation,
	dropdownRef,
	level,
	fromFlightDropdown = false,
) {
	const accessToken = await getTokenSilently();
	dispatch(flightsPlotsActions.getExistingFlightsPlotsInField(flightId, fieldId, clientId, accessToken)).then((res) => {
		let newFeatureCollection = {
			type: "FeatureCollection",
			features: [],
		};

		markedPlots = res.markedPlots;
		markedSubsamples = res.markedQuantifiedRegions;
		markedPlotOptions = res.markedPlotOptions;
		annotationClassOptions = res.annotationClassOptions;
		quantifiedRegionOptions = res.quantifiedRegionOptions;

		_.map(res.plots, (plot) => {
			let plotToAdd = {
				id: plot.plotId,
				type: "Feature",
				properties: {
					type: "plot",
					field: plot.fieldId,
					fieldName: plot.fieldName,
					trial: plot.trialId,
					trialName: `${plot.companyName} - ${plot.trialName}`,
					fieldRangeLength: plot.plotRangeLength,
					fieldColWidth: plot.plotColumnWidth,
					fieldRowCount: plot.fieldRowsPerPlot,
					fieldRowSpacing: plot.fieldRowSpacing,
					fieldRowsPerPlot: plot.rowsPerPlot,
					fieldPassesPerPlot: plot.passesPerPlot,
					fieldPlanterOffset: plot.planterOffset,
					locked: align,
					portColor: align ? "#0ac944" : "#ffb820",
					new: true,
					isDirty: true,
					crop: plot.crop,
					plantDate: plot.plantDate !== "0001-01-01T00:00:00" ? plot.plantDate : -1,
					harvestDate: plot.harvestDate !== "0001-01-01T00:00:00" ? plot.harvestDate : -1,
					city: plot.city,
					region: plot.region,
					country: plot.country,
					countryCode: plot.countryCode,
					ranges: plot.ranges,
					columns: plot.columns,
					range: plot.range,
					column: plot.column,
					name: plot.plotName,
					quantifiedHeight: plot.quantifiedHeight,
					quantifiedWidth: plot.quantifiedWidth,
					scaleFactor: plot.scaleFactor,
					replicate: plot.replicate,
					treatment: plot.treatment,
					flightDate: plot.flightDate,
				},
				geometry: {
					type: "Polygon",
					coordinates: [
						[
							[plot.llLong, plot.llLat],
							[plot.ulLong, plot.ulLat],
							[plot.urLong, plot.urLat],
							[plot.lrLong, plot.lrLat],
							[plot.llLong, plot.llLat],
						],
					],
				},
			};

			plotToAdd = turf.truncate(plotToAdd, precisionOptions);

			let existingIndex = _.findIndex(allPlots, { id: plot.plotId });
			if (existingIndex !== -1) {
				_.pullAt(allPlots, existingIndex);
			}

			newFeatureCollection.features.push(plotToAdd);
			allPlots.push(plotToAdd);
			initialPlots.push(_.cloneDeep(plotToAdd));
		});

		//-- Field was added through dropdown list, add subsample dimensions to subsamplesToAdd
		if (!fromFlightDropdown) {
			setupQuantifiedRegions(res.quantifiedRegions, controlComponentRefs);
		}

		if (analysisOptions?.length === 0) {
			setupAnalysisOptions(res.analysisOptions, controlComponentRefs);
		}

		//-- This will make fields redraw
		fieldsDirty = true;

		selectedFieldId = fieldId;
		currentFlightId = flightId;
		refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);

		if (readjust || first) {
			setViewerOrientation(canvas, "field", fromFlightDropdown);
		}

		if (controlComponentRefs.alignPlotsRef?.current) {
			controlComponentRefs.alignPlotsRef.current.setDisabled(true);
		}

		if (controlComponentRefs.lockToggleRef?.current) {
			let locked = _.find(allFields, { id: selectedFieldId }).properties.locked;
			controlComponentRefs.lockToggleRef.current.setLocked(locked);
		}

		if (controlComponentRefs.llToggleRef?.current?.checkDisabled) {
			_.map(controlComponentRefs, (ref) => {
				if (
					ref.current &&
					(ref === controlComponentRefs.flagPlotsRef ||
						(ref === controlComponentRefs.heatmapOverlayLabelsRef &&
							controlComponentRefs.heatmapOverlayLabelsRef?.current) ||
						(ref === controlComponentRefs.heatmapOptionsRef && controlComponentRefs.heatmapOptionsRef?.current))
				) {
					ref.current.setDisabled(true);
				} else if (ref?.current?.setDisabled) {
					ref.current.setDisabled(false);
				}
			});
		}
	});
}

export async function addExistingPlotsInTrial(
	flightId,
	trialId,
	getTokenSilently,
	dispatch,
	draw,
	canvas,
	align,
	first,
	clientId,
	controlComponentRefs,
	moduleNavigation,
	dropdownRef,
	level,
) {
	const accessToken = await getTokenSilently();
	dispatch(flightsPlotsActions.getExistingFlightsPlotsInTrial(flightId, trialId, clientId, accessToken)).then((res) => {
		let newFeatureCollection = {
			type: "FeatureCollection",
			features: [],
		};

		markedPlots = res.markedPlots;
		markedSubsamples = res.markedQuantifiedRegions;
		markedPlotOptions = res.markedPlotOptions;
		annotationClassOptions = res.annotationClassOptions;
		quantifiedRegionOptions = res.quantifiedRegionOptions;

		_.map(res.plots, (plot) => {
			let plotToAdd = {
				id: plot.plotId,
				type: "Feature",
				properties: {
					type: "plot",
					field: plot.fieldId,
					fieldName: plot.fieldName,
					trial: plot.trialId,
					trialName: `${plot.companyName} - ${plot.trialName}`,
					companyName: plot.companyName,
					fieldRangeLength: plot.plotRangeLength,
					fieldColWidth: plot.plotColumnWidth,
					fieldRowCount: plot.fieldRowsPerPlot,
					fieldRowSpacing: plot.fieldRowSpacing,
					fieldRowsPerPlot: plot.rowsPerPlot,
					fieldPassesPerPlot: plot.passesPerPlot,
					fieldPlanterOffset: plot.planterOffset,
					locked: align,
					portColor: align ? "#0ac944" : "#ffb820",
					new: true,
					isDirty: true,
					crop: plot.crop,
					plantDate: plot.plantDate !== "0001-01-01T00:00:00" ? plot.plantDate : -1,
					harvestDate: plot.harvestDate !== "0001-01-01T00:00:00" ? plot.harvestDate : -1,
					city: plot.city,
					region: plot.region,
					country: plot.country,
					countryCode: plot.countryCode,
					ranges: plot.ranges,
					columns: plot.columns,
					range: plot.range,
					column: plot.column,
					quantifiedHeight: plot.quantifiedHeight,
					quantifiedWidth: plot.quantifiedWidth,
					name: plot.plotName,
					scaleFactor: plot.scaleFactor,
					treatment: plot.treatment,
					replicate: plot.replicate,
					flightDate: plot.flightDate,
				},
				geometry: {
					type: "Polygon",
					coordinates: [
						[
							[plot.llLong, plot.llLat],
							[plot.ulLong, plot.ulLat],
							[plot.urLong, plot.urLat],
							[plot.lrLong, plot.lrLat],
							[plot.llLong, plot.llLat],
						],
					],
				},
			};

			plotToAdd = turf.truncate(plotToAdd, precisionOptions);

			let existingIndex = _.findIndex(allPlots, { id: plot.plotId });
			if (existingIndex !== -1) {
				_.pullAt(allPlots, existingIndex);
			}

			newFeatureCollection.features.push(plotToAdd);
			allPlots.push(plotToAdd);
			initialPlots.push(_.cloneDeep(plotToAdd));
		});

		setupQuantifiedRegions(res.quantifiedRegions, controlComponentRefs);

		if (analysisOptions?.length === 0) {
			setupAnalysisOptions(res.analysisOptions, controlComponentRefs);
		}

		if (first) {
			recalculateTrialBoundaries(false);
			setViewerOrientation(canvas, "trial");
		}

		currentFlightId = flightId;
		fieldsDirty = true;
		refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	});
}

export async function drawFarmPlots(
	flightDate,
	flightImages,
	analysisOpts,
	farmId,
	orthoId,
	clientId,
	draw,
	canvas,
	getTokenSilently,
	dispatch,
	controlComponentRefs,
	first,
	moduleNavigation,
	dropdownRef,
	level,
) {
	if (draw && canvas && flightImages) {
		const accessToken = await getTokenSilently();
		dispatch(orthoViewerActions.setImageLoaded(false));
		dispatch(flightsPlotsActions.getExistingFlightsPlotsInFarm(flightDate, farmId, orthoId, clientId, accessToken))
			.then((res) => {
				//-- Reset plots for when fields change
				allPlots = [];

				markedPlots = res.markedPlots;
				markedSubsamples = res.markedQuantifiedRegions;
				markedPlotOptions = res.markedPlotOptions;
				annotationClassOptions = res.annotationClassOptions;
				quantifiedRegionOptions = res.quantifiedRegionOptions;

				_.map(res.plots, (plot) => {
					let plotToAdd = {
						id: plot.plotId,
						type: "Feature",
						properties: {
							type: "plot",
							field: plot.fieldId,
							fieldName: plot.fieldName,
							trial: plot.trialId,
							trialName: `${plot.companyName ? `${plot.companyName} - ` : ""}${plot.trialName}`,
							companyName: plot.companyName,
							fieldRangeLength: plot.plotRangeLength,
							fieldColWidth: plot.plotColumnWidth,
							fieldRowCount: plot.fieldRowsPerPlot,
							fieldRowSpacing: plot.fieldRowSpacing,
							fieldRowsPerPlot: plot.rowsPerPlot,
							fieldPassesPerPlot: plot.passesPerPlot,
							fieldPlanterOffset: plot.planterOffset,
							portColor: "#0ac944",
							new: false,
							isDirty: false,
							locked: true,
							crop: plot.crop,
							plantDate: plot.plantDate !== "0001-01-01T00:00:00" ? plot.plantDate : -1,
							harvestDate: plot.harvestDate !== "0001-01-01T00:00:00" ? plot.harvestDate : -1,
							city: plot.city,
							region: plot.region,
							country: plot.country,
							countryCode: plot.countryCode,
							ranges: plot.ranges,
							columns: plot.columns,
							range: plot.range,
							column: plot.column,
							quantifiedHeight: plot.quantifiedHeight,
							quantifiedWidth: plot.quantifiedWidth,
							name: plot.plotName,
							scaleFactor: plot.scaleFactor,
							treatment: plot.treatment,
							replicate: plot.replicate,
							flightDate: plot.flightDate,
						},
						geometry: {
							type: "Polygon",
							coordinates: [
								[
									[plot.llLong, plot.llLat],
									[plot.ulLong, plot.ulLat],
									[plot.urLong, plot.urLat],
									[plot.lrLong, plot.lrLat],
									[plot.llLong, plot.llLat],
								],
							],
						},
					};

					plotToAdd = turf.truncate(plotToAdd, precisionOptions);

					allPlots.push(plotToAdd);
				});

				setupQuantifiedRegions(res.quantifiedRegions, controlComponentRefs);

				if (analysisOptions?.length === 0) {
					setupAnalysisOptions(analysisOpts, controlComponentRefs);
				}

				//-- This will make fields redraw
				fieldsDirty = true;

				currentFlightDate = flightDate;
				refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
				dispatch(orthoViewerActions.setImageLoaded(true));
			})
			.catch((err) => {
				toast.error("Couldn't find plots for this farm on this date.");
				console.error(err);
			});

		if (first && _.flatten(_.map(flightImages, "mapboxUploads"))?.length > 5) {
			removeShader();
		}

		buildMapForImagesOnDate(flightImages, orthoId, flightDate, canvas, controlComponentRefs);
	}
}

export function setupAnalysisOptions(analysisOpts, componentRefs) {
	analysisOptions = analysisOpts;

	let opts = [];
	if (analysisOptions?.analysisOptions?.length > 0) {
		analysisOptions.analysisOptions = _.sortBy(
			analysisOptions.analysisOptions,
			[(opt) => opt.order || Infinity, "analysisName"],
			["desc"],
		);

		opts.push({ key: "a-divider", value: "a-divider", text: "Timecourse Data", disabled: true });
		opts = [
			...opts,
			..._.map(
				analysisOptions.analysisOptions,
				({ analysisId, analysisName, analysisTypeId, quantifiedRegionTypeId, years }) => {
					return {
						key: `${analysisId}/${analysisTypeId}/${quantifiedRegionTypeId}`,
						value: `${analysisId}/${analysisTypeId}/${quantifiedRegionTypeId}`,
						text: analysisName,
						years,
					};
				},
			),
		];
	}

	if (analysisOptions?.curveModelAnalysisOptions?.length > 0) {
		opts.push({ key: "cm-divider", value: "cm-divider", text: "Digital Phenotypes", disabled: true });
		opts = [
			...opts,
			..._.map(
				_.sortBy(
					_.uniqBy(
						_.filter(analysisOptions.curveModelAnalysisOptions, (cmao) => cmao.displayName !== null),
						(opt) => [opt.analysisId, opt.curveModelAnalysisId, opt.analysisTypeId].join(),
					),
					[(opt) => opt.order || Infinity, "curveModelAnalysisAbbreviation"],
					["desc"],
				),
				({
					analysisAbbreviation,
					analysisId,
					curveModelAnalysisAbbreviation,
					curveModelAnalysisId,
					displayName,
					analysisTypeId,
					years,
				}) => {
					return {
						key: `${analysisId}/${analysisTypeId}/${curveModelAnalysisId}`,
						value: `${analysisId}/${analysisTypeId}/${curveModelAnalysisId}`,
						text: `${displayName} (${curveModelAnalysisAbbreviation}_${analysisAbbreviation})`,
						years,
					};
				},
			),
		];
	}

	if (analysisOptions?.groundDataOptions?.length > 0) {
		opts.push({ key: "gd-divider", value: "gd-divider", text: "Ground Data", disabled: true });
		opts = [
			...opts,
			..._.map(analysisOptions.groundDataOptions, ({ assessmentId, assessmentName, unitName, years }) => {
				return {
					key: assessmentId,
					value: assessmentId,
					text: assessmentName + (unitName ? ` (${unitName})` : ""),
					years,
				};
			}),
		];
	}

	// let selectedAnalysisId = _.find(opts, { text: "Vegetation (NDVI)" })?.key ?? opts[1]?.key;

	if (componentRefs?.heatmapTimelineRef?.current) {
		componentRefs.heatmapTimelineRef.current.setRawAnalysisOptions(opts);
		// if (defaultViewerSetting === null) {
		// 	componentRefs.heatmapTimelineRef.current.setSelectedAnalysisId(selectedAnalysisId);
		// }
	}

	return opts;
}

export async function redrawPlots(
	flightId,
	fieldId,
	trialId,
	sensorChanged,
	res,
	orthoId,
	getTokenSilently,
	dispatch,
	draw,
	canvas,
	align,
	first,
	componentRefs,
	clientId,
	moduleNavigation,
	dropdownRef,
	level,
) {
	if (sensorChanged) {
		allPlots = [];
		initialPlots = [];

		refreshToggles(draw, canvas, componentRefs, moduleNavigation, dropdownRef, level);
	}

	if (fieldId) {
		addExistingPlotsInField(
			flightId,
			fieldId,
			getTokenSilently,
			dispatch,
			draw,
			canvas,
			align,
			false,
			first,
			componentRefs,
			clientId,
			moduleNavigation,
			dropdownRef,
			level,
			false,
		);
	} else if (trialId) {
		addExistingPlotsInTrial(
			flightId,
			trialId,
			getTokenSilently,
			dispatch,
			draw,
			canvas,
			align,
			first,
			clientId,
			componentRefs,
			moduleNavigation,
			dropdownRef,
			level,
		);
	}

	buildMapImage(res, orthoId, canvas, align);
}

export async function handleFieldDropdownChange(
	draw,
	canvas,
	align,
	field,
	flightId,
	getTokenSilently,
	dispatch,
	orthoImageTypeId,
	clientId,
	componentRefs,
	moduleNavigation,
	dropdownRef,
	level,
) {
	if (fieldCombined.length > 0) {
		uncombinePlotsInField(draw, false);
	}

	if (componentRefs.alignPlotsRef && componentRefs.alignPlotsRef.current) {
		componentRefs.alignPlotsRef.current.setDisabled(true);
	}

	if (componentRefs.editFieldModal?.current) {
		componentRefs.editFieldModal.current.setDisabled(true);
	}

	if (field.key === "all") {
		resetOrientation(canvas, level, draw, dropdownRef, componentRefs, moduleNavigation);
	} else {
		const accessToken = await getTokenSilently();
		let flightImageInfo = await getFlightImage(clientId, flightId, orthoImageTypeId, field.key, accessToken, dispatch);

		// If flight image doesn't exist, get last flight's field coords if they exist
		if (!flightImageInfo.id && _.findIndex(allFields, { id: field.key }) === -1) {
			let flightToCopy = null;
			dispatch(fieldActions.getFlightsWithFieldOrTrial(clientId, field.key, null, accessToken)).then((res) => {
				//-- If the field was added and then removed before it was locked and saved AND this is the first flight the field was added to, there will not be any coordinates
				if (res?.flights.length > 0) {
					flightToCopy = _.first(res.flights).flightId;
					addExistingPlotsInField(
						flightToCopy,
						field.key,
						getTokenSilently,
						dispatch,
						draw,
						canvas,
						align,
						true,
						null,
						componentRefs,
						clientId,
						moduleNavigation,
						dropdownRef,
						level,
						true,
					);
				} else {
					selectedFieldId = field.key;
					toggleSingleFieldTrial(draw, canvas, "field", componentRefs, moduleNavigation, dropdownRef, level);
					fitToHeight(canvas, "field", true);
				}
			});
		} else {
			// If plots don't exist, add, otherwise fly to field.
			// If on add field page, just fly to field
			if (!align && _.findIndex(allFields, { id: field.key }) === -1) {
				addExistingPlotsInField(
					flightId,
					field.key,
					getTokenSilently,
					dispatch,
					draw,
					canvas,
					align,
					true,
					null,
					componentRefs,
					clientId,
					moduleNavigation,
					dropdownRef,
					level,
					true,
				);
			} else {
				selectedFieldId = field.key;
				toggleSingleFieldTrial(draw, canvas, "field", componentRefs, moduleNavigation, dropdownRef, level);
				fitToHeight(canvas, "field", true);

				if (componentRefs.lockToggleRef && componentRefs.lockToggleRef.current) {
					let locked = _.find(allFields, { id: selectedFieldId }).properties.locked;
					componentRefs.lockToggleRef.current.setLocked(locked);
				}
			}
		}
	}
}

function getFlightImage(clientId, flightId, orthoImageTypeId, fieldId, accessToken, dispatch) {
	let flightImageInfo = dispatch(
		flightImageActions.getFlightImage(
			clientId,
			flightId,
			orthoImageTypeId,
			fieldId,
			"00000000-0000-0000-0000-000000000000",
			"00000000-0000-0000-0000-000000000000",
			accessToken,
		),
	).then((res) => {
		return {
			id: res.id,
			ll: [parseFloat(res.llLong), parseFloat(res.llLat)],
			ul: [parseFloat(res.ulLong), parseFloat(res.ulLat)],
			lr: [parseFloat(res.lrLong), parseFloat(res.lrLat)],
			ur: [parseFloat(res.urLong), parseFloat(res.urLat)],
		};
	});

	return flightImageInfo;
}

let layerIds = [];
let previousPage = null;
export function buildMapImage(res, orthoId, canvas, edit) {
	if (res?.id) {
		if (canvas) {
			imageLayers = _.map(res.mapboxUploads, (u) => `ortho-${res.flightId}__${orthoId}__${u.tilesetId}`);
			tilesetIds = _.map(res.mapboxUploads, "tilesetId");

			// Resetting layers if user changes page. Handles going from align fields to add fields
			if (previousPage !== edit) {
				layerIds = [];
			}
			previousPage = edit;
			// if layer already exists, move the image to the front
			_.forEach(res.mapboxUploads, ({ tilesetId }) => {
				if (
					_.indexOf(layerIds, `ortho-${res.flightId}__${orthoId}__${tilesetId}`) !== -1 &&
					canvas.getLayer(`ortho-${res.flightId}__${orthoId}__${tilesetId}`)
				) {
					//-- Keep image layers hidden if main toggle is still off
					if (!imageLayersHidden) {
						canvas.setPaintProperty(`ortho-${res.flightId}__${orthoId}__${tilesetId}`, "raster-opacity", 1);
					}
				} else {
					// need to add the ortho to the layer list before call so that we can set the canvas up beforehand
					layerIds.push(`ortho-${res.flightId}__${orthoId}__${tilesetId}`);
					canvas.addSource(`ortho-${res.flightId}__${orthoId}__${tilesetId}`, {
						type: "raster",
						url: `mapbox://${tilesetId}`,
					});

					canvas.addLayer(
						{
							id: `ortho-${res.flightId}__${orthoId}__${tilesetId}`,
							source: `ortho-${res.flightId}__${orthoId}__${tilesetId}`,
							type: "raster",
							layout: { visibility: "visible" },
							paint: { "raster-opacity": imageLayersHidden ? 0 : 1, "raster-opacity-transition": { duration: 300 } },
						},
						// put the layer before this one
						// this is the layer on top of the background, but before all drawings
						"gl-draw-point-point-stroke-inactive.cold",
					);
				}
			});

			_.forEach(layerIds, (id) => {
				const layer = canvas.getLayer(id);
				if (layer && !id.includes(`ortho-${res.flightId}__${orthoId}`)) {
					canvas.setPaintProperty(id, "raster-opacity", 0);
				}
			});

			if (activeShader) {
				refreshShaderLayer(canvas);
			}
		}
	}
}

function buildMapForImagesOnDate(images, orthoId, flightDate, canvas, controlComponentRefs) {
	if (canvas) {
		if (controlComponentRefs?.imageLayersRef) {
			let flights = _.map(_.orderBy(images, "fileName"), (im, i) => {
				return {
					name: `Flight ${i + 1}`,
					checked: true,
					layers: _.map(im.mapboxUploads, (u) => `ortho-${flightDate}__${orthoId}__${u.tilesetId}`),
				};
			});

			controlComponentRefs.imageLayersRef.current.setFlights(flights);
		}

		let mapboxUploads = _.flatten(_.map(images, "mapboxUploads"));
		tilesetIds = _.map(mapboxUploads, "tilesetId");

		_.forEach(tilesetIds, (tilesetId) => {
			// need to add the ortho to the layer list before call so that we can set the canvas up beforehand
			layerIds.push(`ortho-${flightDate}__${orthoId}__${tilesetId}`);
			canvas.addSource(`ortho-${flightDate}__${orthoId}__${tilesetId}`, {
				type: "raster",
				url: `mapbox://${tilesetId}`,
			});

			canvas.addLayer(
				{
					id: `ortho-${flightDate}__${orthoId}__${tilesetId}`,
					source: `ortho-${flightDate}__${orthoId}__${tilesetId}`,
					type: "raster",
					layout: { visibility: "visible" },
					paint: { "raster-opacity": imageLayersHidden ? 0 : 1, "raster-opacity-transition": { duration: 300 } },
				},
				// put the layer before this one
				// this is the layer on top of the background, but before all drawings
				"gl-draw-point-point-stroke-inactive.cold",
			);
		});

		let layersRemoved = [];
		_.forEach(layerIds, (id) => {
			const layer = canvas.getLayer(id);
			if (layer && !id.includes(`ortho-${flightDate}__${orthoId}`)) {
				canvas.removeLayer(id);
				canvas.removeSource(id);

				layersRemoved.push(id);
			}
		});

		_.pull(layerIds, ...layersRemoved);

		if (activeShader) {
			refreshShaderLayer(canvas);
		}
	}
}

export function showLayers(canvas, layers = null) {
	_.forEach(layers ?? imageLayers, (id) => {
		const layer = canvas.getLayer(id);
		if (layer) {
			canvas.setPaintProperty(id, "raster-opacity", 1);
		}
	});

	if (layers === null) {
		imageLayersHidden = false;
	}

	if (activeShader) {
		refreshShaderLayer(canvas);
	}
}

export function hideLayers(canvas, layers = null) {
	_.forEach(layers ?? imageLayers, (id) => {
		const layer = canvas.getLayer(id);
		if (layer) {
			canvas.setPaintProperty(id, "raster-opacity", 0);
		}
	});

	if (layers === null) {
		imageLayersHidden = true;
	}

	if (activeShader) {
		refreshShaderLayer(canvas);
	}
}

export function getImageLayersHidden() {
	return imageLayersHidden;
}

export async function cutImage(
	clientId,
	flightId,
	orthoImageTypes,
	accessToken,
	dispatch,
	skipToast = false,
	skipFields = false,
	fieldsToCreate = [],
	fieldsToUpdate = [],
	recutAllImages = false,
) {
	if (!skipToast) {
		toast.info("Preparing modified images...", {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
		});
	}

	let cutParams = {
		clientId: clientId,
		flightId: flightId,
		orthoImageTypes: orthoImageTypes,
		recutAllImages: recutAllImages,
		updatedImages: [],
	};

	if (!skipFields) {
		recalculateFieldBoundaries(true);

		_.map(
			_.filter(allFields, (af) => _.map([...fieldsToCreate, ...fieldsToUpdate], "id").includes(af.id)),
			({ id, geometry, properties }) => {
				if (properties.locked) {
					let bbox = turf.bbox(turf.feature(geometry));
					let bboxPolygon = turf.bboxPolygon(bbox);

					let ll = [bboxPolygon.geometry.coordinates[0][3][0], bboxPolygon.geometry.coordinates[0][3][1]];
					let ul = [bboxPolygon.geometry.coordinates[0][0][0], bboxPolygon.geometry.coordinates[0][0][1]];
					let lr = [bboxPolygon.geometry.coordinates[0][2][0], bboxPolygon.geometry.coordinates[0][2][1]];
					let ur = [bboxPolygon.geometry.coordinates[0][1][0], bboxPolygon.geometry.coordinates[0][1][1]];

					let field = {
						llLat: ll[1],
						llLong: ll[0],
						ulLat: ul[1],
						ulLong: ul[0],
						lrLat: lr[1],
						lrLong: lr[0],
						urLat: ur[1],
						urLong: ur[0],
						fieldId: id,
						trialId: null,
						plotId: null,
					};

					cutParams.updatedImages.push(field);
				}
			},
		);
	}

	recalculateTrialBoundaries(true);
	_.map(
		_.filter(allTrials, (at) => _.map([...fieldsToCreate, ...fieldsToUpdate], "id").includes(at.properties.field)),
		({ id, properties, geometry }) => {
			if (properties.locked) {
				let bbox = turf.bbox(turf.feature(geometry));
				let bboxPolygon = turf.bboxPolygon(bbox);

				let ll = [bboxPolygon.geometry.coordinates[0][3][0], bboxPolygon.geometry.coordinates[0][3][1]];
				let ul = [bboxPolygon.geometry.coordinates[0][0][0], bboxPolygon.geometry.coordinates[0][0][1]];
				let lr = [bboxPolygon.geometry.coordinates[0][2][0], bboxPolygon.geometry.coordinates[0][2][1]];
				let ur = [bboxPolygon.geometry.coordinates[0][1][0], bboxPolygon.geometry.coordinates[0][1][1]];

				let trial = {
					llLat: ll[1],
					llLong: ll[0],
					ulLat: ul[1],
					ulLong: ul[0],
					lrLat: lr[1],
					lrLong: lr[0],
					urLat: ur[1],
					urLong: ur[0],
					fieldId: properties.field,
					trialId: id,
					plotId: null,
				};

				cutParams.updatedImages.push(trial);
			}
		},
	);

	if (cutParams.updatedImages.length !== 0) {
		await dispatch(orthoActions.cutOrtho(cutParams, accessToken));
	}
}

async function createFlightsPlots(newPlots, flightId, accessToken, dispatch) {
	let plotsToAdd = [];

	_.map(newPlots.features, ({ id, geometry, properties }) => {
		let plotToAdd = {
			plotId: id,
			flightId: flightId,
			scaleFactor: properties.scaleFactor,
			ll: {
				long: applyPrecision(geometry.coordinates[0][0][0]),
				lat: applyPrecision(geometry.coordinates[0][0][1]),
			},
			ul: {
				long: applyPrecision(geometry.coordinates[0][1][0]),
				lat: applyPrecision(geometry.coordinates[0][1][1]),
			},
			ur: {
				long: applyPrecision(geometry.coordinates[0][2][0]),
				lat: applyPrecision(geometry.coordinates[0][2][1]),
			},
			lr: {
				long: applyPrecision(geometry.coordinates[0][3][0]),
				lat: applyPrecision(geometry.coordinates[0][3][1]),
			},
		};

		plotsToAdd.push(plotToAdd);
	});

	let response = await dispatch(flightsPlotsActions.createFlightsPlots(plotsToAdd, accessToken)).then(() => {
		return true;
	});

	return response;
}

function applyPrecision(num) {
	return Number((Math.round(num * 10000000) / 10000000).toFixed(7));
}

export async function removeFieldGrid(
	flightId,
	fieldId,
	clientId,
	draw,
	canvas,
	getTokenSilently,
	dispatch,
	dropdownRef,
	removeFields,
	controlComponentRefs,
	moduleNavigation,
) {
	if (fieldCombined.length > 0) {
		uncombinePlotsInField(draw);
	}

	if (_.findIndex(allFields, { id: fieldId }) !== -1) {
		const accessToken = await getTokenSilently();
		dispatch(analysisActions.getAnalysisResultsForFlight(flightId, clientId, accessToken)).then((data) => {
			let fieldResults = _.find(data.fieldAnalysisResults, { fieldId: fieldId });
			if (!fieldResults) {
				let plotsToRemove = [];

				_.map(allPlots, (plot) => {
					if (plot.properties.field === fieldId) {
						plotsToRemove.push(plot);
					}
				});

				fieldsDirty = true;
				singleFeatureToggle = false;
				selectedFieldId = null;
				selectedTrialId = null;

				let plotIdsToRemove = _.map(plotsToRemove, "id");

				draw.current.draw.delete(plotIdsToRemove);
				_.pullAll(allPlots, plotsToRemove);
				refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, "flight");

				dropdownRef.current.innerRef.current.setThirdDropdownId("all");

				if (removeFields) {
					let fieldsInDropdown = dropdownRef.current.innerRef.current.currentThirdDropdownOptions();
					let prunedDdl = _.filter(fieldsInDropdown, ({ key }) => key !== fieldId);

					dropdownRef.current.innerRef.current.setThirdDropdownOptions(prunedDdl);

					let index = _.findIndex(_.map(fieldPivotPoints, "pivot"), { id: fieldId });
					fieldPivotPoints.splice(index, 1);
				}
			} else {
				let fieldAnalyzed = _.some(fieldResults?.analysisResults) ? true : false;

				if (!fieldAnalyzed) {
					toast.info("Deleting field from flight...", {
						position: "top-right",
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
					});

					dispatch(flightsPlotsActions.getExistingFlightsPlotsInField(flightId, fieldId, clientId, accessToken)).then(
						(res) => {
							if (res.plots) {
								dispatch(fieldActions.deleteFieldInFlight(flightId, fieldId, clientId, accessToken))
									.then(() => {
										toast.success("Field deleted successfully", {
											position: "top-right",
											autoClose: 5000,
											hideProgressBar: true,
											closeOnClick: true,
											pauseOnHover: true,
										});
									})
									.catch(() => {
										toast.error("Error deleting field", {
											position: "top-right",
											autoClose: 5000,
											hideProgressBar: true,
											closeOnClick: true,
											pauseOnHover: true,
										});
									});
							}
							let plotsToRemove = [];

							_.map(allPlots, (plot) => {
								if (plot.properties.field === fieldId) {
									plotsToRemove.push(plot);
								}
							});

							fieldsDirty = true;
							singleFeatureToggle = false;
							selectedFieldId = null;
							selectedTrialId = null;

							let plotIdsToRemove = _.map(plotsToRemove, "id");

							draw.current.draw.delete(plotIdsToRemove);
							_.pullAll(allPlots, plotsToRemove);
							refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, "flight");

							updateQrToggleList(controlComponentRefs);

							if (removeFields) {
								let fieldsInDropdown = dropdownRef.current.innerRef.current.currentThirdDropdownOptions();
								let prunedDdl = _.filter(fieldsInDropdown, ({ key }) => key !== fieldId);

								dropdownRef.current.innerRef.current.setThirdDropdownOptions(prunedDdl);

								let index = _.findIndex(_.map(fieldPivotPoints, "pivot"), { id: fieldId });
								fieldPivotPoints.splice(index, 1);
							}
						},
					);
				} else {
					toast.error("Cannot remove a field that has been analyzed", {
						position: "top-right",
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
					});
				}
			}
		});
	} else {
		toast.error("That field is not yet in this flight", {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
		});
	}
}

export function checkPlotsSaved(draw) {
	if (fieldCombined.length > 0) {
		uncombinePlotsInField(draw, false);
	}

	// Checks if any plots are not saved
	return _.findIndex(_.map(allPlots, "properties"), { isDirty: true });
}

export function checkPlotsLocked(draw) {
	if (fieldCombined.length > 0) {
		uncombinePlotsInField(draw, false);
	}

	// Checks if any plots are not locked
	return _.findIndex(_.map(allPlots, "properties"), { locked: false });
}

export async function handleSave(flightId, clientId, orthoImageTypes, type, getTokenSilently, dispatch, redirect) {
	// Create lists of fields to update and create
	let fieldIdsToUpdate = [];
	let fieldsToCreate = [];
	const accessToken = await getTokenSilently();
	_.map(allPlots, (plot) => {
		if (plot.properties.locked) {
			if (plot.properties.new) {
				if (_.findIndex(fieldsToCreate, { id: plot.properties.field }) == -1) {
					fieldsToCreate.push({ id: plot.properties.field, plots: [] });
				}

				let fieldIndex = _.findIndex(fieldsToCreate, { id: plot.properties.field });
				fieldsToCreate[fieldIndex].plots.push(plot);
			} else {
				let initialPlot = _.find(initialPlots, { id: plot.id });
				if (!fieldIdsToUpdate.includes(plot.properties.field)) {
					let plotHasChanged = false;
					_.map(initialPlot.geometry.coordinates[0], (initialCoords, index) => {
						if (
							applyPrecision(initialCoords[0]) !== applyPrecision(plot.geometry.coordinates[0][index][0]) ||
							applyPrecision(initialCoords[1]) !== applyPrecision(plot.geometry.coordinates[0][index][1])
						) {
							plotHasChanged = true;
						}
					});

					if (plotHasChanged || plot.properties.isDirty) {
						fieldIdsToUpdate.push(plot.properties.field);
					}
				}
			}
		}
	});

	// Create flights plots for each new field
	// eslint-disable-next-line
	const creatingPlots = await Promise.all(
		_.map(fieldsToCreate, async ({ plots }) => {
			let fieldToCreate = {
				type: "FeatureCollection",
				features: plots,
			};

			await createFlightsPlots(fieldToCreate, flightId, accessToken, dispatch);
		}),
	);

	// Create full list of plots to fields
	let fieldsToUpdate = [];
	_.map(fieldIdsToUpdate, (fieldId) => {
		let fieldToUpdate = {
			id: fieldId,
			plots: _.filter(allPlots, ({ properties }) => {
				return properties.field === fieldId;
			}),
		};

		fieldsToUpdate.push(fieldToUpdate);
	});

	// Update flights plots for each changed field
	// eslint-disable-next-line
	const updatingPlots = await Promise.all(
		_.map(fieldsToUpdate, async ({ plots }) => {
			let plotsToUpdate = [];

			_.map(plots, ({ id, geometry, properties }) => {
				let plotToUpdate = {
					flightId: flightId,
					plotId: id,
					scaleFactor: properties.scaleFactor,
					fieldId: properties.field,
					lowerLeft: {
						lat: applyPrecision(geometry.coordinates[0][0][1]),
						long: applyPrecision(geometry.coordinates[0][0][0]),
					},
					upperLeft: {
						lat: applyPrecision(geometry.coordinates[0][1][1]),
						long: applyPrecision(geometry.coordinates[0][1][0]),
					},
					upperRight: {
						lat: applyPrecision(geometry.coordinates[0][2][1]),
						long: applyPrecision(geometry.coordinates[0][2][0]),
					},
					lowerRight: {
						lat: applyPrecision(geometry.coordinates[0][3][1]),
						long: applyPrecision(geometry.coordinates[0][3][0]),
					},
				};

				plotsToUpdate.push(plotToUpdate);
			});

			await dispatch(flightsPlotsActions.updateFlightsPlots(plotsToUpdate, clientId, accessToken));
		}),
	);

	// Create quantified regions
	if (fieldsToCreate?.length > 0) {
		let plotIdsToCreate = _.map(_.flatten(_.map(fieldsToCreate, "plots")), "id");
		let plotFeatures = _.filter(allPlots, (ap) => plotIdsToCreate.includes(ap.id));
		let plotObjs = _.map(plotFeatures, (p) => {
			return {
				id: p.id,
				fieldId: p.properties.field,
				flightId: flightId,
				scaleFactor: p.properties.scaleFactor,
				fieldRangeLength: p.properties.fieldRangeLength,
				fieldColumnWidth: p.properties.fieldColWidth,
				rowCount: p.properties.fieldRowCount,
				rowSpacing: p.properties.fieldRowSpacing,
				planterOffset: p.properties.fieldPlanterOffset,
				ll: {
					lat: applyPrecision(p.geometry.coordinates[0][0][1]),
					long: applyPrecision(p.geometry.coordinates[0][0][0]),
				},
				ul: {
					lat: applyPrecision(p.geometry.coordinates[0][1][1]),
					long: applyPrecision(p.geometry.coordinates[0][1][0]),
				},
				ur: {
					lat: applyPrecision(p.geometry.coordinates[0][2][1]),
					long: applyPrecision(p.geometry.coordinates[0][2][0]),
				},
				lr: {
					lat: applyPrecision(p.geometry.coordinates[0][3][1]),
					long: applyPrecision(p.geometry.coordinates[0][3][0]),
				},
			};
		});

		dispatch(quantifiedRegionActions.createFlightsQuantifiedRegions(plotObjs, accessToken));
	}

	// Update quantified regions of updated plots
	let plotIdsToUpdate = _.map(
		_.filter(allPlots, (ap) => fieldIdsToUpdate.includes(ap.properties.field)),
		"id",
	);
	if (plotIdsToUpdate?.length > 0) {
		let plotFeatures = _.filter(allPlots, (ap) => plotIdsToUpdate.includes(ap.id));
		let plotObjs = _.map(plotFeatures, (p) => {
			return {
				id: p.id,
				fieldId: p.properties.field,
				flightId: flightId,
				scaleFactor: p.properties.scaleFactor,
				fieldRangeLength: p.properties.fieldRangeLength,
				fieldColumnWidth: p.properties.fieldColWidth,
				rowCount: p.properties.fieldRowCount,
				rowSpacing: p.properties.fieldRowSpacing,
				planterOffset: p.properties.fieldPlanterOffset,
				ll: {
					lat: applyPrecision(p.geometry.coordinates[0][0][1]),
					long: applyPrecision(p.geometry.coordinates[0][0][0]),
				},
				ul: {
					lat: applyPrecision(p.geometry.coordinates[0][1][1]),
					long: applyPrecision(p.geometry.coordinates[0][1][0]),
				},
				ur: {
					lat: applyPrecision(p.geometry.coordinates[0][2][1]),
					long: applyPrecision(p.geometry.coordinates[0][2][0]),
				},
				lr: {
					lat: applyPrecision(p.geometry.coordinates[0][3][1]),
					long: applyPrecision(p.geometry.coordinates[0][3][0]),
				},
			};
		});

		dispatch(quantifiedRegionActions.updateFlightsQuantifiedRegions(plotObjs, accessToken));
	}

	//-- Delete any data layer associations that are marked
	_.map(dataLayerFieldsToDelete, (fieldId) => {
		dispatch(fieldActions.deleteAllDataLayerFieldAssociationsForField(fieldId, clientId, accessToken));
	});

	dataLayerFieldsToDelete = [];

	// Mark all plots as saved
	_.map(allPlots, ({ properties }) => {
		properties.isDirty = false;
	});

	// Only call cut if fields have been modified
	if (fieldsToCreate.length > 0 || fieldsToUpdate.length > 0) {
		cutImage(clientId, flightId, orthoImageTypes, accessToken, dispatch, false, false, fieldsToCreate, fieldsToUpdate);
	}

	// Will redirect to next page without waiting for cut to be finished
	redirect();
}

export function setSubsamplesToAdd(quantifiedRegions) {
	subsamplesToAdd = quantifiedRegions;
}

export function setTempSubsamplesToAdd(quantifiedRegions) {
	tempSubsamplesToAdd = quantifiedRegions;
}

export function setQuantifiedRegionOptions(quantifiedRegionTypes) {
	quantifiedRegionOptions = quantifiedRegionTypes;
}

export async function saveQuantifiedRegions(flightId, dispatch, accessToken, fieldQuantifiedRegionIds, fromViewer) {
	// Create quantified regions
	if (subsamplesToAdd?.length > 0 || (fromViewer && tempSubsamplesToAdd?.length > 0)) {
		let plotIdsToCreate = _.map(_.uniqBy(fromViewer ? tempSubsamplesToAdd : subsamplesToAdd, "plotId"), "plotId");
		let plotFeatures = _.filter(fromViewer ? tempPlots : allPlots, (ap) => plotIdsToCreate.includes(ap.id));
		let plotObjs = _.map(plotFeatures, (p) => {
			return {
				id: p.id,
				fieldId: p.properties.field,
				flightId: flightId,
				scaleFactor: p.properties.scaleFactor,
				fieldRangeLength: p.properties.fieldRangeLength,
				fieldColWidth: p.properties.fieldColWidth,
				rowCount: p.properties.fieldRowCount,
				rowSpacing: p.properties.fieldRowSpacing,
				planterOffset: p.properties.fieldPlanterOffset,
				ll: {
					lat: applyPrecision(p.geometry.coordinates[0][0][1]),
					long: applyPrecision(p.geometry.coordinates[0][0][0]),
				},
				ul: {
					lat: applyPrecision(p.geometry.coordinates[0][1][1]),
					long: applyPrecision(p.geometry.coordinates[0][1][0]),
				},
				ur: {
					lat: applyPrecision(p.geometry.coordinates[0][2][1]),
					long: applyPrecision(p.geometry.coordinates[0][2][0]),
				},
				lr: {
					lat: applyPrecision(p.geometry.coordinates[0][3][1]),
					long: applyPrecision(p.geometry.coordinates[0][3][0]),
				},
			};
		});

		dispatch(quantifiedRegionActions.createFlightsQuantifiedRegions(plotObjs, accessToken, fieldQuantifiedRegionIds));
	}
}

export function setSelectedFieldId(id) {
	selectedFieldId = id;
}

export function setSelectedTrialId(id) {
	selectedTrialId = id;
}

export function toggleSingleFieldTrial(draw, canvas, type, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	if (type) {
		singleFeatureToggle = true;
		refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		let allFeatures = draw.current.draw.getAll().features;
		let idsToDelete = [];

		if (type === "field") {
			if (!selectedFieldId) {
				selectedFieldId = _.last(allFields).id;
			}

			selectedTrialId = null;

			let plotIdsInField = _.map(
				_.filter(allFeatures, ({ properties }) => properties.field === selectedFieldId),
				"id",
			);

			idsToDelete = _.filter(allFeatures, ({ id, properties }) => {
				// Check if the id is the field id for field features or if the plot field id matches
				if (id !== selectedFieldId && properties.type === "field") {
					return true;
				} else if (!plotIdsInField.includes(id) && properties.type === "plot") {
					return true;
				} else if (!plotIdsInField.includes(properties.plotId) && properties.type === "subsample") {
					return true;
				}
			});
		} else {
			if (!selectedTrialId) {
				selectedTrialId = _.last(allTrials).id;
			}

			selectedFieldId = null;

			idsToDelete = _.filter(allFeatures, ({ id, properties }) => {
				if (
					(id !== selectedTrialId && properties.plotIds) ||
					(properties.trial !== undefined && properties.trial !== selectedTrialId)
				) {
					return true;
				}
			});
		}

		draw.current.draw.delete(_.map(idsToDelete, "id"));
	} else {
		singleFeatureToggle = false;
		refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	}
}

function combinePlotsInField(draw, addToSelection = false, controlComponentRefs = null) {
	// Selects all plots in field
	let selectedFeatures = [];
	if (!addToSelection && fieldsDirty) {
		recalculateFieldBoundaries();
	} else {
		selectedFeatures = draw.current.draw.getSelected().features;
		selectedFeatures = _.filter(selectedFeatures, ({ id }) => {
			return id !== selectedFieldId;
		});
	}

	draw.current.draw.changeMode("simple_select", {
		featureIds: [],
	});

	let plots = _.find(allFields, { id: selectedFieldId }).properties.plotIds;
	let selectedPlots = _.cloneDeep(plots);

	// Hide subsamples if they are toggled
	//-- Don't care about default subsamples
	if (pcToggle || pcQrToggle || rcQrToggle || brQrToggle || frQrToggle || scQrToggle) {
		let subsamplesInPlot = _.filter(subsamples, (s) => plots.includes(s.properties.plotId));

		// Filter on toggled subsample type
		let qrTypeId = _.find(quantifiedRegionOptions, (qro) => {
			if (pcToggle) return qro.name === "Plot-Centered";
			if (pcQrToggle) return qro.name === "Plot-Centered with Subsamples";
			if (rcQrToggle) return qro.name === "Row-Centered";
			if (brQrToggle) return qro.name === "Between-Row";
			if (frQrToggle) return qro.name === "Full Row";
			if (scQrToggle) return qro.name === "Stand Count";
		})?.id;

		let subsampleIds = _.map(
			_.filter(subsamplesInPlot, (sp) => sp.properties.quantifiedRegionTypeId === qrTypeId),
			"id",
		);
		draw.current.draw.delete(subsampleIds);
	}

	// Combine field
	selectedPlots.unshift(selectedFieldId);

	// Make sure plots are drawn
	let plotToggleState = _.cloneDeep(plotBoundaryToggle);
	if (!plotBoundaryToggle) {
		plotToggle(draw, controlComponentRefs);
	}

	draw.current.draw.changeMode("simple_select", {
		featureIds: selectedPlots,
	});

	// Combines selected features
	draw.current.draw.combineFeatures();

	let selectedIds = [];
	if (addToSelection) {
		selectedIds = selectedIds.concat(_.map(selectedFeatures, "id"));
	}
	selectedIds = selectedIds.concat(draw.current.draw.getSelected().features[0].id);

	// Select rows if toggled -- Don't combine
	if (rowsToggle) {
		let selectedRows = _.map(
			_.filter(allRows, ({ properties }) => {
				return plots.includes(properties.plot);
			}),
			"id",
		);

		draw.current.draw.changeMode("simple_select", {
			featureIds: selectedRows,
		});

		// Combines selected features
		draw.current.draw.combineFeatures();

		selectedIds = selectedIds.concat(draw.current.draw.getSelected().features[0].id);
	}

	// Select ll point if toggled
	if (llToggle) {
		selectedIds = selectedIds.concat(
			allLLPoints[_.findIndex(_.map(allLLPoints, "properties"), { field: selectedFieldId })].id,
		);
	}

	draw.current.draw.changeMode("simple_select", {
		featureIds: selectedIds,
	});

	if (!plotToggleState) {
		plotToggle(draw, controlComponentRefs);
	}
}

export function uncombinePlotsInField(draw, reselect) {
	if (draw?.current) {
		let idToSelect = draw.current.draw.getSelectedIds();

		draw.current.draw.changeMode("simple_select", {
			featureIds: [...fieldCombined],
		});

		// Uncombines selected features
		draw.current.draw.uncombineFeatures();

		draw.current.draw.changeMode("simple_select", {
			featureIds: [...rowsCombined],
		});

		// Uncombines selected features
		draw.current.draw.uncombineFeatures();

		// De-select field, re-select original feature clicked
		fieldCombined = [];
		rowsCombined = [];
		if (idToSelect.length > 0 && reselect) {
			draw.current.draw.changeMode("simple_select", {
				featureIds: idToSelect,
			});
		} else {
			draw.current.draw.changeMode("simple_select");
		}
	}
}

function selectPlotFromRow(draw, rowId, controlComponentRefs = null) {
	if (plotBoundaryToggle) {
		let plotId = _.find(allRows, { id: rowId }).properties.plot;

		// Select other rows
		let idsToSelect = [plotId].concat(
			_.map(
				_.filter(allRows, ({ properties }) => properties.plot === plotId),
				"id",
			),
		);

		draw.current.draw.changeMode("simple_select", {
			featureIds: idsToSelect,
		});
	} else {
		selectedFieldId = _.find(allRows, { id: rowId }).properties.field;
		combinePlotsInField(draw, false, controlComponentRefs);
	}
}

function bringSubsamplesToTopLayer(draw) {
	if (pcToggle || pcQrToggle || rcQrToggle || brQrToggle || frQrToggle || scQrToggle) {
		let subsampleFeatureIds = _.map(
			_.filter(draw.current.draw.getAll().features, (feature) => feature.properties.type === "subsample"),
			"id",
		);

		_.map(subsampleFeatureIds, (featureId) => {
			let feature = draw.current.draw.get(featureId);
			draw.current.draw.delete(featureId);
			draw.current.draw.add(feature);
		});
	}
}

export function scaleOutward(draw, orthoAnalyzedModal, dataLayerDeleteModal, e) {
	if (draw?.current) {
		if (fieldCombined.length === 1) {
			_.map(fieldCombined, (combinedFieldId) => {
				//-- Find field to scale
				let feature = draw.current.draw.get(combinedFieldId);
				if (!feature.properties.locked) {
					let fieldIndex = _.findIndex(allFields, { id: feature.properties.field });
					let field = allFields[fieldIndex];

					//-- Add scale factor by static metric
					let newScaleFactor =
						Math.round(
							(field.properties.scaleFactor +
								(scalingMetric / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1) +
								Number.EPSILON) *
								1000,
						) / 1000;

					//-- Get the current scale period
					//---- 1 being the first time a user scales
					let scalePeriod = parseFloat(
						(
							Math.abs(1 - newScaleFactor) /
							((scalingMetric / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1))
						).toFixed(3),
					);

					//-- Find the actual rate of change
					//-- https://www.mathsisfun.com/money/compound-interest-derivation.html
					let scale =
						newScaleFactor !== 1
							? Math.pow(newScaleFactor, 1 / scalePeriod)
							: 1 + (scalingMetric / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1);

					//-- If user was scaling inward, apply inverse scale until object is smaller than the original scale
					if (scale < 1) {
						scale = Math.abs(1 - (scale - 1));
					}

					//-- Apply scale to drawn object
					turf.truncate(
						turf.transformScale(feature, scale, {
							origin: field.properties.initialLL,
							mutate: true,
						}),
						precisionOptions,
					);

					//-- Update scale on plot and field properties
					allFields[fieldIndex].properties.scaleFactor = parseFloat(parseFloat(newScaleFactor).toFixed(3)); // setting precision to 3 decimals, converting back to number

					draw.current.draw.add(feature);

					updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
				} else {
					toast.warn(`Cannot scale field ${feature.properties.fieldName} while it is locked`, {
						position: "top-right",
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
					});
				}
			});
		} else if (fieldCombined.length > 1) {
			// Selecting multiple fields during scaling causes major lag
			// Take out if-else when allowing multiple fields
			toast.info("Please only select one field to scale", {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
			});
		} else {
			toast.info("Select a field to scale", {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
			});
		}
	}
}

export function scaleInward(draw, orthoAnalyzedModal, dataLayerDeleteModal, e) {
	if (draw?.current) {
		if (fieldCombined.length === 1) {
			_.map(fieldCombined, (combinedFieldId) => {
				//-- Find field to scale
				let feature = draw.current.draw.get(combinedFieldId);
				if (!feature.properties.locked) {
					let fieldIndex = _.findIndex(allFields, { id: feature.properties.field });
					let field = allFields[fieldIndex];

					//-- Subtract scale factor by static metric
					let newScaleFactor =
						Math.round(
							(field.properties.scaleFactor -
								(scalingMetric / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1) +
								Number.EPSILON) *
								1000,
						) / 1000;

					//-- Get the current scale period
					//---- 1 being the first time a user scales
					let scalePeriod = parseFloat(
						(
							Math.abs(1 - newScaleFactor) /
							((scalingMetric / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1))
						).toFixed(3),
					);

					//-- Find the actual rate of change
					//-- https://www.mathsisfun.com/money/compound-interest-derivation.html
					let scale =
						newScaleFactor !== 1
							? Math.pow(newScaleFactor, 1 / scalePeriod)
							: 1 - (scalingMetric / (e.ctrlKey ? fineConstant : 1)) * (e.altKey ? coarseConstant : 1);

					//-- If user was scaling outward, apply inverse scale until object is smaller than the original scale
					if (scale > 1) {
						scale = Math.abs(1 - (scale - 1));
					}

					//-- Apply scale to drawn object
					turf.truncate(
						turf.transformScale(feature, scale, {
							origin: field.properties.initialLL,
							mutate: true,
						}),
						precisionOptions,
					);

					//-- Update scale on plot and field properties
					allFields[fieldIndex].properties.scaleFactor = parseFloat(parseFloat(newScaleFactor).toFixed(3));

					draw.current.draw.add(feature);

					updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
				} else {
					toast.warn(`Cannot scale field ${feature.properties.fieldName} while it is locked`, {
						position: "top-right",
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
					});
				}
			});
		} else if (fieldCombined.length > 1) {
			// Selecting multiple fields during scaling causes major lag
			toast.info("Please only select one field to scale", {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
			});
		} else {
			toast.info("Select a field to scale", {
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
			});
		}
	}
}

export function setPlots(plots) {
	allPlots = plots;
}

export function setTempPlots(plots) {
	tempPlots = plots;
}

export function handleDragging(draw) {
	if (movingFieldProperties?.length === 0) {
		let featuresSelected = draw.current.draw.getSelected().features;

		if (fieldCombined.length > 0 && featuresSelected[0].geometry.coordinates.length > 1) {
			const fieldDrawings = _.filter(featuresSelected, (feature) => {
				return feature.properties.type === "field";
			});
			let featuresToKeep = [];
			let featuresToRemove = [];

			_.map(featuresSelected, (feature) => {
				feature.properties.type === "llPoint" || feature.geometry.type === "MultiLineString"
					? featuresToKeep.push(feature)
					: featuresToRemove.push(feature);
			});

			let featureIdsToKeep = _.map(featuresToKeep, "id");
			let featureIdsToRemove = _.map(featuresToRemove, "id");

			nonPlotDrawingsDeleted = _.filter(featuresToRemove, ({ id }) => {
				return !_.map(fieldDrawings, "id").includes(id);
			});
			movingFieldProperties = fieldDrawings;

			draw.current.draw.delete([...featureIdsToRemove, ...featureIdsToKeep]);

			// Stripping away the extra plots
			let draggableFieldDrawing = _.map(fieldDrawings, (f) => {
				return {
					id: f.id,
					properties: {
						field: f.properties.field,
						initalLL: f.properties.initialLL,
						locked: f.properties.locked,
						type: f.properties.type,
					},
					geometry: {
						coordinates: [f.geometry.coordinates[0][0]],
						type: "Polygon",
					},
				};
			});

			let featuresToAdd = {
				type: "FeatureCollection",
				features: [...draggableFieldDrawing, ...featuresToKeep],
			};

			draw.current.draw.add(featuresToAdd);

			featureIdsToKeep.unshift(..._.map(draggableFieldDrawing, "id"));

			draw.current.draw.changeMode("simple_select", {
				featureIds: featureIdsToKeep,
			});
		}
	}
}

export async function handleCreate(
	e,
	draw,
	controlComponentRefs,
	addFieldModal,
	addExistingFieldsModal,
	clientId,
	getTokenSilently,
	dispatch,
	flightId,
) {
	let currentMode = draw.current.draw.getMode();
	if (currentMode === "new_field_mode") {
		if (e.features[0].geometry.type === "LineString") {
			newFieldLine = e.features[0];
			draw.current.draw.delete(e.features[0].id);

			//-- Closes measurement popup, opens add field modal
			const accessToken = await getTokenSilently();
			dispatch(fieldActions.getUnusedFields(clientId, flightId, accessToken)).then((res) => {
				if (controlComponentRefs?.measurePopupRef?.current) {
					controlComponentRefs.measurePopupRef.current.setOpen(false);
				}

				if (res || res.length > 0) {
					addExistingFieldsModal.current.handleClick();
				} else {
					addFieldModal.current.handleClick();
				}
			});
		}
	} else {
		if (drawnFeature) {
			clearMeasurements(draw);
		}
		drawnFeature = e.features[0];
		if (drawnFeature && controlComponentRefs.measurePopupRef) {
			getMeasuredCoords(drawnFeature, controlComponentRefs.measurePopupRef);
			if (currentMode === "line_measure") {
				measureLineDistance(drawnFeature, controlComponentRefs.measurePopupRef);
			} else if (currentMode === "polygon_measure" || currentMode === "rectangle_measure") {
				measureArea(drawnFeature, controlComponentRefs.measurePopupRef);
			}
		}
	}
}

export function handleUpdate(e, draw, feature, orthoAnalyzedModal, dataLayerDeleteModal, measurePopupRef) {
	if (fieldCombined.length > 0) {
		handleEndDragging(draw, orthoAnalyzedModal, dataLayerDeleteModal);
	} else {
		updateArea(draw, feature, orthoAnalyzedModal, dataLayerDeleteModal);
	}

	if (e.features[0].properties.meta === "drawn_feature") {
		drawnFeature = e.features[0];
		let currentMode = drawnFeature.geometry.type;
		if (drawnFeature && measurePopupRef) {
			getMeasuredCoords(drawnFeature, measurePopupRef);
			if (currentMode === "LineString") {
				measureLineDistance(drawnFeature, measurePopupRef);
			} else if (currentMode === "Polygon") {
				measureArea(drawnFeature, measurePopupRef);
			}
		}
	}
}

export function handleEndDragging(draw, orthoAnalyzedModal, dataLayerDeleteModal) {
	if (movingFieldProperties.length > 0) {
		let selectedFeatures = draw.current.draw.getSelected().features;
		let movedFields = [];
		let nonFieldSelectedFeatures = [];

		_.map(selectedFeatures, (feature) => {
			feature.properties.type === "field" ? movedFields.push(feature) : nonFieldSelectedFeatures.push(feature);
		});

		if (
			_.filter(movedFields, ({ properties }) => {
				return properties.locked;
			}).length !== 0
		) {
			toast.warn("Your changes to this feature will not be saved while it's locked");
		} else {
			let movedFieldIds = _.map(movedFields, (mf) => mf.properties.field);
			let fieldPlots = _.filter(allPlots, (ap) => movedFieldIds.includes(ap.properties.field));
			if (fieldPlots.some((x) => x.properties.analyzed)) {
				orthoAnalyzedModal.current.setFieldIds(movedFieldIds);
				orthoAnalyzedModal.current.updateActiveElement(document.activeElement);
				orthoAnalyzedModal.current.updateDraw(draw);
				orthoAnalyzedModal.current.setFeatures(movedFields);
				orthoAnalyzedModal.current.openModal();
			}

			if (_.some(movedFieldIds, (fieldId) => firstFlightFields?.includes(fieldId))) {
				dataLayerDeleteModal.current.setFieldIds(_.filter(movedFieldIds, (id) => firstFlightFields.includes(id)));
				dataLayerDeleteModal.current.updateActiveElement(document.activeElement);
				dataLayerDeleteModal.current.openModal();
			}

			fieldsDirty = true;
		}

		let nonFieldSelectedFeatureIds = _.map(nonFieldSelectedFeatures, "id");

		let featuresToAdd = {
			type: "FeatureCollection",
			features: [],
		};

		let deltaX = 0;
		let deltaY = 0;

		_.map(movedFields, (movedField) => {
			let fieldProperties = _.find(movingFieldProperties, { id: movedField.id });

			deltaX = applyPrecision(
				movedField.geometry.coordinates[0][0][0] - fieldProperties.geometry.coordinates[0][0][0][0],
			);
			deltaY = applyPrecision(
				movedField.geometry.coordinates[0][0][1] - fieldProperties.geometry.coordinates[0][0][0][1],
			);

			// Add delta to all plot coordinates
			_.map(fieldProperties.geometry.coordinates, (coordinates) => {
				_.map(coordinates[0], (xy) => {
					xy[0] += deltaX;
					xy[1] += deltaY;
				});
			});

			featuresToAdd.features.push(fieldProperties);
		});

		draw.current.draw.delete([..._.map(movedFields, "id"), ...nonFieldSelectedFeatureIds]);

		featuresToAdd.features = featuresToAdd.features.concat(nonFieldSelectedFeatures);

		movingFieldProperties = [];

		// Add delta to all non plot coordinates
		_.map(nonPlotDrawingsDeleted, (feature) => {
			if (feature.geometry.type === "Polygon") {
				_.map(feature.geometry.coordinates[0], (coordinates) => {
					coordinates[0] += deltaX;
					coordinates[1] += deltaY;
				});
			} else {
				_.map(feature.geometry.coordinates, (coordinates) => {
					coordinates[0] += deltaX;
					coordinates[1] += deltaY;
				});
			}

			featuresToAdd.features.push(feature);
		});

		nonPlotDrawingsDeleted = [];

		draw.current.draw.add(featuresToAdd);

		let addedFeatureIds = _.map(featuresToAdd.features, "id");

		draw.current.draw.changeMode("simple_select", {
			featureIds: addedFeatureIds.concat(nonFieldSelectedFeatureIds),
		});
	}
}

export function selectRow(plotId, draw) {
	if (plotId && draw) {
		let plot = _.find(allPlots, { id: plotId });

		let plotsToSelectFrom = _.cloneDeep(trialPlots);
		let plotIdsWithTrials = _.map(_.map(plotsToSelectFrom, "properties"), "plotId");

		_.map(allPlots, (singlePlot) => {
			if (!plotIdsWithTrials.includes(singlePlot.id)) {
				plotsToSelectFrom.push(singlePlot);
			}
		});

		let plotsToSelect = _.filter(plotsToSelectFrom, ({ properties }) => {
			if (trialPlots.length > 0 && singleFeatureToggle) {
				return properties.trial === plot.properties.trial && properties.range === plot.properties.range;
			} else {
				return properties.field === plot.properties.field && properties.range === plot.properties.range;
			}
		});

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(plotsToSelect, (p) => p.properties.plotId ?? p.id),
		});
	}
}

export function selectColumn(plotId, draw) {
	if (plotId && draw) {
		let plot = _.find(allPlots, { id: plotId });

		let plotsToSelectFrom = _.cloneDeep(trialPlots);
		let plotIdsWithTrials = _.map(_.map(plotsToSelectFrom, "properties"), "plotId");

		_.map(allPlots, (singlePlot) => {
			if (!plotIdsWithTrials.includes(singlePlot.id)) {
				plotsToSelectFrom.push(singlePlot);
			}
		});

		let plotsToSelect = _.filter(plotsToSelectFrom, ({ properties }) => {
			if (trialPlots.length > 0 && singleFeatureToggle) {
				return properties.trial === plot.properties.trial && properties.column === plot.properties.column;
			} else {
				return properties.field === plot.properties.field && properties.column === plot.properties.column;
			}
		});

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(plotsToSelect, (p) => p.properties.plotId ?? p.id),
		});
	}
}

export function selectGrid(plotId, draw, level) {
	if (plotId && draw) {
		let plot = _.find(allPlots, { id: plotId });

		let plotsToSelectFrom = _.cloneDeep(trialPlots);
		let plotIdsWithTrials = _.map(_.map(plotsToSelectFrom, "properties"), "plotId");

		_.map(allPlots, (singlePlot) => {
			if (!plotIdsWithTrials.includes(singlePlot.id)) {
				plotsToSelectFrom.push(singlePlot);
			}
		});

		let plotsToSelect = _.filter(plotsToSelectFrom, ({ properties }) => {
			return level !== "trial"
				? properties.field === plot.properties.field
				: properties.trial === plot.properties.trial;
		});

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(plotsToSelect, (p) => p.properties.plotId ?? p.id),
		});
	}
}

export function selectRep(plotId, subsampleId, draw) {
	if ((plotId || subsampleId) && draw) {
		if (!plotId) {
			plotId = _.find(subsamples, { id: subsampleId })?.properties.plotId;
		}

		let plot = _.find(allPlots, { id: plotId });

		let plotsToSelectFrom = _.cloneDeep(trialPlots);
		let plotIdsWithTrials = _.map(_.map(plotsToSelectFrom, "properties"), "plotId");

		_.map(allPlots, (singlePlot) => {
			if (!plotIdsWithTrials.includes(singlePlot.id)) {
				plotsToSelectFrom.push(singlePlot);
			}
		});

		let plotsToSelect = _.filter(plotsToSelectFrom, ({ properties }) => {
			if (trialPlots.length > 0 && singleFeatureToggle) {
				return properties.trial === plot.properties.trial && properties.replicate === plot.properties.replicate;
			} else {
				return properties.field === plot.properties.field && properties.replicate === plot.properties.replicate;
			}
		});

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(plotsToSelect, (p) => p.properties.plotId ?? p.id),
		});
	}
}

export function selectSubsampleRow(subsampleId, draw) {
	if (subsampleId && draw) {
		let subsample = _.find(subsamples, { id: subsampleId });

		let subsamplesToSelect = _.filter(
			subsamples,
			(s) =>
				s.properties.fieldQuantifiedRegionId === subsample.properties.fieldQuantifiedRegionId &&
				s.properties.plotId === subsample.properties.plotId &&
				s.properties.range === subsample.properties.range,
		);

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(subsamplesToSelect, "id"),
		});
	}
}

export function selectSubsampleColumn(subsampleId, draw) {
	if (subsampleId && draw) {
		let subsample = _.find(subsamples, { id: subsampleId });

		let subsamplesToSelect = _.filter(
			subsamples,
			(s) =>
				s.properties.fieldQuantifiedRegionId === subsample.properties.fieldQuantifiedRegionId &&
				s.properties.plotId === subsample.properties.plotId &&
				s.properties.column === subsample.properties.column,
		);

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(subsamplesToSelect, "id"),
		});
	}
}

export function selectSubsampleGrid(subsampleId, draw) {
	if (subsampleId && draw) {
		let subsample = _.find(subsamples, { id: subsampleId });

		let subsamplesToSelect = _.filter(
			subsamples,
			(s) =>
				s.properties.fieldQuantifiedRegionId === subsample.properties.fieldQuantifiedRegionId &&
				s.properties.plotId === subsample.properties.plotId,
		);

		draw.current.draw.changeMode("simple_select", {
			featureIds: _.map(subsamplesToSelect, "id"),
		});
	}
}

export function isFieldCombined() {
	return fieldCombined.length > 0;
}

export async function deleteExistingMarkedFeatures(
	features,
	draw,
	dispatch,
	getTokenSilently,
	clientId,
	canvas,
	controlComponentRefs,
	modalRef,
	queryClient,
) {
	const accessToken = await getTokenSilently();

	const featureIdsToReselect = draw.current.draw.getSelectedIds();

	const plotDeleteInfo = { clientId: clientId, markedPlots: [], plotTrialPairs: [] };
	const quantifiedRegionDeleteInfo = { clientId: clientId, markedQuantifiedRegions: [], plotTrialPairs: [] };

	for (const feature of features) {
		if (feature.plotId) {
			markedPlots = _.filter(
				markedPlots,
				(mp) =>
					mp.plotId !== feature.plotId ||
					mp.flightId !== feature.flightId ||
					new Date(mp.dateAndTime).toLocaleString() !== new Date(feature.dateAndTime).toLocaleString() ||
					mp.isAllData !== feature.isAllData ||
					mp.plotStatusId !== feature.plotStatusId,
			);

			plotDeleteInfo.markedPlots.push({
				plotId: feature.plotId,
				flightId: feature.isAllData ? null : feature.flightId,
				dateAndTime: feature.isAllData ? null : feature.dateAndTime,
				isAllData: feature.isAllData,
				plotStatusId: feature.plotStatusId,
			});

			let matchingPlotFeature = _.find(
				draw.current.draw.getAll().features,
				(f) => (f.id === feature.plotId || f.properties.plotId === feature.plotId) && !f.properties.quantifiedRegionId,
			);

			plotDeleteInfo.plotTrialPairs.push({
				plotId: feature.plotId,
				trialId: matchingPlotFeature.properties.trial,
			});

			//-- Update subsample colors
			const matchingSubsamples = _.filter(subsamples, ({ properties }) => properties.plotId === feature.plotId);
			if (matchingSubsamples.length > 0) {
				applyNewSubsampleBoundaryColors(
					matchingSubsamples,
					draw,
					controlComponentRefs?.quantifiedRegionToggleRef?.current?.anyQrsToggled,
				);
			}
		} else if (feature.quantifiedRegionId) {
			markedSubsamples = _.filter(
				markedSubsamples,
				(ms) =>
					ms.quantifiedRegionId !== feature.quantifiedRegionId ||
					ms.flightId !== feature.flightId ||
					new Date(ms.dateAndTime).toLocaleString() !== new Date(feature.dateAndTime).toLocaleString() ||
					ms.isAllData !== feature.isAllData ||
					ms.quantifiedRegionStatusId !== feature.plotStatusId,
			);

			const matchingSubsampleFeature = _.find(
				draw.current.draw.getAll().features,
				(f) => f.properties.quantifiedRegionId === feature.quantifiedRegionId,
			);

			if (matchingSubsampleFeature) {
				applyNewSubsampleBoundaryColors([matchingSubsampleFeature], draw);
			} else {
				const tempFeature = {
					properties: {
						quantifiedRegionId: feature.quantifiedRegionId,
						flightDate: feature.dateAndTime,
						flightId: feature.flightId,
					},
				};
				applyNewSubsampleBoundaryColors([tempFeature], draw, false);
			}

			quantifiedRegionDeleteInfo.markedQuantifiedRegions.push({
				quantifiedRegionId: feature.quantifiedRegionId,
				flightId: feature.isAllData ? null : feature.flightId,
				dateAndTime: feature.isAllData ? null : feature.dateAndTime,
				isAllData: feature.isAllData,
				plotStatusId: feature.plotStatusId,
			});

			let matchingParentPlot = _.find(
				draw.current.draw.getAll().features,
				(f) => f.properties.plotId === feature.parentPlotId || f.id === feature.parentPlotId,
			);

			quantifiedRegionDeleteInfo.plotTrialPairs.push({
				plotId: feature.parentPlotId,
				trialId: matchingParentPlot.properties.trial,
			});
		}
	}
	if (plotDeleteInfo.markedPlots.length > 0) {
		await dispatch(markedPlotActions.deleteMarkedPlots(plotDeleteInfo, accessToken));
	}

	if (quantifiedRegionDeleteInfo.markedQuantifiedRegions.length > 0) {
		await dispatch(markedPlotActions.deleteMarkedQuantifiedRegions(quantifiedRegionDeleteInfo, accessToken));
	}

	controlComponentRefs?.heatmapTimelineRef?.current?.getPlotAnalysisResults();
	modalRef.current.doneDeleting();

	if (defMarkersToggle) {
		defMarkerToggle(canvas, controlComponentRefs);
		defMarkerToggle(canvas, controlComponentRefs);
	}

	controlComponentRefs?.flagPlotsRef?.current?.closeModal();
	draw.current.draw.changeMode("simple_select", { featureIds: featureIdsToReselect });
	queryClient.invalidateQueries({ queryKey: ["annotation data"] });
}

function setSelectedPlotStatuses(
	checkedOptions,
	notes,
	draw,
	timelineRef,
	navigationFlightId,
	flightOptions,
	controlComponentRefs,
) {
	let toastPlotStatusId = "plot-status";
	let flightId = navigationFlightId ?? timelineRef.current.currentFlightId;
	let selectedFeatures = draw.current.draw.getSelected().features;
	if (selectedFeatures.length > 0) {
		let plotFeatures = _.filter(selectedFeatures, (feature) => {
			return feature.properties.type === "plot";
		});
		if (plotFeatures.length > 0) {
			_.map(plotFeatures, (feature) => {
				let plotId = feature.properties?.plotId ?? feature.id;
				let trialId = feature.properties.trial;

				//-- Find matching marked plot to replace
				let matchingMarkedPlot = _.findIndex(
					markedPlots,
					(mp) =>
						mp.plotId === plotId &&
						((mp.flightId === flightId &&
							new Date(mp.dateAndTime).getTime() === new Date(timelineRef.current.getCurrentFlightDate()).getTime()) ||
							(mp.dateAndTime === checkedOptions.dateAndTime && !mp.isAllData) ||
							(mp.isAllData &&
								checkedOptions.timeframe === "All Data" &&
								mp.plotStatusName === checkedOptions.plotStatusName)),
				);

				if (matchingMarkedPlot !== -1) {
					_.pullAt(markedPlots, [matchingMarkedPlot]);
				}

				let dateAndTime =
					checkedOptions.dateAndTime ??
					(checkedOptions.timeframe !== "All Data"
						? _.find(flightOptions, { flightId: flightId })?.flightDateAndTime
						: null);

				markedPlots.push({
					plotId: plotId,
					plotStatusName: checkedOptions.plotStatusName,
					plotStatusId: checkedOptions.plotStatusId,
					dateAndTime: dateAndTime,
					isAllData: checkedOptions.timeframe === "All Data",
					flightId:
						checkedOptions.timeframe === "This Flight Onward" || checkedOptions.timeframe === "One Time"
							? flightId
							: null,
					notes: notes,
					trialId: trialId,
					annotationClassifier: checkedOptions.annotationClassifier,
					oneTime: checkedOptions.plotStatusName === "Excluded" ? checkedOptions.oneTime : false,
					modifiedBy: checkedOptions.modifiedBy,
					modifiedDateTime: checkedOptions.modifiedDateTime,
				});

				//-- Update subsample colors
				const matchingSubsamples = _.filter(subsamples, ({ properties }) => properties.plotId === plotId);
				if (matchingSubsamples.length > 0) {
					applyNewSubsampleBoundaryColors(
						matchingSubsamples,
						draw,
						controlComponentRefs?.quantifiedRegionToggleRef?.current?.anyQrsToggled,
					);
				}
			});
		} else {
			if (!toast.isActive(toastPlotStatusId)) {
				toast.error("No plots were selected", {
					toastId: toastPlotStatusId,
				});
			}
		}
	} else {
		if (!toast.isActive(toastPlotStatusId)) {
			toast.error("No features were selected", {
				toastId: toastPlotStatusId,
			});
		}
	}
}

function setSelectedSubsampleStatuses(checkedOptions, notes, draw, timelineRef, flightOptions) {
	let selectedFeatures = draw.current.draw.getSelected().features;
	let flightId = timelineRef.current.currentFlightId;
	if (selectedFeatures.length > 0) {
		let subsampleFeatures = _.filter(selectedFeatures, (feature) => {
			return feature.properties.type === "subsample";
		});
		if (subsampleFeatures.length > 0) {
			_.map(subsampleFeatures, (feature) => {
				let quantifiedRegionId = feature.properties.quantifiedRegionId;
				let trialId = feature.properties.trial;

				let matchingMarkedSubsample = _.findIndex(
					markedSubsamples,
					(ms) =>
						ms.quantifiedRegionId === quantifiedRegionId &&
						((ms.flightId === flightId &&
							new Date(ms.dateAndTime).getTime() === new Date(timelineRef.current.getCurrentFlightDate()).getTime()) ||
							(ms.dateAndTime === checkedOptions.dateAndTime && !ms.isAllData) ||
							(ms.isAllData &&
								checkedOptions.timeframe === "All Data" &&
								ms.quantifiedRegionStatusName === checkedOptions.plotStatusName)),
				);

				if (matchingMarkedSubsample !== -1) {
					_.pullAt(markedSubsamples, [matchingMarkedSubsample]);
				}

				let dateAndTime =
					checkedOptions.dateAndTime ??
					(checkedOptions.timeframe !== "All Data"
						? _.find(flightOptions, { flightId: flightId })?.flightDateAndTime
						: null);

				markedSubsamples.push({
					quantifiedRegionId: quantifiedRegionId,
					quantifiedRegionStatusName: checkedOptions.plotStatusName,
					quantifiedRegionStatusId: checkedOptions.plotStatusId,
					isAllData: checkedOptions.timeframe === "All Data",
					dateAndTime: dateAndTime,
					flightId:
						checkedOptions.timeframe === "This Flight Onward" || checkedOptions.timeframe === "One Time"
							? flightId
							: null,
					notes: notes,
					trialId: trialId,
					annotationClassifier: checkedOptions.annotationClassifier,
					oneTime: checkedOptions.plotStatusName === "Excluded" ? checkedOptions.oneTime : false,
					modifiedBy: checkedOptions.modifiedBy,
					modifiedDateTime: checkedOptions.modifiedDateTime,
				});
			});

			//-- Apply new boundary colors
			applyNewSubsampleBoundaryColors(subsampleFeatures, draw);
		}
	}
}

const applyNewSubsampleBoundaryColors = (subsampleFeatures, draw, redraw = true) => {
	_.map(subsampleFeatures, (sf) => {
		let allStatusesForSubsample = _.map(
			_.filter(
				markedSubsamples,
				(ms) =>
					ms.quantifiedRegionId === sf.properties.quantifiedRegionId &&
					((new Date(ms.dateAndTime).getTime() <= new Date(sf.properties.flightDate).getTime() &&
						ms.quantifiedRegionStatusName !== "Excluded") ||
						(new Date(ms.dateAndTime).getTime() === new Date(sf.properties.flightDate).getTime() &&
							ms.quantifiedRegionStatusName === "Excluded") ||
						ms.flightId === sf.properties.flightId ||
						ms.isAllData),
			),
			"quantifiedRegionStatusName",
		);

		allStatusesForSubsample = [
			...allStatusesForSubsample,
			..._.map(
				_.filter(
					markedPlots,
					(ms) =>
						ms.plotId === sf.properties.plotId &&
						((new Date(ms.dateAndTime).getTime() <= new Date(sf.properties.flightDate).getTime() &&
							ms.quantifiedRegionStatusName !== "Excluded") ||
							(new Date(ms.dateAndTime).getTime() === new Date(sf.properties.flightDate).getTime() &&
								ms.quantifiedRegionStatusName === "Excluded") ||
							ms.flightId === sf.properties.flightId ||
							ms.isAllData),
				),
				"plotStatusName",
			),
		];

		let matchingSubsampleIndex = _.findIndex(
			subsamples,
			(s) => s.properties.quantifiedRegionId === sf.properties.quantifiedRegionId,
		);
		if (matchingSubsampleIndex !== -1) {
			subsamples[matchingSubsampleIndex].properties.portColor = "#42adf5";

			if (allStatusesForSubsample.includes("Excluded") || allStatusesForSubsample.includes("Flagged")) {
				subsamples[matchingSubsampleIndex].properties.defColor = "#ff00ff";
			} else {
				delete subsamples[matchingSubsampleIndex].properties.defColor;
			}

			if (redraw) {
				draw.current.draw.delete(subsamples[matchingSubsampleIndex].id);
				draw.current.draw.add(subsamples[matchingSubsampleIndex]);
			}
		}
	});
};

export function handleApplyStatuses(
	checkedOptions,
	notes,
	draw,
	timelineRef,
	modalRef,
	clientId,
	dispatch,
	getTokenSilently,
	canvas,
	controlComponentRefs,
	navigationFlightId = null,
	flightOptions,
	queryClient,
) {
	let selectedFeatures = draw.current.draw.getSelected().features;
	let featureTypes = _.map(selectedFeatures, "properties.type");
	let subsample = _.some(featureTypes, (ft) => ft === "subsample");

	if (subsample) {
		applySubsampleStatuses(
			checkedOptions,
			notes,
			draw,
			timelineRef,
			modalRef,
			clientId,
			dispatch,
			getTokenSilently,
			canvas,
			controlComponentRefs,
			flightOptions,
		);
	} else {
		applyPlotStatuses(
			checkedOptions,
			notes,
			draw,
			timelineRef,
			modalRef,
			clientId,
			dispatch,
			getTokenSilently,
			canvas,
			controlComponentRefs,
			navigationFlightId,
			flightOptions,
		);
	}

	if (controlComponentRefs?.defMarkerToggleRef?.current?.checkToggleState === false) {
		defMarkerToggle(canvas, controlComponentRefs);
	}

	queryClient.invalidateQueries({ queryKey: ["annotation data"] });
}

export async function applyPlotStatuses(
	checkedOptions,
	notes,
	draw,
	timelineRef,
	modalRef,
	clientId,
	dispatch,
	getTokenSilently,
	canvas,
	controlComponentRefs,
	navigationFlightId = null,
	flightOptions,
) {
	let toastPlotStatusId = "plot-status";
	let flightId = navigationFlightId ?? timelineRef.current.currentFlightId;
	let selectedFeatures = draw.current.draw.getSelected().features;
	if (selectedFeatures.length > 0) {
		let plotFeatures = _.filter(selectedFeatures, (feature) => {
			return feature.properties.type === "plot";
		});
		if (plotFeatures.length > 0) {
			const accessToken = await getTokenSilently();
			let plotIds = _.map(plotFeatures, "id");
			let plotTrialPairs = _.map(plotFeatures, (pfs) => ({ plotId: pfs.id, trialId: pfs.properties.trial }));
			if (plotFeatures[0].properties.plotId) {
				plotIds = _.map(_.map(plotFeatures, "properties"), "plotId");
			}
			dispatch(
				markedPlotActions.updateMarkedPlots(accessToken, {
					clientId: clientId,
					flightId: flightId,
					plotNotes: notes,
					plotStatusId: checkedOptions.plotStatusId,
					timeframe: checkedOptions.timeframe,
					dateAndTime: checkedOptions.dateAndTime,
					plotTrialPairs: plotTrialPairs,
					plotIds: plotIds,
					annotationClassId: checkedOptions.annotationClassId,
				}),
			)
				.then(() => {
					setSelectedPlotStatuses(
						checkedOptions,
						notes,
						draw,
						timelineRef,
						navigationFlightId,
						flightOptions,
						controlComponentRefs,
					);
					if (defMarkersToggle) {
						defMarkerToggle(canvas, controlComponentRefs);
						defMarkerToggle(canvas, controlComponentRefs);
					}

					controlComponentRefs?.heatmapTimelineRef?.current?.getPlotAnalysisResults();
					toast.success("Plot statuses updated successfully.");

					modalRef.current.closeModal();
				})
				.catch((err) => {
					toast.error(err);
					modalRef.current.closeModal();
				});
		} else {
			if (!toast.isActive(toastPlotStatusId)) {
				toast.error("No plots were selected", {
					toastId: toastPlotStatusId,
				});
			}
			modalRef.current.closeModal();
		}
	} else {
		if (!toast.isActive(toastPlotStatusId)) {
			toast.error("No features were selected", {
				toastId: toastPlotStatusId,
			});
		}
		modalRef.current.closeModal();
	}
}

export async function applySubsampleStatuses(
	checkedOptions,
	notes,
	draw,
	timelineRef,
	modalRef,
	clientId,
	dispatch,
	getTokenSilently,
	canvas,
	controlComponentRefs,
	flightOptions,
) {
	let toastSubsampleStatusId = "subsample-status";
	let flightId = timelineRef.current.currentFlightId;
	let selectedFeatures = draw.current.draw.getSelected().features;
	if (selectedFeatures.length > 0) {
		let subsampleFeatures = _.filter(selectedFeatures, (feature) => {
			return feature.properties.type === "subsample";
		});
		if (subsampleFeatures.length > 0) {
			let subsampleIds = _.map(subsampleFeatures, "properties.quantifiedRegionId");
			let plotTrialPairs = _.map(subsampleFeatures, (pfs) => ({
				plotId: pfs.properties.plotId,
				trialId: pfs.properties.trial,
			}));

			const accessToken = await getTokenSilently();
			dispatch(
				markedPlotActions.updateMarkedPlots(accessToken, {
					clientId: clientId,
					flightId: flightId,
					quantifiedRegionNotes: notes,
					quantifiedRegionStatusId: checkedOptions.plotStatusId,
					dateAndTime: checkedOptions.dateAndTime,
					timeframe: checkedOptions.timeframe,
					plotTrialPairs: plotTrialPairs,
					quantifiedRegionIds: subsampleIds,
					annotationClassId: checkedOptions.annotationClassId,
				}),
			)
				.then(() => {
					setSelectedSubsampleStatuses(checkedOptions, notes, draw, timelineRef, flightOptions);

					if (defMarkersToggle) {
						defMarkerToggle(canvas, controlComponentRefs);
						defMarkerToggle(canvas, controlComponentRefs);
					}

					controlComponentRefs?.heatmapTimelineRef?.current?.getPlotAnalysisResults();
					toast.success("Subsample statuses updated successfully.");

					modalRef.current.closeModal();
				})
				.catch((err) => {
					toast.error(err);
					modalRef.current.closeModal();
				});
		} else {
			if (!toast.isActive(toastSubsampleStatusId)) {
				toast.error("No subsamples were selected", {
					toastId: toastSubsampleStatusId,
				});
			}
			modalRef.current.closeModal();
		}
	} else {
		if (!toast.isActive(toastSubsampleStatusId)) {
			toast.error("No features were selected", {
				toastId: toastSubsampleStatusId,
			});
		}
		modalRef.current.closeModal();
	}
}

export function getMarkedPlots() {
	return markedPlots;
}

export function getMarkedPlotOptions() {
	return markedPlotOptions;
}

export function getAnnotationClassOptions() {
	return annotationClassOptions;
}

export function getMarkedSubsamples() {
	return markedSubsamples;
}

export function setCurrentFlightId(id) {
	currentFlightId = id;
}

export function getCurrentFlightId() {
	return currentFlightId;
}

export function setCurrentFlightDate(date) {
	currentFlightDate = date;
}

export function getCurrentFlightDate() {
	return currentFlightDate;
}

export async function alignPlots(
	draw,
	canvas,
	orthoImageTypeId,
	moduleNavigation,
	dispatch,
	clientId,
	getTokenSilently,
	modalRef,
	controlComponentRefs,
	dropdownRef,
	level,
) {
	let selectedFeatures = draw.current.draw.getSelected().features;

	let fieldFeatures = _.filter(selectedFeatures, (f) => f.properties.type === "field");

	if (fieldFeatures.length > 1) {
		toast.error("Can only align one field at a time.");
		modalRef.current.setLoading(false);
	} else if (fieldFeatures.length === 0 || selectedFeatures.length === 0) {
		toast.error("No fields were selected.");
		modalRef.current.setLoading(false);
	} else {
		let fieldFeature = _.find(allFields, (f) => f.properties.field === fieldFeatures[0].properties.field);

		if (fieldFeature.properties.locked) {
			toast.error("Cannot align locked fields.");
			modalRef.current.setLoading(false);
		} else {
			uncombinePlotsInField(draw, false);
			let pageSize = 0;

			let matchingPlot = _.find(allPlots, { id: fieldFeature.properties.plotIds[0] });
			let objectToPass = {
				flightId: moduleNavigation.flightId,
				orthoImageTypeId: orthoImageTypeId,
				rows: matchingPlot?.properties.fieldRowCount,
				fieldRangeLength: matchingPlot?.properties.fieldRangeLength,
				fieldColumnWidth: matchingPlot?.properties.fieldColWidth,
				fieldPlanterOffset: matchingPlot?.properties.fieldPlanterOffset,
				fieldRowSpacing: matchingPlot?.properties.fieldRowSpacing,
				scaleFactor: fieldFeature.properties.scaleFactor,
				ranges: [],
				plots: [],
			};

			let j = 0;
			let ranges = [];
			let splitRanges = [[]];
			let splitPlots = [[]];

			for (let i = 1; i < matchingPlot?.properties.ranges + 1; i++) {
				let rangeFeatures = {
					type: "FeatureCollection",
					features: _.filter(
						allPlots,
						(ap) => fieldFeature.properties.plotIds.includes(ap.id) && ap.properties.range == i,
					),
				};
				let rangeBbox = turf.bbox(rangeFeatures);

				let rangeBboxPolygon = turf.bboxPolygon(rangeBbox);
				pageSize += turf.area(rangeBboxPolygon);

				if (pageSize > 20000) {
					j++;
					splitRanges.push([]);
					splitPlots.push([]);
					pageSize = 0;
				}

				let lowerLeft = [
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][3][0]),
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][3][1]),
				];
				let upperLeft = [
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][0][0]),
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][0][1]),
				];
				let lowerRight = [
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][2][0]),
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][2][1]),
				];
				let upperRight = [
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][1][0]),
					applyPrecision(rangeBboxPolygon.geometry.coordinates[0][1][1]),
				];

				let rangeToAdd = {
					range: i,
					ll: { lat: lowerLeft[1], long: lowerLeft[0] },
					ul: { lat: upperLeft[1], long: upperLeft[0] },
					ur: { lat: upperRight[1], long: upperRight[0] },
					lr: { lat: lowerRight[1], long: lowerRight[0] },
				};

				splitRanges[j].push(rangeToAdd);
				ranges[i] = j;
			}

			_.map(
				_.filter(allPlots, (ap) => fieldFeature.properties.plotIds.includes(ap.id)),
				(plot) => {
					let coordinates = plot.geometry.coordinates[0];

					let plotToAdd = {
						column: plot.properties.column,
						range: plot.properties.range,
						ll: { lat: coordinates[0][1], long: coordinates[0][0] },
						ul: { lat: coordinates[1][1], long: coordinates[1][0] },
						ur: { lat: coordinates[2][1], long: coordinates[2][0] },
						lr: { lat: coordinates[3][1], long: coordinates[3][0] },
					};

					splitPlots[ranges[plot.properties.range]].push(plotToAdd);
				},
			);

			const accessToken = await getTokenSilently();

			Promise.all(
				_.map(splitRanges, (_v, i) => {
					objectToPass.ranges = splitRanges[i];
					objectToPass.plots = splitPlots[i];
					dispatch(autoAlignActions.alignPlots(objectToPass, clientId, accessToken))
						.then((res) => {
							_.map(res.plots, (plot) => {
								let matchingPlot = _.find(
									allPlots,
									(p) =>
										p.properties.field == fieldFeatures[0].properties.field &&
										p.properties.range == plot.range &&
										p.properties.column == plot.column,
								);

								if (matchingPlot) {
									//-- Store plots for reverting
									prealignedPlots = [
										...prealignedPlots,
										{
											id: matchingPlot.id,
											geometry: _.cloneDeep(matchingPlot.geometry),
											properties: {
												field: matchingPlot.properties.field,
												range: matchingPlot.properties.range,
												column: matchingPlot.properties.column,
											},
										},
									];

									matchingPlot.geometry.coordinates = [
										[
											[plot.ll.long, plot.ll.lat],
											[plot.ul.long, plot.ul.lat],
											[plot.ur.long, plot.ur.lat],
											[plot.lr.long, plot.lr.lat],
											[plot.ll.long, plot.ll.lat],
										],
									];

									if (plot.failed) {
										matchingPlot.properties.alignColor = "#648FFF";
									} else if (plot.overRotated) {
										matchingPlot.properties.alignColor = "#FFB000";
									} else if (plot.confidence <= 0.1) {
										matchingPlot.properties.alignColor = "#DC267F";
									} else if (plot.confidence > 0.1 && plot.confidence <= 0.2) {
										matchingPlot.properties.alignColor = "#FE6100";
									} else if (plot.confidence > 0.2 && plot.confidence <= 0.3) {
										matchingPlot.properties.alignColor = "#FFB000";
									}

									matchingPlot = turf.truncate(matchingPlot, precisionOptions);
								}
							});

							controlComponentRefs.alignPlotsRef.current.setDisabled(true);
							controlComponentRefs.revertAlignmentRef.current.setOpen(true);
							refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);

							toast.success("Aligned plots successfully!", { toastId: "alignSuccess" });

							modalRef.current.setLoading(false);
							modalRef.current.setModalOpen(false);
						})
						.catch((err) => {
							console.log(err);
							toast.error("An error occurred while aligning plots.", { toastId: "alignFail" });
							modalRef.current.setLoading(false);
						});
				}),
			);
		}
	}
}

export function revertPlotUpdates(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	if (draw && canvas && prealignedPlots.length > 0) {
		//-- Reset plot coordinates
		_.map(prealignedPlots, (plot) => {
			let matchingPlot = _.find(
				allPlots,
				(p) =>
					p.properties.field == plot.properties.field &&
					p.properties.range == plot.properties.range &&
					p.properties.column == plot.properties.column,
			);

			if (matchingPlot) {
				matchingPlot.geometry.coordinates = plot.geometry.coordinates;
				delete matchingPlot.properties.alignColor;

				matchingPlot = turf.truncate(matchingPlot, precisionOptions);
			}
		});

		refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		prealignedPlots = [];
	}
}

export function validateSelectedField(draw) {
	if (draw?.current) {
		let selectedFeatures = draw.current.draw.getSelected().features;
		let fieldFeatures = _.filter(selectedFeatures, (f) => f.properties.type === "field");

		if (fieldFeatures.length > 1) {
			toast.error("Can only edit one field at a time.");
		} else if (fieldFeatures.length === 0 || selectedFeatures.length === 0) {
			toast.error("No fields were selected.");
		} else {
			let fieldFeature = _.find(allFields, (f) => f.properties.field === fieldFeatures[0].properties.field);

			return fieldFeature.properties.field;
		}
	}
}

function getTileUrl(canvas) {
	return _.filter(tilesetIds, (id) =>
		canvas.getPaintProperty(
			_.find(layerIds, (l) => l.includes(id)),
			"raster-opacity",
		),
	).map(
		(tilesetId) =>
			`${process.env.MAPBOX_TILE_URL}${tilesetId}/{z}/{x}/{y}.@2x.png?access_token=${process.env.MAPBOX_ACCESS_TOKEN}`,
	);
}

export function getActiveShader() {
	return activeShader;
}

export function getMinThreshold() {
	return defaultMinShaderThreshold;
}

export function getMaxThreshold() {
	return defaultMaxShaderThreshold;
}

export function setMinThreshold(min) {
	if (min >= 0 && min < defaultMaxShaderThreshold) defaultMinShaderThreshold = min;
}

export function setMaxThreshold(max) {
	if (max > defaultMinShaderThreshold && max <= 1) defaultMaxShaderThreshold = max;
}

export function refreshShaderLayer(canvas) {
	defaultMinShaderThreshold = 0;
	defaultMaxShaderThreshold = 1;

	switch (activeShader) {
		case "thermal":
			applyThermalShader(canvas);
			break;
		case "ryg":
			applyRYGShader(canvas);
			break;
		case "gfb":
			applyGreenFireBlueShader(canvas);
			break;
		case "spectral":
			applySpectralShader(canvas);
			break;
		case "by":
			applyBlueYellowShader(canvas);
			break;
		case "clamped":
			applyClampedShader(canvas);
			break;
		default:
			break;
	}
}

export function removeShader() {
	if (shaderLayer) {
		shaderLayer.setProps({ id: "no-shader", layers: [] });
	}

	activeShader = "";

	lastAppliedShader = (minThreshold, maxThreshold) => {
		(minThreshold, maxThreshold);
	};
}

function applyShader(canvas, minThreshold, maxThreshold, shaderLayerCode, inverse = null) {
	removeShader();

	const layers = [];

	const tileUrls = getTileUrl(canvas);
	for (let tileUrl of tileUrls) {
		let layerId = `shader-${shaderLayerCode}-tile-${tileUrl}`;

		let data = {
			tileUrl: tileUrl,
			min: minThreshold ?? defaultMinShaderThreshold,
			max: maxThreshold ?? defaultMaxShaderThreshold,
			layerId: layerId,
			inverse: inverse,
			beforeId: "gl-draw-point-point-stroke-inactive.cold",
			opacity: 1,
		};

		if (minThreshold !== null && minThreshold !== undefined) {
			defaultMinShaderThreshold = minThreshold;
		}

		if (maxThreshold !== null && maxThreshold !== undefined) {
			defaultMaxShaderThreshold = maxThreshold;
		}

		layers.push(new shaderLayers[shaderLayerCode]({ data }));
	}

	if (!shaderLayer) {
		shaderLayer = new MapboxOverlay({
			id: "deck-gl-shader-layer",
			layers: layers,
			interleaved: true,
		});

		canvas.addControl(shaderLayer);
	} else {
		shaderLayer.setProps({ id: "deck-gl-shader-layer", layers: layers });
	}

	activeShader = shaderLayerCode;
	inverseShader = inverse;

	lastAppliedShader = (minThreshold, maxThreshold, inverse) => {
		applyShader(canvas, minThreshold, maxThreshold, shaderLayerCode, inverse);
	};
}

export function applyThermalShader(canvas, minThreshold, maxThreshold, orthoImageTypeName) {
	let inverse = orthoImageTypeName ? orthoImageTypeName?.includes("RGB") : inverseShader;
	applyShader(canvas, minThreshold, maxThreshold, "thermal", inverse);
}

export function applyRYGShader(canvas, minThreshold, maxThreshold, orthoImageTypeName) {
	let inverse = orthoImageTypeName ? orthoImageTypeName?.includes("RGB") : inverseShader;
	applyShader(canvas, minThreshold, maxThreshold, "ryg", inverse);
}

export function applyGreenFireBlueShader(canvas, minThreshold, maxThreshold, orthoImageTypeName) {
	let inverse = orthoImageTypeName ? orthoImageTypeName?.includes("RGB") : inverseShader;
	applyShader(canvas, minThreshold, maxThreshold, "gfb", inverse);
}

export function applySpectralShader(canvas, minThreshold, maxThreshold, orthoImageTypeName) {
	let inverse = orthoImageTypeName ? orthoImageTypeName?.includes("RGB") : inverseShader;
	applyShader(canvas, minThreshold, maxThreshold, "spectral", inverse);
}

export function applyBlueYellowShader(canvas, minThreshold, maxThreshold, orthoImageTypeName) {
	let inverse = orthoImageTypeName ? orthoImageTypeName?.includes("RGB") : inverseShader;
	applyShader(canvas, minThreshold, maxThreshold, "by", inverse);
}

export function applyClampedShader(canvas, minThreshold, maxThreshold, orthoImageTypeName) {
	let inverse = orthoImageTypeName ? orthoImageTypeName?.includes("RGB") : inverseShader;
	//-- Remove check to re-enable shaders on RGB images
	//-- This will catch default shading
	if (!inverse) {
		applyShader(canvas, minThreshold, maxThreshold, "clamped", inverse);
	} else {
		removeShader();
	}
}

export function applyLastAppliedShader(minThreshold, maxThreshold, inverse = false) {
	return lastAppliedShader(minThreshold, maxThreshold, inverse);
}

export function MeasureDistanceToggle(draw, measureDistanceRef) {
	clearMeasurements(draw, measureDistanceRef);
	measureDistanceRef.current.setActive(true);
	draw.current.draw.changeMode("line_measure", {});
}

function measureLineDistance(line, measurePopupRef) {
	const lineDistance = Math.round(turf.length(line, { units: "feet" }) * 100) / 100;
	measurePopupRef.current.setMeasuredInfo(lineDistance, "ft");
}

function measureArea(polygon, measurePopupRef) {
	const area = Math.round((turf.area(polygon) * 100) / 4047) / 100;
	measurePopupRef.current.setMeasuredInfo(area, "ac");
}

function getMeasuredCoords(feature, measurePopupRef) {
	let geometry;

	if (feature.geometry.type === "Polygon") {
		geometry = feature.geometry.coordinates[0];
		geometry = geometry.slice(0, -1);
	} else if (feature.geometry.type === "LineString") {
		geometry = feature.geometry.coordinates;
	} else if (feature.geometry.type === "Point") {
		geometry = [feature.geometry.coordinates];
	}

	const coords = geometry.map((c) => [Math.round(c[1] * 1000000) / 1000000, Math.round(c[0] * 1000000) / 1000000]);
	measurePopupRef.current.setCoords(coords);
}

export function toggleMeasurePopup(measurePopupRef, state) {
	if (state !== undefined) {
		measurePopupRef.current.setOpen(state);
	} else {
		measurePopupRef.current.toggleOpen();
	}
}

export function measureLineMode(draw, measurePopupRef) {
	clearMeasurements(draw, measurePopupRef);
	measurePopupRef.current.setCurrentTool("Line Measure");
	draw.current.draw.changeMode("line_measure", {});
}

export function measureBoxMode(draw, measurePopupRef) {
	clearMeasurements(draw, measurePopupRef);
	measurePopupRef.current.setCurrentTool("Rectangle Measure");
	draw.current.draw.changeMode("rectangle_measure");
}

export function measurePolygonMode(draw, measurePopupRef) {
	clearMeasurements(draw, measurePopupRef);
	measurePopupRef.current.setCurrentTool("Polygon Measure");
	draw.current.draw.changeMode("polygon_measure");
}

export function coordinateAtPointMode(draw, measurePopupRef) {
	clearMeasurements(draw, measurePopupRef);
	measurePopupRef.current.setCurrentTool("Coordinate at Point");
	draw.current.draw.changeMode("point");
}

export function clearMeasurements(draw, measurePopupRef = null, reset = false) {
	if (draw?.current) {
		if (drawnFeature) {
			draw.current.draw.delete(drawnFeature.id);
			drawnFeature = null;
		}

		if (measurePopupRef && measurePopupRef.current) {
			measurePopupRef.current.reset();
			if (reset) {
				measurePopupRef.current.setCurrentTool("Measurement Tools");
			}
		}
	}
}

//-- Sets up existing quantified regions
function setupQuantifiedRegions(quantifiedRegions, refs) {
	if (quantifiedRegions?.length > 0) {
		//-- Clear existing list of subsamples
		//-- Need this when switching between flights
		subsamples = [];

		const maxColumns = {};
		const firstPlotQrs = _.filter(quantifiedRegions, { plotId: quantifiedRegions[0].plotId });
		const splitFirstPlotQrs = _.groupBy(firstPlotQrs, "quantifiedRegionTypeId");
		_.map(Object.keys(splitFirstPlotQrs), (type) => {
			maxColumns[type] = _.maxBy(splitFirstPlotQrs[type], "column").column;
		});

		_.map(quantifiedRegions, (qr) => {
			const { name: plotName, scaleFactor, trial } = _.find(allPlots, { id: qr.plotId })?.properties;

			//-- Find marked subsample color
			let matchingMarkedSubsamples = _.filter(
				markedSubsamples,
				(ms) =>
					ms.quantifiedRegionId === qr.quantifiedRegionId &&
					((new Date(ms.dateAndTime).getTime() <= new Date(qr.flightDate).getTime() &&
						ms.quantifiedRegionStatusName !== "Excluded") ||
						(new Date(ms.dateAndTime).getTime() === new Date(qr.flightDate).getTime() &&
							ms.quantifiedRegionStatusName === "Excluded") ||
						ms.flightId === qr.flightId ||
						ms.isAllData),
			);

			let quantifiedRegionNumber = maxColumns[qr.quantifiedRegionTypeId] * (qr.range - 1) + qr.column;

			let qrToAdd = {
				id: qr.id === "00000000-0000-0000-0000-000000000000" ? crypto.randomUUID() : qr.id,
				type: "Feature",
				properties: {
					type: "subsample",
					column: qr.column,
					range: qr.range,
					plotId: qr.plotId,
					plotName: plotName,
					quantifiedRegionNumber: quantifiedRegionNumber,
					quantifiedRegionName: `S${
						quantifiedRegionNumber > 9 ? quantifiedRegionNumber : "0" + quantifiedRegionNumber
					}`,
					quantifiedRegionTypeId: qr.quantifiedRegionTypeId,
					quantifiedRegionTypeName: _.find(quantifiedRegionOptions, { id: qr.quantifiedRegionTypeId })?.name ?? null,
					quantifiedRegionId: qr.quantifiedRegionId,
					flightsQuantifiedRegionId: qr.id,
					length: qr.length,
					width: qr.width,
					quantifiedLength: qr.quantifiedLength,
					quantifiedWidth: qr.quantifiedWidth,
					quantifiedRadius: qr.quantifiedRadius,
					fieldQuantifiedRegionId: qr.fieldQuantifiedRegionId,
					flightDate: qr.flightDate,
					flightId: qr.flightId,
					trial: trial,
					scaleFactor: scaleFactor,
					portColor: "#42adf5",
					locked: true,
				},
				geometry: {
					type: "Polygon",
					coordinates: [
						[
							[parseFloat(qr.ll.long), parseFloat(qr.ll.lat)],
							[parseFloat(qr.ul.long), parseFloat(qr.ul.lat)],
							[parseFloat(qr.ur.long), parseFloat(qr.ur.lat)],
							[parseFloat(qr.lr.long), parseFloat(qr.lr.lat)],
							[parseFloat(qr.ll.long), parseFloat(qr.ll.lat)],
						],
					],
				},
			};

			qrToAdd = turf.truncate(qrToAdd, precisionOptions);

			let allStatusesForSubsample = _.map(matchingMarkedSubsamples, "quantifiedRegionStatusName");
			if (allStatusesForSubsample.includes("Excluded") || allStatusesForSubsample.includes("Flagged")) {
				qrToAdd.properties.defColor = "#ff00ff";
			}

			let isPlotMarked = _.find(
				markedPlots,
				(mp) =>
					mp.plotId === qr.plotId &&
					((new Date(mp.dateAndTime).getTime() <= new Date(qr.flightDate).getTime() &&
						mp.quantifiedRegionStatusName !== "Excluded") ||
						(new Date(mp.dateAndTime).getTime() === new Date(qr.flightDate).getTime() &&
							mp.quantifiedRegionStatusName === "Excluded") ||
						mp.flightId === qr.flightId ||
						mp.isAllData),
			);
			if (isPlotMarked) {
				qrToAdd.properties.defColor = "#ff00ff";
			}

			subsamples.push(qrToAdd);
		});

		if (refs.quantifiedRegionToggleRef?.current) {
			updateQrToggleList(refs);
		}
	}
}

export function getSubsamples() {
	return subsamples;
}

export function handleModifyQrFromFieldModal(fieldId, qrModifyList, qrDeleteList) {
	if (fieldId) {
		if (qrModifyList?.length > 0) {
			//-- Remove all modified quantified regions from subsamplesToAdd and subsamples lists
			let fieldQuantifiedRegionIdsToModify = _.uniqBy(qrModifyList, "fieldQuantifiedRegionId");
			subsamplesToAdd = _.filter(
				subsamplesToAdd,
				(sta) => !fieldQuantifiedRegionIdsToModify.includes(sta.properties.fieldQuantifiedRegionId),
			);

			subsamples = _.filter(
				subsamples,
				(s) => !fieldQuantifiedRegionIdsToModify.includes(s.properties.fieldQuantifiedRegionId),
			);

			//-- Re-add quantified regions to be redrawn on save
			subsamplesToAdd = [...subsamplesToAdd, ...qrModifyList];

			//-- Make plots dirty so the unsaved changes popup triggers
			let plotIdsToDirty = _.map(_.uniqBy(qrModifyList, "plotId"), "plotId");
			_.map(allPlots, (p) => {
				if (plotIdsToDirty.includes(p.id)) {
					p.properties.isDirty = true;
				}
			});
		}

		if (qrDeleteList?.length > 0) {
			subsamplesToAdd = _.filter(
				subsamplesToAdd,
				(sta) => !qrDeleteList.includes(sta.properties.fieldQuantifiedRegionId),
			);
		}
	}
}

function updateQrToggleList(refs) {
	let uniqueQrTypeIds = _.map(
		_.uniqBy(subsamples, (s) => s.properties.quantifiedRegionTypeId),
		"properties.quantifiedRegionTypeId",
	);
	let uniqueQrTypeNames = _.map(
		_.filter(quantifiedRegionOptions, (qro) => uniqueQrTypeIds.includes(qro.id)),
		"name",
	);

	refs.quantifiedRegionToggleRef.current.setActiveList(uniqueQrTypeNames);
}

export function quantifiedRegionToggle(draw, refresh, qr) {
	let choice = qr;

	if (!choice) {
		choice = pcQrToggle
			? "Plot-Centered with Subsamples"
			: rcQrToggle
				? "Row-Centered"
				: brQrToggle
					? "Between-Row"
					: frQrToggle
						? "Full Row"
						: scQrToggle
							? "Stand Count"
							: "Plot-Centered";
	}

	let filteredSubsamples = _.cloneDeep(subsamples);
	if (singleFeatureToggle && selectedFieldId) {
		filteredSubsamples = _.filter(filteredSubsamples, (s) =>
			_.find(allFields, (f) => f.id === selectedFieldId)?.properties?.plotIds?.includes(s.properties.plotId),
		);
	} else if (singleFeatureToggle && selectedTrialId) {
		filteredSubsamples = _.filter(filteredSubsamples, (s) =>
			_.find(allTrials, (t) => t.id === selectedTrialId)?.properties?.plotIds?.includes(s.properties.plotId),
		);
	}

	if (cropToFilterOn !== "all") {
		filteredSubsamples = _.filter(
			filteredSubsamples,
			(s) => _.find(allPlots, (p) => p.id === s.properties.plotId)?.properties.crop === cropToFilterOn,
		);
	}

	if (choice === "Plot-Centered with Subsamples") {
		plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);
		if (refresh) plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);

		//-- These turn off other toggles if they were active
		if (pcToggle) plotCenteredQrToggle(draw, filteredSubsamples);
		if (rcQrToggle) rowCenteredQrToggle(draw, filteredSubsamples);
		if (brQrToggle) betweenRowQrToggle(draw, filteredSubsamples);
		if (frQrToggle) fullRowQrToggle(draw, filteredSubsamples);
		if (scQrToggle) standCountQrToggle(draw, filteredSubsamples);
	} else if (choice === "Row-Centered") {
		rowCenteredQrToggle(draw, filteredSubsamples);
		if (refresh) rowCenteredQrToggle(draw, filteredSubsamples);

		if (pcToggle) plotCenteredQrToggle(draw, filteredSubsamples);
		if (pcQrToggle) plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);
		if (brQrToggle) betweenRowQrToggle(draw, filteredSubsamples);
		if (frQrToggle) fullRowQrToggle(draw, filteredSubsamples);
		if (scQrToggle) standCountQrToggle(draw, filteredSubsamples);
	} else if (choice === "Between-Row") {
		betweenRowQrToggle(draw, filteredSubsamples);
		if (refresh) betweenRowQrToggle(draw, filteredSubsamples);

		if (pcToggle) plotCenteredQrToggle(draw, filteredSubsamples);
		if (pcQrToggle) plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);
		if (rcQrToggle) rowCenteredQrToggle(draw, filteredSubsamples);
		if (frQrToggle) fullRowQrToggle(draw, filteredSubsamples);
		if (scQrToggle) standCountQrToggle(draw, filteredSubsamples);
	} else if (choice === "Full Row") {
		fullRowQrToggle(draw, filteredSubsamples);
		if (refresh) fullRowQrToggle(draw, filteredSubsamples);

		if (pcToggle) plotCenteredQrToggle(draw, filteredSubsamples);
		if (pcQrToggle) plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);
		if (rcQrToggle) rowCenteredQrToggle(draw, filteredSubsamples);
		if (brQrToggle) betweenRowQrToggle(draw, filteredSubsamples);
		if (scQrToggle) standCountQrToggle(draw, filteredSubsamples);
	} else if (choice === "Plot-Centered") {
		plotCenteredQrToggle(draw, filteredSubsamples);
		if (refresh) plotCenteredQrToggle(draw, filteredSubsamples);

		if (pcQrToggle) plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);
		if (rcQrToggle) rowCenteredQrToggle(draw, filteredSubsamples);
		if (brQrToggle) betweenRowQrToggle(draw, filteredSubsamples);
		if (frQrToggle) fullRowQrToggle(draw, filteredSubsamples);
		if (scQrToggle) standCountQrToggle(draw, filteredSubsamples);
	} else if (choice === "Stand Count") {
		standCountQrToggle(draw, filteredSubsamples);
		if (refresh) standCountQrToggle(draw, filteredSubsamples);

		if (pcToggle) plotCenteredQrToggle(draw, filteredSubsamples);
		if (pcQrToggle) plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples);
		if (rcQrToggle) rowCenteredQrToggle(draw, filteredSubsamples);
		if (brQrToggle) betweenRowQrToggle(draw, filteredSubsamples);
		if (frQrToggle) fullRowQrToggle(draw, filteredSubsamples);
	}
}

export function plotCenteredQrToggle(draw, filteredSubsamples) {
	if (draw?.current) {
		let pcTypeId = _.find(quantifiedRegionOptions, { name: "Plot-Centered" })?.id;
		//-- Find all subsamples and drawn subsamples with the same type id
		let filteredQrs = _.filter(
			[...filteredSubsamples, ...draw.current.draw.getAll().features],
			(s) => s.properties.quantifiedRegionTypeId === pcTypeId,
		);

		//-- Removes legacy subsamples without coords
		filteredQrs = _.filter(filteredQrs, (qr) => !isNaN(qr.geometry.coordinates[0][0][0]));

		if (!pcToggle) {
			let qrsToAdd = {
				type: "FeatureCollection",
				features: filteredQrs,
			};

			draw.current.draw.add(qrsToAdd);
		} else {
			draw.current.draw.delete(_.map(filteredQrs, "id"));
		}

		pcToggle = !pcToggle;
	}
}

export function plotCenteredWithSubsamplesQrToggle(draw, filteredSubsamples) {
	if (draw?.current) {
		let pcTypeId = _.find(quantifiedRegionOptions, { name: "Plot-Centered with Subsamples" })?.id;

		//-- Find all subsamples and drawn subsamples with the same type id
		let filteredQrs = _.filter(
			[...filteredSubsamples, ...draw.current.draw.getAll().features],
			(s) => s.properties.quantifiedRegionTypeId === pcTypeId,
		);

		if (!pcQrToggle) {
			let qrsToAdd = {
				type: "FeatureCollection",
				features: filteredQrs,
			};

			draw.current.draw.add(qrsToAdd);
		} else {
			draw.current.draw.delete(_.map(filteredQrs, "id"));
		}

		pcQrToggle = !pcQrToggle;
	}
}

export function setPlotAnalysisResults(values, controlComponentRefs) {
	plotAnalysisResults = values;

	filteredAnalysisResults = _.map(
		_.filter(plotAnalysisResults, (par) => par.plotAnalysisResultValue !== null),
		"plotAnalysisResultValue",
	);

	if (controlComponentRefs.heatmapOptionsRef.current) {
		controlComponentRefs.heatmapOptionsRef.current.setHeatmapValues(filteredAnalysisResults);
	}
}

export function betweenRowQrToggle(draw, filteredSubsamples) {
	if (draw?.current) {
		let pcTypeId = _.find(quantifiedRegionOptions, { name: "Between-Row" })?.id;
		//-- Find all subsamples and drawn subsamples with the same type id
		let filteredQrs = _.filter(
			[...filteredSubsamples, ...draw.current.draw.getAll().features],
			(s) => s.properties.quantifiedRegionTypeId === pcTypeId,
		);

		if (!brQrToggle) {
			let qrsToAdd = {
				type: "FeatureCollection",
				features: filteredQrs,
			};

			draw.current.draw.add(qrsToAdd);
		} else {
			draw.current.draw.delete(_.map(filteredQrs, "id"));
		}

		brQrToggle = !brQrToggle;
	}
}

export function rowCenteredQrToggle(draw, filteredSubsamples) {
	if (draw?.current) {
		let pcTypeId = _.find(quantifiedRegionOptions, { name: "Row-Centered" })?.id;
		//-- Find all subsamples and drawn subsamples with the same type id
		let filteredQrs = _.filter(
			[...filteredSubsamples, ...draw.current.draw.getAll().features],
			(s) => s.properties.quantifiedRegionTypeId === pcTypeId,
		);

		if (!rcQrToggle) {
			let qrsToAdd = {
				type: "FeatureCollection",
				features: filteredQrs,
			};

			draw.current.draw.add(qrsToAdd);
		} else {
			draw.current.draw.delete(_.map(filteredQrs, "id"));
		}

		rcQrToggle = !rcQrToggle;
	}
}

export function fullRowQrToggle(draw, filteredSubsamples) {
	if (draw?.current) {
		let pcTypeId = _.find(quantifiedRegionOptions, { name: "Full Row" })?.id;
		//-- Find all subsamples and drawn subsamples with the same type id
		let filteredQrs = _.filter(
			[...filteredSubsamples, ...draw.current.draw.getAll().features],
			(s) => s.properties.quantifiedRegionTypeId === pcTypeId,
		);

		if (!frQrToggle) {
			let qrsToAdd = {
				type: "FeatureCollection",
				features: filteredQrs,
			};

			draw.current.draw.add(qrsToAdd);
		} else {
			draw.current.draw.delete(_.map(filteredQrs, "id"));
		}

		frQrToggle = !frQrToggle;
	}
}

function standCountQrToggle(draw, filteredSubsamples) {
	if (draw?.current) {
		let pcTypeId = _.find(quantifiedRegionOptions, { name: "Stand Count" })?.id;
		//-- Find all subsamples and drawn subsamples with the same type id
		let filteredQrs = _.filter(
			[...filteredSubsamples, ...draw.current.draw.getAll().features],
			(s) => s.properties.quantifiedRegionTypeId === pcTypeId,
		);

		if (!scQrToggle) {
			let qrsToAdd = {
				type: "FeatureCollection",
				features: filteredQrs,
			};

			draw.current.draw.add(qrsToAdd);
		} else {
			draw.current.draw.delete(_.map(filteredQrs, "id"));
		}

		scQrToggle = !scQrToggle;
	}
}

export function heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	if (draw && canvas && heatmapDomain.length > 0) {
		//-- Don't turn on if plots aren't on
		//---- & remove any trace of this function
		if (!plotBoundaryToggle) {
			heatmapOverlayLabelsToggled = true;

			//-- Create list of plots to search from
			//---- Filter as needed
			let plotsToSearch = allPlots;
			plotsToSearch = _.filter(plotsToSearch, (p) => p.properties.heatmapColor);

			//-- This updates the plot metadata to not show heatmap when plots are re-toggled
			_.map(plotsToSearch, (p) => {
				let matchingPlotIndex = _.findIndex(allPlots, { id: p.id });

				if (matchingPlotIndex !== -1) {
					allPlots[matchingPlotIndex].properties.heatmapOpacity = 0;
				}
			});
		} else if (controlComponentRefs.heatmapTimelineRef.current.getHeatmapEnabled()) {
			if (plotAnalysisResults?.length > 0 || defaultViewerSetting) {
				//-- Make sure all plots are uncombined
				uncombinePlotsInField(draw);

				//-- Turn off ortho shaders
				//-- Except if active shader is clamped
				if (activeShader !== "clamped") {
					removeShader();
				}

				//-- Color gradient taken from heatmap page

				const midValue = median(
					_.map(
						_.filter(plotAnalysisResults, (par) => {
							const value = par.plotAnalysisResultValue;
							if (value !== 0 && value !== null) {
								if (heatmapDomain.length > 0) {
									if (heatmapDomain[0] > value || heatmapDomain[1] < value) {
										return false;
									}
								}
								return true;
							}
							return false;
						}),
						"plotAnalysisResultValue",
					),
				);

				let cg;

				switch (heatmapGradient) {
					case "mono":
						cg = new ColorGradient(
							heatmapDomain[0],
							midValue,
							heatmapDomain[1],
							ColorGradient.oneColorGradient({ r: 32, g: 183, b: 241 }),
						);
						break;

					case "ryg":
					default:
						cg = new ColorGradient(heatmapDomain[0], midValue, heatmapDomain[1]);
						break;
				}
				//-- Apply coloring to all plots with analysis data
				_.map(plotAnalysisResults, (par) => {
					let rgb =
						!par.excluded && par.plotAnalysisResultValue !== null
							? cg.getRgbValuesAtValue(par.plotAnalysisResultValue, heatmapDomain)
							: [127, 127, 127];
					let heatmapColor = rgbToHex(rgb);

					let matchingPlotIndex = _.findIndex(allPlots, { id: par.plotId });

					//-- Set plot color & opacity metadata
					if (matchingPlotIndex !== -1) {
						allPlots[matchingPlotIndex].properties.heatmapColor = heatmapColor;
						allPlots[matchingPlotIndex].properties.heatmapOpacity = heatmapOpacity;
					}

					//-- Check for existing mapbox feature
					let featureExists = draw.current.draw.get(par.plotId);

					if (featureExists) {
						draw.current.draw.setFeatureProperty(par.plotId, "heatmapColor", heatmapColor);
						draw.current.draw.setFeatureProperty(par.plotId, "heatmapOpacity", heatmapOpacity);

						//-- Redrawing plot
						let feature = draw.current.draw.get(par.plotId);
						draw.current.draw.add(feature);
					}
				});

				const idsWithVaules = new Set(_.map(plotAnalysisResults, "plotId"));

				//-- Apply shading changes to plots without results
				_.map(
					_.filter(allPlots, (ap) => !idsWithVaules.has(ap.id)),
					(ap) => {
						ap.properties.heatmapColor = "#808080";
						ap.properties.heatmapOpacity = 0;

						//-- Check for existing mapbox feature
						let featureExists = draw.current.draw.get(ap.id);

						if (featureExists) {
							draw.current.draw.setFeatureProperty(ap.id, "heatmapColor", "#808080");
							draw.current.draw.setFeatureProperty(ap.id, "heatmapOpacity", 0);

							//-- Redrawing plot
							let feature = draw.current.draw.get(ap.id);
							draw.current.draw.add(feature);
						}
					},
				);

				bringSubsamplesToTopLayer(draw);
			} else {
				toast.error("No analysis results to display for this ortho type", { toastId: "no-analysis-results" });
				controlComponentRefs.heatmapTimelineRef.current.setHeatmapEnabled(false);
			}
		} else {
			//-- Set plot metadata heatmap opacity to 0 to hide coloring
			_.map(
				_.filter(allPlots, (p) => p.properties.heatmapColor),
				(p) => {
					let matchingPlotIndex = _.findIndex(allPlots, { id: p.id });

					if (matchingPlotIndex !== -1) {
						allPlots[matchingPlotIndex].properties.heatmapOpacity = 0;
					}

					//-- Check for existing mapbox feature
					let featureExists = draw.current.draw.get(p.id);

					if (featureExists) {
						draw.current.draw.setFeatureProperty(p.id, "heatmapOpacity", 0);

						//-- Redrawing plot
						let feature = draw.current.draw.get(p.id);
						draw.current.draw.add(feature);
					}
				},
			);

			//-- Turn back on trial coloring
			if (trialsToggle) {
				trialToggle(draw, true, false);
			}

			bringSubsamplesToTopLayer(draw);
		}

		if (fieldLabelsToggle) {
			fieldLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
			fieldLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		}
		if (trialLabelsToggle) {
			trialLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
			trialLabelToggle(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
		}
	}
}

export function heatmapOverlayLabels(draw, canvas, controlComponentRefs) {
	//-- Don't turn on if plots aren't on
	//---- & remove any trace of this function
	if (!plotBoundaryToggle) {
		heatmapOverlayLabelsToggled = true;

		//-- Turns off labels
		if (canvas.getLayer("plot-labels")) {
			canvas.removeLayer("plot-labels");
			canvas.removeSource("plot-labels");
		}
	} else if (!heatmapOverlayLabelsToggled) {
		if (plotAnalysisResults?.length > 0) {
			console.time("labels prep");
			//-- Make sure all plots are uncombined
			uncombinePlotsInField(draw);

			//-- Turn off plot labels if on
			if (plotLabelsToggle) {
				if (canvas.getLayer("plot-labels")) {
					canvas.removeLayer("plot-labels");
					canvas.removeSource("plot-labels");
				}

				controlComponentRefs.plotLabelToggleRef.current.setToggleState(false);
				plotLabelsToggle = !plotLabelsToggle;
			}

			let labelCollection = {
				type: "FeatureCollection",
				features: [],
			};

			//-- Create list of plots to search from
			//---- Filter as needed
			let plotsToSearch = _.cloneDeep(allPlots);

			if (singleFeatureToggle && selectedTrialId) {
				let trialPlotIds = _.find(allTrials, (t) => t.id === selectedTrialId)?.properties?.plotIds;
				plotsToSearch = _.filter(plotsToSearch, (p) => trialPlotIds.includes(p.id));
				//plotsToSearch = _.filter(allPlots, (ap) => _.map(trialPlots, "properties.plotId").includes(ap.id));
			} else if (singleFeatureToggle && selectedFieldId) {
				let fieldPlotIds = _.find(allFields, (f) => f.id === selectedFieldId)?.properties?.plotIds;
				plotsToSearch = _.filter(plotsToSearch, (p) => fieldPlotIds.includes(p.id));
			}

			if (cropToFilterOn !== "all") {
				plotsToSearch = _.filter(plotsToSearch, (p) => p.properties.crop === cropToFilterOn);
			}

			//-- Add all plot labels to be added
			_.map(plotAnalysisResults, (par) => {
				const matchingPlot = _.find(plotsToSearch, { id: par.plotId });

				if (matchingPlot && par.plotAnalysisResultValue !== null) {
					// let center = turf.truncate(turf.centroid(matchingPlot), precisionOptions);

					// Get corners in this order: LL UL UR LR
					const corner1 = turf.point(matchingPlot.geometry.coordinates[0][0]);
					const corner2 = turf.point(matchingPlot.geometry.coordinates[0][1]);
					const corner3 = turf.point(matchingPlot.geometry.coordinates[0][2]);
					const corner4 = turf.point(matchingPlot.geometry.coordinates[0][3]);

					// Get mid points in this order: Left Right Top Bottom
					const midpoint1 = turf.midpoint(corner1, corner2).geometry.coordinates;
					const midpoint2 = turf.midpoint(corner3, corner4).geometry.coordinates;
					const midpoint3 = turf.midpoint(corner2, corner3).geometry.coordinates;
					const midpoint4 = turf.midpoint(corner1, corner4).geometry.coordinates;

					// Depending on shorter side, get longest bisecting line
					// let centerLine =
					// 	matchingPlot.properties.fieldColWidth > matchingPlot.properties.fieldRangeLength
					// 		? turf.bearing(midpoint4, midpoint3)
					// 		: turf.bearing(midpoint2, midpoint1);

					let centerLine =
						matchingPlot.properties.fieldColWidth < matchingPlot.properties.fieldRangeLength
							? turf.lineString([midpoint3, midpoint4])
							: turf.lineString([midpoint1, midpoint2]);

					centerLine = turf.transformScale(centerLine, 0.6);

					const minSideLen = Math.min(matchingPlot.properties.fieldColWidth, matchingPlot.properties.fieldRangeLength);

					const size = minSideLen * 1.2;

					const labelToAdd = {
						type: "Feature",
						properties: {
							name: getPrecisionString(par.plotAnalysisResultValue),
							plot: matchingPlot.id,
							field: matchingPlot.properties.field,
							type: "plotLabel",
							size: size,
							rotation: centerLine,
						},
						geometry: centerLine.geometry,
						// geometry: center.geometry
					};

					labelCollection.features.push(labelToAdd);
					// draw.current.draw.add(centerLine);
				}
			});
			console.timeEnd("labels prep");
			console.time("labels");

			if (canvas.getLayer("plot-labels")) {
				canvas.removeLayer("plot-labels");
			}

			if (canvas.getSource("plot-labels")) {
				canvas.removeSource("plot-labels");
			}

			//-- Mapbox layer needs a source
			canvas.addSource("plot-labels", {
				type: "geojson",
				data: labelCollection,
			});

			//-- Create layer & style
			//-- Calling plot-labels so it shares same name as plotLabels so they don't appear at same time
			canvas.addLayer({
				id: "plot-labels",
				type: "symbol",
				source: "plot-labels",
				layout: {
					"text-field": ["format", ["get", "name"]],
					"text-anchor": "center",
					"text-size": ["interpolate", ["exponential", 2], ["zoom"], 14, 3, 19, ["get", "size"], 25, 255],
					"text-justify": "auto",
					"icon-allow-overlap": true,
					"text-allow-overlap": true,
					"text-ignore-placement": true,
					"text-padding": 0,
					"symbol-placement": "line-center",
					// "text-rotation-alignment": "map",
					// "symbol-placement": "point",
					// "text-rotate": ["get", "rotation"]
				},
				paint: {
					"text-color": "#ffffff",
					"text-halo-color": "#000000",
					"text-halo-width": 0.65,
				},
				//minzoom: 14
			});
			console.timeEnd("labels");
		} else {
			toast.error("No analysis results to display for this ortho type", { toastId: "no-analysis-results" });
			heatmapOverlayLabelsToggled = true; //-- Will turn off the toggle
		}
	} else {
		//-- Turns off labels
		if (canvas.getLayer("plot-labels")) {
			canvas.removeLayer("plot-labels");
			canvas.removeSource("plot-labels");
		}
	}

	heatmapOverlayLabelsToggled = !heatmapOverlayLabelsToggled;
	controlComponentRefs.heatmapOverlayLabelsRef.current.setToggleState(heatmapOverlayLabelsToggled);
}

function rgbValueToHex(rgb) {
	var hex = Math.round(rgb).toString(16);
	if (hex.length < 2) {
		hex = "0" + hex;
	}
	return hex;
}

function rgbToHex(rgb) {
	var red = rgbValueToHex(rgb[0]);
	var green = rgbValueToHex(rgb[1]);
	var blue = rgbValueToHex(rgb[2]);
	return `#${red}${green}${blue}`;
}

function median(numbers) {
	const numsLen = numbers.length;
	let median = 0;

	numbers.sort();

	if (numsLen % 2 === 0) {
		median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
	} else {
		median = numbers[(numsLen - 1) / 2];
	}

	return median;
}

export function setHeatmapDomain(domain, draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	heatmapDomain = domain;

	heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
}

export function setHeatmapOpacity(opacity, draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	heatmapOpacity = opacity;
	heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
}

export function setHeatmapGradient(gradient, draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	heatmapGradient = gradient;
	heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
	heatmapOverlayShading(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
}

export function getAnalysisOptions() {
	return analysisOptions;
}

export function applyEditFieldChanges(plots, field, dropdownRef) {
	if (plots?.length > 0) {
		//-- Update plot metadata
		_.map(plots, (p) => {
			let matchingPlotIndex = _.findIndex(allPlots, { id: p.id });

			if (matchingPlotIndex !== -1) {
				allPlots[matchingPlotIndex].properties = {
					...allPlots[matchingPlotIndex].properties,
					fieldName: field.name,
					name: p.name,
					treatment: p.treatment,
					trial: p.trialId === "00000000-0000-0000-0000-000000000000" ? null : p.trialId,
					isDirty: true,
					plantDate: field.plantDate,
					harvestDate: field.harvestDate,
				};
			}
		});

		//-- Fix field name in field ddl
		let modifiedList = dropdownRef.current.innerRef.current.currentThirdDropdownOptions();
		_.find(modifiedList, { key: field.id }).text = field.name;

		dropdownRef.current.innerRef.current.setThirdDropdownOptions(modifiedList);
	}
}

export function rotateFeatureRight(canvas, level) {
	if (level === "farm") {
		canvas.easeTo({
			bearing: (canvas.getBearing() - 90) % 360,
			// duration: 200,
			// easing: (x) => x
		});
	} else {
		let feature = level === "field" ? allFields[0] : allTrials[0];
		if (feature) {
			let plots = _.filter(allPlots, (ap) => feature.properties.plotIds.includes(ap.id));

			//-- Find and create bbox of all plots in feature
			let bbox = turf.bbox(turf.featureCollection(plots));
			let bboxPolygon = turf.bboxPolygon(bbox);

			//-- Get current viewport bearing
			let viewportLl = canvas.unproject([0, canvas.getCanvas().height]).toArray();
			let viewportUl = canvas.unproject([0, 0]).toArray();
			let viewportBearing = turf.bearing(viewportLl, viewportUl);

			let coords = plots[0].geometry.coordinates[0];

			//-- Identify all bearings of feature
			let llToUl = turf.bearing(coords[0], coords[1]);
			let ulToUr = turf.bearing(coords[1], coords[2]);
			let urToLr = turf.bearing(coords[2], coords[3]);
			let lrToLl = turf.bearing(coords[3], coords[0]);

			//-- Adjusting for range to be 0 - 360
			if (viewportBearing < 0) viewportBearing = 360 - Math.abs(viewportBearing);
			if (llToUl < 0) llToUl = 360 - Math.abs(llToUl);
			if (ulToUr < 0) ulToUr = 360 - Math.abs(ulToUr);
			if (urToLr < 0) urToLr = 360 - Math.abs(urToLr);
			if (lrToLl < 0) lrToLl = 360 - Math.abs(lrToLl);

			//-- Viewport bearing must be less than feature bearing
			let closestRightSnap =
				viewportBearing <= llToUl && viewportBearing > lrToLl
					? llToUl
					: viewportBearing <= ulToUr && viewportBearing > llToUl
						? ulToUr
						: viewportBearing <= urToLr && viewportBearing > ulToUr
							? urToLr
							: lrToLl;

			//-- Make sure viewport bearing didn't stay at same bearing
			if (viewportBearing.toPrecision(4) == llToUl.toPrecision(4)) closestRightSnap = lrToLl;
			if (viewportBearing.toPrecision(4) == ulToUr.toPrecision(4)) closestRightSnap = llToUl;
			if (viewportBearing.toPrecision(4) == urToLr.toPrecision(4)) closestRightSnap = ulToUr;
			if (viewportBearing.toPrecision(4) == lrToLl.toPrecision(4)) closestRightSnap = urToLr;

			if (closestRightSnap > 180) closestRightSnap -= 360;

			fitBoundsRotated(
				[bboxPolygon.geometry.coordinates[0][0], bboxPolygon.geometry.coordinates[0][2]],
				{
					bearing: closestRightSnap,
				},
				{},
				canvas,
			);
		}
	}
}

export function rotateFeatureLeft(canvas, level) {
	if (level === "farm") {
		canvas.easeTo({
			bearing: (canvas.getBearing() + 90) % 360,
			// duration: 200,
			// easing: (x) => x
		});
	} else {
		let feature = level === "field" ? allFields[0] : allTrials[0];
		if (feature) {
			let plots = _.filter(allPlots, (ap) => feature.properties.plotIds.includes(ap.id));

			//-- Find and create bbox of all plots in feature
			let bbox = turf.bbox(turf.featureCollection(plots));
			let bboxPolygon = turf.bboxPolygon(bbox);

			//-- Get current viewport bearing
			let viewportLl = canvas.unproject([0, canvas.getCanvas().height]).toArray();
			let viewportUl = canvas.unproject([0, 0]).toArray();
			let viewportBearing = turf.bearing(viewportLl, viewportUl);

			let coords = plots[0].geometry.coordinates[0];

			//-- Identify all bearings of feature
			let llToUl = turf.bearing(coords[0], coords[1]);
			let ulToUr = turf.bearing(coords[1], coords[2]);
			let urToLr = turf.bearing(coords[2], coords[3]);
			let lrToLl = turf.bearing(coords[3], coords[0]);

			//-- Adjusting for range to be 0 - 360
			if (viewportBearing < 0) viewportBearing = 360 - Math.abs(viewportBearing);
			if (llToUl < 0) llToUl = 360 - Math.abs(llToUl);
			if (ulToUr < 0) ulToUr = 360 - Math.abs(ulToUr);
			if (urToLr < 0) urToLr = 360 - Math.abs(urToLr);
			if (lrToLl < 0) lrToLl = 360 - Math.abs(lrToLl);

			//-- Viewport bearing must be less than feature bearing
			let closestLeftSnap =
				viewportBearing <= llToUl && viewportBearing > lrToLl
					? lrToLl
					: viewportBearing <= ulToUr && viewportBearing > llToUl
						? llToUl
						: viewportBearing <= urToLr && viewportBearing > ulToUr
							? ulToUr
							: urToLr;

			//-- Make sure viewport bearing didn't stay at same bearing
			if (viewportBearing.toPrecision(4) == llToUl.toPrecision(4)) closestLeftSnap = ulToUr;
			if (viewportBearing.toPrecision(4) == ulToUr.toPrecision(4)) closestLeftSnap = urToLr;
			if (viewportBearing.toPrecision(4) == urToLr.toPrecision(4)) closestLeftSnap = lrToLl;
			if (viewportBearing.toPrecision(4) == lrToLl.toPrecision(4)) closestLeftSnap = llToUl;

			if (closestLeftSnap > 180) closestLeftSnap -= 360;

			fitBoundsRotated(
				[bboxPolygon.geometry.coordinates[0][0], bboxPolygon.geometry.coordinates[0][2]],
				{
					bearing: closestLeftSnap,
				},
				{},
				canvas,
			);
		}
	}
}

function setViewerOrientation(canvas, level, override = false) {
	if (allPlots?.length > 0) {
		let minRange = _.minBy(allPlots, (ap) => ap.properties.range).properties.range;
		let maxRange = _.maxBy(allPlots, (ap) => ap.properties.range).properties.range;
		let minColumn = _.minBy(allPlots, (ap) => ap.properties.column).properties.column;
		let maxColumn = _.maxBy(allPlots, (ap) => ap.properties.column).properties.column;

		let ranges = maxRange - minRange;
		let columns = maxColumn - minColumn;

		let length = parseFloat(allPlots[0].properties.fieldRangeLength);
		let width = parseFloat(allPlots[0].properties.fieldColWidth);

		if (ranges * length > columns * width && !override) {
			rotateFeatureRight(canvas, level);
		} else {
			fitToHeight(canvas, level, true);
		}
	}
}

/**
 *
 * @param {[number, number]} domain
 * @param {*} controlComponentRefs
 * @param {"ortho" | "heatmap"} type
 * @param {boolean} reset
 * @returns
 */
export function updateTimelineDomain(domain, controlComponentRefs, type, reset = false) {
	if (domain === null) return;

	const other = type === "ortho" ? "heatmap" : "ortho";
	if (reset) timelineDomain = { ...timelineDomain, [type]: domain, [other]: null };

	if (domain?.[0] && domain?.[1]) {
		timelineDomain[type] = domain;
		if (timelineDomain[other] !== null) {
			timelineDomain.union = [
				Math.min(timelineDomain.ortho[0], timelineDomain.heatmap[0]),
				Math.max(timelineDomain.ortho[1], timelineDomain.heatmap[1]),
			];
		} else {
			timelineDomain.union = domain;
		}

		// if (timelineDomain) {
		// 	if (_.isEqual(timelineDomain, [Math.min(domain[0], timelineDomain[0]), Math.max(domain[1], timelineDomain[1])])) {
		// 		return;
		// 	}

		// 	timelineDomain = [Math.min(domain[0], timelineDomain[0]), Math.max(domain[1], timelineDomain[1])];
		// } else {
		// 	timelineDomain = domain;
		// }
	} else {
		timelineDomain[type] = null;
		timelineDomain.union = timelineDomain[other];
	}

	if (controlComponentRefs.heatmapTimelineRef.current) {
		controlComponentRefs.heatmapTimelineRef.current.setDomain(timelineDomain.union);
	}

	if (controlComponentRefs.orthoTimelineRef.current) {
		controlComponentRefs.orthoTimelineRef.current.setDomain(timelineDomain.union);
	}
}

export function setCropToFilterOn(crop, draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level) {
	cropToFilterOn = crop;

	refreshToggles(draw, canvas, controlComponentRefs, moduleNavigation, dropdownRef, level);
}

export const checkAnnotationPermissions = async (
	markedPlots,
	markedQuantifiedRegions,
	clientId,
	dispatch,
	getTokenSilently,
	annotationRef,
	type,
) => {
	if (markedPlots?.length > 0 || markedQuantifiedRegions?.length > 0) {
		let accessToken = await getTokenSilently();
		dispatch(markedPlotActions.checkAnnotationPermissions(markedPlots, markedQuantifiedRegions, clientId, accessToken))
			.then((res) => {
				if (type === "add" && res.data.existingFeatures && (res.data.isCreator || res.data.isOwner)) {
					annotationRef.current.showOverwriteModal();
				} else if (res.data.isCreator) {
					annotationRef.current.passCreator();
				} else if (res.data.isOwner) {
					annotationRef.current.showOwnerModal();
				} else {
					annotationRef.current.showBlockModal();
				}
			})
			.catch((err) => {
				console.error(err);
				toast.error("Error validating annotation permissions.");
			});
	}
};
